/* eslint-disable */

const multivHTML = `<!DOCTYPE html>
<html class="no-js" lang="en">
<head>
    <title>Starbucks Secret Menu Drinks - 20 Secret Starbucks Hacks</title>
    <meta name="charset" charset="UTF-8">
    <script type="text/javascript">window.NREUM || (NREUM = {}), __nr_require = function (e, n, t) {
        function r(t) {
            if (!n[t]) {
                var o = n[t] = {exports: {}};
                e[t][0].call(o.exports, function (n) {
                    var o = e[t][1][n];
                    return r(o || n)
                }, o, o.exports)
            }
            return n[t].exports
        }

        if ("function" == typeof __nr_require)return __nr_require;
        for (var o = 0; o < t.length; o++)r(t[o]);
        return r
    }({
        1: [function (e, n, t) {
            function r() {
            }

            function o(e, n, t) {
                return function () {
                    return i(e, [c.now()].concat(u(arguments)), n ? null : this, t), n ? void 0 : this
                }
            }

            var i = e("handle"), a = e(2), u = e(3), f = e("ee").get("tracer"), c = e("loader"), s = NREUM;
            "undefined" == typeof window.newrelic && (newrelic = s);
            var p = ["setPageViewName", "setCustomAttribute", "setErrorHandler", "finished", "addToTrace", "inlineHit", "addRelease"], d = "api-", l = d + "ixn-";
            a(p, function (e, n) {
                s[n] = o(d + n, !0, "api")
            }), s.addPageAction = o(d + "addPageAction", !0), s.setCurrentRouteName = o(d + "routeName", !0), n.exports = newrelic, s.interaction = function () {
                return (new r).get()
            };
            var m = r.prototype = {
                createTracer: function (e, n) {
                    var t = {}, r = this, o = "function" == typeof n;
                    return i(l + "tracer", [c.now(), e, t], r), function () {
                        if (f.emit((o ? "" : "no-") + "fn-start", [c.now(), r, o], t), o)try {
                            return n.apply(this, arguments)
                        } finally {
                            f.emit("fn-end", [c.now()], t)
                        }
                    }
                }
            };
            a("setName,setAttribute,save,ignore,onEnd,getContext,end,get".split(","), function (e, n) {
                m[n] = o(l + n)
            }), newrelic.noticeError = function (e) {
                "string" == typeof e && (e = new Error(e)), i("err", [e, c.now()])
            }
        }, {}], 2: [function (e, n, t) {
            function r(e, n) {
                var t = [], r = "", i = 0;
                for (r in e)o.call(e, r) && (t[i] = n(r, e[r]), i += 1);
                return t
            }

            var o = Object.prototype.hasOwnProperty;
            n.exports = r
        }, {}], 3: [function (e, n, t) {
            function r(e, n, t) {
                n || (n = 0), "undefined" == typeof t && (t = e ? e.length : 0);
                for (var r = -1, o = t - n || 0, i = Array(o < 0 ? 0 : o); ++r < o;)i[r] = e[n + r];
                return i
            }

            n.exports = r
        }, {}], 4: [function (e, n, t) {
            n.exports = {exists: "undefined" != typeof window.performance && window.performance.timing && "undefined" != typeof window.performance.timing.navigationStart}
        }, {}], ee: [function (e, n, t) {
            function r() {
            }

            function o(e) {
                function n(e) {
                    return e && e instanceof r ? e : e ? f(e, u, i) : i()
                }

                function t(t, r, o, i) {
                    if (!d.aborted || i) {
                        e && e(t, r, o);
                        for (var a = n(o), u = m(t), f = u.length, c = 0; c < f; c++)u[c].apply(a, r);
                        var p = s[y[t]];
                        return p && p.push([b, t, r, a]), a
                    }
                }

                function l(e, n) {
                    v[e] = m(e).concat(n)
                }

                function m(e) {
                    return v[e] || []
                }

                function w(e) {
                    return p[e] = p[e] || o(t)
                }

                function g(e, n) {
                    c(e, function (e, t) {
                        n = n || "feature", y[t] = n, n in s || (s[n] = [])
                    })
                }

                var v = {}, y = {}, b = {
                    on: l,
                    emit: t,
                    get: w,
                    listeners: m,
                    context: n,
                    buffer: g,
                    abort: a,
                    aborted: !1
                };
                return b
            }

            function i() {
                return new r
            }

            function a() {
                (s.api || s.feature) && (d.aborted = !0, s = d.backlog = {})
            }

            var u = "nr@context", f = e("gos"), c = e(2), s = {}, p = {}, d = n.exports = o();
            d.backlog = s
        }, {}], gos: [function (e, n, t) {
            function r(e, n, t) {
                if (o.call(e, n))return e[n];
                var r = t();
                if (Object.defineProperty && Object.keys)try {
                    return Object.defineProperty(e, n, {value: r, writable: !0, enumerable: !1}), r
                } catch (i) {
                }
                return e[n] = r, r
            }

            var o = Object.prototype.hasOwnProperty;
            n.exports = r
        }, {}], handle: [function (e, n, t) {
            function r(e, n, t, r) {
                o.buffer([e], r), o.emit(e, n, t)
            }

            var o = e("ee").get("handle");
            n.exports = r, r.ee = o
        }, {}], id: [function (e, n, t) {
            function r(e) {
                var n = typeof e;
                return !e || "object" !== n && "function" !== n ? -1 : e === window ? 0 : a(e, i, function () {
                            return o++
                        })
            }

            var o = 1, i = "nr@id", a = e("gos");
            n.exports = r
        }, {}], loader: [function (e, n, t) {
            function r() {
                if (!x++) {
                    var e = h.info = NREUM.info, n = d.getElementsByTagName("script")[0];
                    if (setTimeout(s.abort, 3e4), !(e && e.licenseKey && e.applicationID && n))return s.abort();
                    c(y, function (n, t) {
                        e[n] || (e[n] = t)
                    }), f("mark", ["onload", a() + h.offset], null, "api");
                    var t = d.createElement("script");
                    t.src = "https://" + e.agent, n.parentNode.insertBefore(t, n)
                }
            }

            function o() {
                "complete" === d.readyState && i()
            }

            function i() {
                f("mark", ["domContent", a() + h.offset], null, "api")
            }

            function a() {
                return E.exists && performance.now ? Math.round(performance.now()) : (u = Math.max((new Date).getTime(), u)) - h.offset
            }

            var u = (new Date).getTime(), f = e("handle"), c = e(2), s = e("ee"), p = window, d = p.document, l = "addEventListener", m = "attachEvent", w = p.XMLHttpRequest, g = w && w.prototype;
            NREUM.o = {
                ST: setTimeout,
                CT: clearTimeout,
                XHR: w,
                REQ: p.Request,
                EV: p.Event,
                PR: p.Promise,
                MO: p.MutationObserver
            };
            var v = "" + location, y = {
                beacon: "bam.nr-data.net",
                errorBeacon: "bam.nr-data.net",
                agent: "js-agent.newrelic.com/nr-1026.min.js"
            }, b = w && g && g[l] && !/CriOS/.test(navigator.userAgent), h = n.exports = {
                offset: u,
                now: a,
                origin: v,
                features: {},
                xhrWrappable: b
            };
            e(1), d[l] ? (d[l]("DOMContentLoaded", i, !1), p[l]("load", r, !1)) : (d[m]("onreadystatechange", o), p[m]("onload", r)), f("mark", ["firstbyte", u], null, "api");
            var x = 0, E = e(4)
        }, {}]
    }, {}, ["loader"]);</script>
    <meta name="x-ua-compatible" content="IE=edge,chrome=1" http_equiv="X-UA-Compatible">
    <meta name="viewport" content="width=device-width,initial-scale=1,maximum-scale=1,user-scalable=no">
    <style id="standard-article-critical">
        @font-face {
        font-family: Sofia;
        src: url("/sites/cosmopolitan/assets/fonts/d493595c-97d2-4edc-bc9a-c09ad13b4913.woff?cb=1494434860978") format("woff")
    }

    @font-face {
        font-family: Sofia;
        src: url("/sites/cosmopolitan/assets/fonts/ec41d681-0313-4b04-88c0-820aebb51f4e.woff?cb=1494434860978") format("woff");
        font-weight: 700
    }

    @font-face {
        font-family: TriviaSerif;
        src: url("/sites/cosmopolitan/assets/fonts/333615_0_0.woff?cb=1494434860978") format("woff")
    }

    @font-face {
        font-family: TriviaSerif;
        src: url("/sites/cosmopolitan/assets/fonts/333615_2_0.woff?cb=1494434860978") format("woff");
        font-weight: 700
    }

    .clearfix::after, .top-pathing-inner::after, .content-info-inner::after {
        content: " ";
        display: table;
        clear: both
    }

    .nav-bar-container, .top-pathing-inner, .content-header-inner, .content-info-inner {
        padding-left: .938rem;
        padding-right: .938rem
    }

    @media (min-width: 40.625rem) {
        .nav-bar-container, .top-pathing-inner, .content-header-inner, .content-info-inner {
            padding-left: 2.5rem;
            padding-right: 2.5rem
        }
    }

    .nav-bar-container, .top-pathing-inner, .content-header-inner {
        max-width: 75rem;
        margin: 0 auto
    }

    .slideshow-leaderboard, .top-pathing-inner, .content-info {
        -webkit-transform: translate(-.938rem, 0);
        transform: translate(-.938rem, 0);
        width: calc(100% + (.938rem * 2))
    }

    @media only screen and (min-width: 40.625rem) {
        .slideshow-leaderboard, .top-pathing-inner, .content-info {
            -webkit-transform: none;
            transform: none;
            width: auto
        }
    }

    .list-vertical-ad, .transporter-vertical-ad, .list-breaker-ad, .standard-article-breaker-ad, .listicle-slide-list-ad, .listicle-breaker-ad, .slideshow-list-ad {
        width: 100vw;
        margin-left: -.938rem
    }

    @media only screen and (min-width: 40.625rem) {
        .list-vertical-ad, .transporter-vertical-ad, .list-breaker-ad, .standard-article-breaker-ad, .listicle-slide-list-ad, .listicle-breaker-ad, .slideshow-list-ad {
            -webkit-transform: translate(-2.5rem, 0);
            transform: translate(-2.5rem, 0);
            width: calc(100% + (2.5rem * 2));
            margin-left: inherit
        }
    }

    @media only screen and (min-width: 61.25rem) {
        .list-vertical-ad, .transporter-vertical-ad, .list-breaker-ad, .standard-article-breaker-ad, .listicle-slide-list-ad, .listicle-breaker-ad, .slideshow-list-ad {
            -webkit-transform: none;
            transform: none;
            width: auto
        }
    }

    @media only screen and (min-width: 40.625rem) {
        .slideshow-leaderboard, .top-pathing-inner, .content-info {
            -webkit-transform: translate(-2.5rem, 0);
            transform: translate(-2.5rem, 0);
            width: calc(100% + (2.5rem * 2))
        }
    }

    @media only screen and (min-width: 61.25rem) {
        .slideshow-leaderboard, .top-pathing-inner, .content-info {
            -webkit-transform: none;
            transform: none;
            width: auto
        }
    }

    .sponsor-bar {
        -webkit-transform: translate(-.938rem, 0);
        transform: translate(-.938rem, 0);
        width: calc(100% + (.938rem * 2));
        clear: both
    }

    @media only screen and (min-width: 40.625rem) {
        .sponsor-bar {
            -webkit-transform: none;
            transform: none;
            width: 100vw;
            position: relative;
            left: calc(-50vw + 50%)
        }
    }

    .aspect-ratio-8x1 {
        position: relative
    }

    .aspect-ratio-8x1:before {
        content: "";
        display: block;
        width: 100%;
        padding-bottom: 12.5%
    }

    .aspect-ratio-8x1 > * {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%
    }

    .aspect-ratio-5x1 {
        position: relative
    }

    .aspect-ratio-5x1:before {
        content: "";
        display: block;
        width: 100%;
        padding-bottom: 20%
    }

    .aspect-ratio-5x1 > * {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%
    }

    .aspect-ratio-8x10 {
        position: relative
    }

    .aspect-ratio-8x10:before {
        content: "";
        display: block;
        width: 100%;
        padding-bottom: 125%
    }

    .aspect-ratio-8x10 > * {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%
    }

    .aspect-ratio-16x9, .content-lede-video, .content-lede-loop .desktop-only-video {
        position: relative
    }

    .aspect-ratio-16x9:before, .content-lede-video:before, .content-lede-loop .desktop-only-video:before {
        content: "";
        display: block;
        width: 100%;
        padding-bottom: 56.25%
    }

    .aspect-ratio-16x9 > *, .content-lede-video > *, .content-lede-loop .desktop-only-video > * {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%
    }

    .aspect-ratio-3x1 {
        position: relative
    }

    .aspect-ratio-3x1:before {
        content: "";
        display: block;
        width: 100%;
        padding-bottom: 33.3333333333%
    }

    .aspect-ratio-3x1 > * {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%
    }

    .aspect-ratio-1x1 {
        position: relative
    }

    .aspect-ratio-1x1:before {
        content: "";
        display: block;
        width: 100%;
        padding-bottom: 100%
    }

    .aspect-ratio-1x1 > * {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%
    }

    .aspect-ratio-6x4 {
        position: relative
    }

    .aspect-ratio-6x4:before {
        content: "";
        display: block;
        width: 100%;
        padding-bottom: 66.6666666667%
    }

    .aspect-ratio-6x4 > * {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%
    }

    .aspect-ratio-2x1, .item-image, .content-lede-image-wrap, .content-lede-loop .desktop-only-video-fallback {
        position: relative
    }

    .aspect-ratio-2x1:before, .item-image:before, .content-lede-image-wrap:before, .content-lede-loop .desktop-only-video-fallback:before {
        content: "";
        display: block;
        width: 100%;
        padding-bottom: 50%
    }

    .aspect-ratio-2x1 > *, .item-image > *, .content-lede-image-wrap > *, .content-lede-loop .desktop-only-video-fallback > * {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%
    }

    .aspect-ratio-4x6 {
        position: relative
    }

    .aspect-ratio-4x6:before {
        content: "";
        display: block;
        width: 100%;
        padding-bottom: 150%
    }

    .aspect-ratio-4x6 > * {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%
    }

    .aspect-ratio-4x3 {
        position: relative
    }

    .aspect-ratio-4x3:before {
        content: "";
        display: block;
        width: 100%;
        padding-bottom: 75%
    }

    .aspect-ratio-4x3 > * {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%
    }

    .nav-menu, .nav-submenu, .nav-menu .nav-menu-item, .nav-submenu .nav-menu-item, .search-overlay {
        transition: opacity .3s ease-in-out;
        width: 0;
        height: 0;
        opacity: 0;
        overflow: hidden
    }

    .active.nav-menu, .active.nav-submenu, .nav-menu .active.nav-menu-item, .nav-submenu .active.nav-menu-item, .active.search-overlay {
        width: auto;
        height: auto;
        overflow: inherit;
        opacity: 1
    }

    .nav-menu, .nav-submenu, .sidepanel-menu, .sidepanel-submenu {
        list-style-type: none
    }

    .link {
        text-decoration: none;
        cursor: pointer
    }

    .link-button {
        outline: none;
        border: none
    }

    .icon, .sidepanel-back-button:before {
        line-height: inherit
    }

    body {
        position: relative;
        font-kerning: normal
    }

    img {
        max-width: 100%
    }

    ul {
        list-style-position: inside;
        list-style-type: disc
    }

    ol {
        list-style-position: outside;
        list-style-type: decimal
    }

    strong, b {
        font-weight: 600
    }

    em, i, q {
        font-style: italic
    }

    /*! normalize.css v3.0.2 | MIT License | git.io/normalize */
    html {
        font-family: sans-serif;
        -ms-text-size-adjust: 100%;
        -webkit-font-smoothing: antialiased;
        -webkit-text-size-adjust: 100%
    }

    body {
        margin: 0
    }

    * {
        box-sizing: border-box
    }

    article, aside, details, figcaption, figure, footer, header, hgroup, main, menu, nav, section, summary {
        display: block
    }

    audio, canvas, progress, video {
        display: inline-block;
        vertical-align: baseline
    }

    audio:not([controls]) {
        display: none;
        height: 0
    }

    [hidden], template {
        display: none
    }

    a {
        background-color: transparent
    }

    a:active, a:hover {
        outline: 0
    }

    abbr[title] {
        border-bottom: 1px dotted
    }

    b, strong {
        font-weight: 700
    }

    dfn {
        font-style: italic
    }

    h1 {
        font-size: 2em;
        margin: 0
    }

    h2 {
        margin: 0
    }

    mark {
        background: #ff0;
        color: #000
    }

    small {
        font-size: 80%
    }

    sub, sup {
        font-size: 75%;
        line-height: 0;
        position: relative;
        vertical-align: baseline
    }

    sup {
        top: -.5em
    }

    sub {
        bottom: -.25em
    }

    img {
        border: 0
    }

    svg:not(:root) {
        overflow: hidden
    }

    figure {
        margin: 1em 40px
    }

    hr {
        box-sizing: content-box;
        height: 0
    }

    pre {
        overflow: auto
    }

    code, kbd, pre, samp {
        font-family: monospace, monospace;
        font-size: 1em
    }

    button, input, optgroup, select, textarea {
        color: inherit;
        font: inherit;
        margin: 0
    }

    button {
        overflow: visible
    }

    button, select {
        text-transform: none
    }

    button, html input[type=button], input[type=reset], input[type=submit] {
        -webkit-appearance: button;
        cursor: pointer
    }

    button[disabled], html input[disabled] {
        cursor: default
    }

    button::-moz-focus-inner, input::-moz-focus-inner {
        border: 0;
        padding: 0
    }

    input {
        line-height: normal
    }

    input[type=checkbox], input[type=radio] {
        box-sizing: border-box;
        padding: 0
    }

    input[type=number]::-webkit-inner-spin-button, input[type=number]::-webkit-outer-spin-button {
        height: auto
    }

    input[type=search] {
        -webkit-appearance: textfield;
        box-sizing: content-box
    }

    input[type=search]::-webkit-search-cancel-button, input[type=search]::-webkit-search-decoration {
        -webkit-appearance: none
    }

    fieldset {
        border: 1px solid silver;
        margin: 0 2px;
        padding: .35em .625em .75em
    }

    legend {
        border: 0;
        padding: 0
    }

    textarea {
        overflow: auto
    }

    optgroup {
        font-weight: 700
    }

    table {
        border-collapse: collapse;
        border-spacing: 0
    }

    td, th {
        padding: 0
    }

    @-webkit-keyframes dropdown-menu-hide {
        0% {
            visibility: visible;
            opacity: 1
        }
        1% {
            z-index: -1
        }
        30% {
            visibility: visible;
            opacity: 1
        }
        100% {
            z-index: -1;
            -webkit-transform: translateY(-100%);
            transform: translateY(-100%)
        }
    }

    @keyframes dropdown-menu-hide {
        0% {
            visibility: visible;
            opacity: 1
        }
        1% {
            z-index: -1
        }
        30% {
            visibility: visible;
            opacity: 1
        }
        100% {
            z-index: -1;
            -webkit-transform: translateY(-100%);
            transform: translateY(-100%)
        }
    }

    @-webkit-keyframes dropdown-menu-show {
        0% {
            z-index: -1;
            -webkit-transform: translateY(-100%);
            transform: translateY(-100%)
        }
        99% {
            z-index: -1
        }
        100% {
            z-index: 9999999;
            -webkit-transform: translateY(0);
            transform: translateY(0)
        }
    }

    @keyframes dropdown-menu-show {
        0% {
            z-index: -1;
            -webkit-transform: translateY(-100%);
            transform: translateY(-100%)
        }
        99% {
            z-index: -1
        }
        100% {
            z-index: 9999999;
            -webkit-transform: translateY(0);
            transform: translateY(0)
        }
    }

    @-webkit-keyframes input-add-button {
        0% {
            visibility: hidden;
            display: none;
            -webkit-transform: scale(.95);
            transform: scale(.95);
            opacity: 0
        }
        100% {
            top: 0;
            visibility: visible;
            display: block;
            -webkit-transform: scale(1);
            transform: scale(1);
            opacity: 1
        }
    }

    @keyframes input-add-button {
        0% {
            visibility: hidden;
            display: none;
            -webkit-transform: scale(.95);
            transform: scale(.95);
            opacity: 0
        }
        100% {
            top: 0;
            visibility: visible;
            display: block;
            -webkit-transform: scale(1);
            transform: scale(1);
            opacity: 1
        }
    }

    @-webkit-keyframes input-hide {
        0% {
            -webkit-transform: scale(1);
            transform: scale(1);
            opacity: 1;
            display: block
        }
        20% {
            -webkit-transform: scale(1.01);
            transform: scale(1.01)
        }
        100% {
            -webkit-transform: scale(.87);
            transform: scale(.87);
            opacity: 0;
            display: none
        }
    }

    @keyframes input-hide {
        0% {
            -webkit-transform: scale(1);
            transform: scale(1);
            opacity: 1;
            display: block
        }
        20% {
            -webkit-transform: scale(1.01);
            transform: scale(1.01)
        }
        100% {
            -webkit-transform: scale(.87);
            transform: scale(.87);
            opacity: 0;
            display: none
        }
    }

    @-webkit-keyframes input-show {
        0% {
            -webkit-transform: scale(.98);
            transform: scale(.98);
            opacity: 0
        }
        95% {
            -webkit-transform: scale(1.004);
            transform: scale(1.004)
        }
        100% {
            -webkit-transform: scale(1);
            transform: scale(1);
            opacity: 1
        }
    }

    @keyframes input-show {
        0% {
            -webkit-transform: scale(.98);
            transform: scale(.98);
            opacity: 0
        }
        95% {
            -webkit-transform: scale(1.004);
            transform: scale(1.004)
        }
        100% {
            -webkit-transform: scale(1);
            transform: scale(1);
            opacity: 1
        }
    }

    @-webkit-keyframes modal {
        0% {
            top: 55%
        }
        100% {
            top: 50%
        }
    }

    @keyframes modal {
        0% {
            top: 55%
        }
        100% {
            top: 50%
        }
    }

    @-webkit-keyframes tabbed-modal {
        0% {
            opacity: 0;
            -webkit-transform: scale(.97);
            transform: scale(.97)
        }
        100% {
            opacity: 1;
            -webkit-transform: scale(1);
            transform: scale(1)
        }
    }

    @keyframes tabbed-modal {
        0% {
            opacity: 0;
            -webkit-transform: scale(.97);
            transform: scale(.97)
        }
        100% {
            opacity: 1;
            -webkit-transform: scale(1);
            transform: scale(1)
        }
    }

    @-webkit-keyframes rotate {
        0% {
            -webkit-transform: rotate(0deg);
            transform: rotate(0deg)
        }
        100% {
            -webkit-transform: rotate(360deg);
            transform: rotate(360deg)
        }
    }

    @keyframes rotate {
        0% {
            -webkit-transform: rotate(0deg);
            transform: rotate(0deg)
        }
        100% {
            -webkit-transform: rotate(360deg);
            transform: rotate(360deg)
        }
    }

    @-webkit-keyframes animation-hue-rotate {
        0% {
            -webkit-filter: hue-rotate(0deg);
            filter: hue-rotate(0deg)
        }
        100% {
            -webkit-filter: hue-rotate(-100deg);
            filter: hue-rotate(-100deg)
        }
    }

    @keyframes animation-hue-rotate {
        0% {
            -webkit-filter: hue-rotate(0deg);
            filter: hue-rotate(0deg)
        }
        100% {
            -webkit-filter: hue-rotate(-100deg);
            filter: hue-rotate(-100deg)
        }
    }

    @-webkit-keyframes shine {
        100% {
            left: 125%
        }
    }

    @keyframes shine {
        100% {
            left: 125%
        }
    }

    .grid-guide {
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        position: fixed;
        z-index: 5999997
    }

    .grid-guide-vert-inner {
        max-width: 75rem;
        margin: 0 auto;
        height: 100%;
        padding: 0 .938rem
    }

    @media only screen and (min-width: 40.625rem) {
        .grid-guide-vert-inner {
            padding: 0 2.5rem
        }
    }

    .grid-guide-col {
        float: left;
        margin-right: 2%;
        width: 2.25%;
        background: rgba(100, 100, 225, .25);
        height: 100%
    }

    .grid-guide-col:last-child {
        margin: 0
    }

    .grid-guide-row {
        background: rgba(100, 100, 225, .25)
    }

    html {
        font-family: breakpoint-0
    }

    @media only screen and (min-width: 17.5rem) {
        html {
            font-family: breakpoint-280
        }
    }

    @media only screen and (min-width: 20rem) {
        html {
            font-family: breakpoint-320
        }
    }

    @media only screen and (min-width: 25rem) {
        html {
            font-family: breakpoint-400
        }
    }

    @media only screen and (min-width: 28.125rem) {
        html {
            font-family: breakpoint-450
        }
    }

    @media only screen and (min-width: 30rem) {
        html {
            font-family: breakpoint-480
        }
    }

    @media only screen and (min-width: 31.25rem) {
        html {
            font-family: breakpoint-500
        }
    }

    @media only screen and (min-width: 34.375rem) {
        html {
            font-family: breakpoint-550
        }
    }

    @media only screen and (min-width: 37.5rem) {
        html {
            font-family: breakpoint-600
        }
    }

    @media only screen and (min-width: 40.625rem) {
        html {
            font-family: breakpoint-650
        }
    }

    @media only screen and (min-width: 43.75rem) {
        html {
            font-family: breakpoint-700
        }
    }

    @media only screen and (min-width: 48rem) {
        html {
            font-family: breakpoint-768
        }
    }

    @media only screen and (min-width: 50rem) {
        html {
            font-family: breakpoint-800
        }
    }

    @media only screen and (min-width: 61.25rem) {
        html {
            font-family: breakpoint-980
        }
    }

    @media only screen and (min-width: 62.5rem) {
        html {
            font-family: breakpoint-1000
        }
    }

    @media only screen and (min-width: 64rem) {
        html {
            font-family: breakpoint-1024
        }
    }

    @media only screen and (min-width: 73.75rem) {
        html {
            font-family: breakpoint-1180
        }
    }

    @media only screen and (min-width: 75rem) {
        html {
            font-family: breakpoint-1200
        }
    }

    @media only screen and (min-width: 100rem) {
        html {
            font-family: breakpoint-1600
        }
    }

    head {
        font-family: '{"mobile":320,"mobile-wide":480,"tablet":650,"tablet-wide":768,"desktop":980,"desktop-wide":1180,"desktop-max":1200,"desktop-extra-wide":1600}'
    }

    body {
        font-family: Helvetica, Arial, Sans-serif;
        font-size: 1rem;
        line-height: 1.2;
        color: #000
    }

    .nav-button, .nav-secondary-menu .nav-menu-item a, .nav-secondary-menu .nav-menu-item .nav-menu-link, .sidepanel-back-button, .sidepanel-close-button, .search-overlay-close-button, .search-overlay-autosuggest-list a, .simple-item-parent-link, .top-pathing-item .item-title {
        transition: color .3s ease-in-out;
        text-decoration: none
    }

    @media only screen and (min-width: 61.25rem) {
        .nav-button:hover, .nav-secondary-menu .nav-menu-item a:hover, .nav-secondary-menu .nav-menu-item .nav-menu-link:hover, .sidepanel-back-button:hover, .sidepanel-close-button:hover, .search-overlay-close-button:hover, .search-overlay-autosuggest-list a:hover, .simple-item-parent-link:hover, .top-pathing-item .item-title:hover {
            color: #fff
        }
    }

    body {
        background: #fff
    }

    body {
        font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
        font-size: 1.0625rem;
        line-height: 1.8;
        color: #000;
        letter-spacing: .02em;
        -webkit-font-smoothing: antialiased
    }

    .search-overlay-form .search-input, .search-overlay-form .search-input::-webkit-input-placeholder, .content-hed {
        font-family: TriviaSerif, Georgia, Times, Serif;
        font-size: 1.875rem;
        line-height: 1.1;
        color: #000;
        letter-spacing: -.03rem;
        font-weight: 400
    }

    .search-overlay-form .search-input, .search-overlay-form .search-input:-ms-input-placeholder, .content-hed {
        font-family: TriviaSerif, Georgia, Times, Serif;
        font-size: 1.875rem;
        line-height: 1.1;
        color: #000;
        letter-spacing: -.03rem;
        font-weight: 400
    }

    .search-overlay-form .search-input, .search-overlay-form .search-input::placeholder, .content-hed {
        font-family: TriviaSerif, Georgia, Times, Serif;
        font-size: 1.875rem;
        line-height: 1.1;
        color: #000;
        letter-spacing: -.03rem;
        font-weight: 400
    }

    @media only screen and (min-width: 30rem) {
        .search-overlay-form .search-input, .search-overlay-form .search-input::-webkit-input-placeholder, .content-hed {
            font-size: 2.5rem;
            line-height: 1.1
        }

        .search-overlay-form .search-input, .search-overlay-form .search-input:-ms-input-placeholder, .content-hed {
            font-size: 2.5rem;
            line-height: 1.1
        }

        .search-overlay-form .search-input, .search-overlay-form .search-input::placeholder, .content-hed {
            font-size: 2.5rem;
            line-height: 1.1
        }
    }

    @media only screen and (min-width: 40.625rem) {
        .search-overlay-form .search-input, .search-overlay-form .search-input::-webkit-input-placeholder, .content-hed {
            font-size: 3rem;
            line-height: 1
        }

        .search-overlay-form .search-input, .search-overlay-form .search-input:-ms-input-placeholder, .content-hed {
            font-size: 3rem;
            line-height: 1
        }

        .search-overlay-form .search-input, .search-overlay-form .search-input::placeholder, .content-hed {
            font-size: 3rem;
            line-height: 1
        }
    }

    @media only screen and (min-width: 61.25rem) {
        .search-overlay-form .search-input, .search-overlay-form .search-input::-webkit-input-placeholder, .content-hed {
            font-size: 3.5rem;
            line-height: 1.1
        }

        .search-overlay-form .search-input, .search-overlay-form .search-input:-ms-input-placeholder, .content-hed {
            font-size: 3.5rem;
            line-height: 1.1
        }

        .search-overlay-form .search-input, .search-overlay-form .search-input::placeholder, .content-hed {
            font-size: 3.5rem;
            line-height: 1.1
        }
    }

    .nav-button, .nav-secondary-menu .nav-menu-item a, .nav-secondary-menu .nav-menu-item .nav-menu-link, .sidepanel-back-button, .sidepanel-close-button, .search-overlay-close-button, .search-overlay-autosuggest-list a, .simple-item-parent-link, .top-pathing-item .item-title {
        text-decoration: none;
        transition: color .3s ease-in-out
    }

    @media only screen and (min-width: 61.25rem) {
        .nav-button:hover, .nav-secondary-menu .nav-menu-item a:hover, .nav-secondary-menu .nav-menu-item .nav-menu-link:hover, .sidepanel-back-button:hover, .sidepanel-close-button:hover, .search-overlay-close-button:hover, .search-overlay-autosuggest-list a:hover, .simple-item-parent-link:hover, .top-pathing-item .item-title:hover {
            color: #e9328c
        }
    }

    .content-dek a, .content-info-byline a.byline-name, .image-credit a, .slide-image-credit a, .standard-lede-image .content-lede-image-credit a, .listicle-lede-image .content-lede-image-credit a {
        transition: color .3s ease-in-out;
        color: #676767;
        text-decoration: underline
    }

    @media only screen and (min-width: 61.25rem) {
        .content-dek a:hover, .content-info-byline a.byline-name:hover, .image-credit a:hover, .slide-image-credit a:hover, .standard-lede-image .content-lede-image-credit a:hover, .listicle-lede-image .content-lede-image-credit a:hover {
            color: #000
        }
    }

    .content-info-date, .content-info-aggregate-count .aggregate-count-number {
        font-family: Sofia, Helvetica, Arial, Sans-serif;
        font-size: .875rem;
        line-height: 1.4;
        color: #000
    }

    .simple-item-metadata {
        font-family: Sofia, Helvetica, Arial, Sans-serif;
        font-size: .75rem;
        line-height: 1;
        color: #000
    }

    .byline {
        font-family: Sofia, Helvetica, Arial, Sans-serif;
        font-size: .875rem;
        line-height: 1.4;
        color: #676767
    }

    .byline-name {
        color: #676767;
        text-transform: capitalize
    }

    hr {
        width: 12.5%;
        border-top: .1875rem solid #000;
        border-right: 0;
        border-left: 0;
        border-bottom: 0;
        padding: .9375rem 0 .3125rem
    }

    @media only screen and (min-width: 61.25rem) {
        .simple-item-image, .top-pathing-item .item-image {
            position: relative
        }

        .simple-item-image:after, .top-pathing-item .item-image:after {
            background-image: linear-gradient(to right, transparent, rgba(255, 255, 255, .2));
            position: absolute;
            top: 0;
            left: -75%;
            z-index: 2;
            display: block;
            content: "";
            width: 50%;
            height: 100%;
            -webkit-transform: skewX(-25deg);
            transform: skewX(-25deg)
        }

        .simple-item-image:hover:after, .top-pathing-item .item-image:hover:after {
            -webkit-animation: shine .95s;
            animation: shine .95s
        }
    }

    .item-image {
        background-color: #f3f3f3
    }

    .top-pathing-item {
        display: none;
        float: left;
        width: 50%
    }

    .top-pathing-item:nth-child(-n+2) {
        display: block
    }

    .top-pathing-item .item-title {
        padding: 0 .938rem;
        display: block
    }

    .top-pathing-item .item-image {
        margin-bottom: .625rem
    }

    @media only screen and (min-width: 40.625rem) {
        .top-pathing-item {
            width: 33.3333333333%
        }

        .top-pathing-item:nth-child(-n+3) {
            display: block
        }
    }

    @media only screen and (min-width: 61.25rem) {
        .top-pathing-item:nth-child(-n+5) {
            width: 20%;
            display: block
        }
    }

    .content-info-social-button .social-button-link, .content-lede-image-social-button .social-button-link {
        display: block;
        width: 100%;
        text-align: center;
        text-decoration: none
    }

    .content-info-social-button .social-button-icon, .content-lede-image-social-button .social-button-icon {
        font-size: 1.063rem
    }

    .content-info-social-button .social-button-link, .content-lede-image-social-button .social-button-link {
        color: #fff
    }

    .social-button-facebook.content-info-social-button, .social-button-facebook.content-lede-image-social-button {
        background-color: #3b5998
    }

    .social-button-pinterest.content-info-social-button, .social-button-pinterest.content-lede-image-social-button {
        background-color: #c92228
    }

    .social-button-twitter.content-info-social-button, .social-button-twitter.content-lede-image-social-button {
        background-color: #00aced
    }

    .social-button-googleplus.content-info-social-button, .social-button-googleplus.content-lede-image-social-button {
        background-color: #dd4b39
    }

    .social-button-youtube.content-info-social-button, .social-button-youtube.content-lede-image-social-button {
        background-color: #b00
    }

    .social-button-email.content-info-social-button, .social-button-email.content-lede-image-social-button {
        background-color: #333
    }

    .social-button-instagram.content-info-social-button, .social-button-instagram.content-lede-image-social-button {
        background-color: #517fa4
    }

    .social-button-tumblr.content-info-social-button, .social-button-tumblr.content-lede-image-social-button {
        background-color: #35465c
    }

    .social-button-reddit.content-info-social-button, .social-button-reddit.content-lede-image-social-button {
        background-color: #ff4500
    }

    .social-button-whatsapp.content-info-social-button, .social-button-whatsapp.content-lede-image-social-button {
        background-color: #5cbe4a
    }

    .social-button-line.content-info-social-button, .social-button-line.content-lede-image-social-button {
        background-color: #00c300
    }

    .longform-social-buttons .social-button-facebook.content-info-social-button {
        border: .0625rem solid #ececec;
        background: transparent
    }

    .longform-social-buttons .social-button-facebook.content-info-social-button .social-button-link {
        color: #3b5998
    }

    .longform-social-buttons .social-button-pinterest.content-info-social-button {
        border: .0625rem solid #ececec;
        background: transparent
    }

    .longform-social-buttons .social-button-pinterest.content-info-social-button .social-button-link {
        color: #c92228
    }

    .longform-social-buttons .social-button-twitter.content-info-social-button {
        border: .0625rem solid #ececec;
        background: transparent
    }

    .longform-social-buttons .social-button-twitter.content-info-social-button .social-button-link {
        color: #00aced
    }

    .longform-social-buttons .social-button-googleplus.content-info-social-button {
        border: .0625rem solid #ececec;
        background: transparent
    }

    .longform-social-buttons .social-button-googleplus.content-info-social-button .social-button-link {
        color: #dd4b39
    }

    .longform-social-buttons .social-button-youtube.content-info-social-button {
        border: .0625rem solid #ececec;
        background: transparent
    }

    .longform-social-buttons .social-button-youtube.content-info-social-button .social-button-link {
        color: #b00
    }

    .longform-social-buttons .social-button-email.content-info-social-button {
        border: .0625rem solid #ececec;
        background: transparent
    }

    .longform-social-buttons .social-button-email.content-info-social-button .social-button-link {
        color: #333
    }

    .longform-social-buttons .social-button-instagram.content-info-social-button {
        border: .0625rem solid #ececec;
        background: transparent
    }

    .longform-social-buttons .social-button-instagram.content-info-social-button .social-button-link {
        color: #517fa4
    }

    .longform-social-buttons .social-button-tumblr.content-info-social-button {
        border: .0625rem solid #ececec;
        background: transparent
    }

    .longform-social-buttons .social-button-tumblr.content-info-social-button .social-button-link {
        color: #35465c
    }

    .longform-social-buttons .social-button-reddit.content-info-social-button {
        border: .0625rem solid #ececec;
        background: transparent
    }

    .longform-social-buttons .social-button-reddit.content-info-social-button .social-button-link {
        color: #ff4500
    }

    .longform-social-buttons .social-button-whatsapp.content-info-social-button {
        border: .0625rem solid #ececec;
        background: transparent
    }

    .longform-social-buttons .social-button-whatsapp.content-info-social-button .social-button-link {
        color: #5cbe4a
    }

    .longform-social-buttons .social-button-line.content-info-social-button {
        border: .0625rem solid #ececec;
        background: transparent
    }

    .longform-social-buttons .social-button-line.content-info-social-button .social-button-link {
        color: #00c300
    }

    .content-info-social-button {
        position: relative
    }

    .content-info-social-button [class^=PIN_] {
        position: absolute;
        width: 100%;
        height: 100%;
        opacity: 0
    }

    .content-info-social-button-group {
        display: -webkit-flex;
        display: -ms-flexbox;
        display: flex;
        -webkit-flex-direction: row;
        -ms-flex-direction: row;
        flex-direction: row;
        -webkit-align-items: center;
        -ms-flex-align: center;
        align-items: center
    }

    .content-info-social-button-group .social-button {
        -webkit-flex-grow: 1;
        -ms-flex-positive: 1;
        flex-grow: 1
    }

    body {
        overflow-x: hidden
    }

    body.no-scroll {
        overflow: hidden
    }

    .site-content {
        overflow-x: hidden
    }

    img.lazyload, picture.lazyload {
        opacity: 0;
        transition: opacity .3s linear
    }

    img.lazyloaded, picture.lazyloaded {
        opacity: 1
    }

    iframe {
        max-width: 100%
    }

    @font-face {
        font-family: IconFont;
        src: url("/sites/cosmopolitan/assets/fonts/IconFont.woff2?cb=1494434860978") format("woff2"), url("/sites/cosmopolitan/assets/fonts/IconFont.woff?cb=1494434860978") format("woff")
    }

    .icon, .sidepanel-back-button:before {
        font-family: IconFont;
        display: inline-block;
        vertical-align: middle;
        line-height: 1;
        font-weight: 400;
        font-style: normal;
        speak: none;
        text-decoration: inherit;
        text-transform: none;
        text-rendering: auto;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale
    }

    .icon-author:before {
        content: "\f101"
    }

    .icon-expand-arrows:before {
        content: "\f102"
    }

    .icon-gallery:before {
        content: "\f103"
    }

    .icon-grid-view:before {
        content: "\f104"
    }

    .icon-heart:before {
        content: "\f105"
    }

    .icon-magnify:before {
        content: "\f106"
    }

    .icon-menu:before {
        content: "\f107"
    }

    .icon-play:before {
        content: "\f108"
    }

    .icon-search:before {
        content: "\f109"
    }

    .icon-rating-empty:before {
        content: "\f10a"
    }

    .icon-rating-half:before {
        content: "\f10b"
    }

    .icon-rating:before {
        content: "\f10c"
    }

    .icon-arrow-down01:before {
        content: "\f10d"
    }

    .icon-arrow-down02:before {
        content: "\f10e"
    }

    .icon-arrow-left01:before, .sidepanel-back-button:before {
        content: "\f10f"
    }

    .icon-arrow-left02:before {
        content: "\f110"
    }

    .icon-arrow-right01:before {
        content: "\f111"
    }

    .icon-arrow-right02:before {
        content: "\f112"
    }

    .icon-arrow-up01:before {
        content: "\f113"
    }

    .icon-article:before {
        content: "\f114"
    }

    .icon-audio:before {
        content: "\f115"
    }

    .icon-avatar:before {
        content: "\f116"
    }

    .icon-clock:before {
        content: "\f117"
    }

    .icon-close01:before {
        content: "\f118"
    }

    .icon-collection:before {
        content: "\f119"
    }

    .icon-comments:before {
        content: "\f11a"
    }

    .icon-comments02:before {
        content: "\f11b"
    }

    .icon-email:before {
        content: "\f11c"
    }

    .icon-facebook:before {
        content: "\f11d"
    }

    .icon-googleplus:before {
        content: "\f11e"
    }

    .icon-info:before {
        content: "\f11f"
    }

    .icon-instagram:before {
        content: "\f120"
    }

    .icon-lightbulb:before {
        content: "\f121"
    }

    .icon-link-out-arrow:before {
        content: "\f122"
    }

    .icon-linked-in:before {
        content: "\f123"
    }

    .icon-list:before {
        content: "\f124"
    }

    .icon-loader:before {
        content: "\f125"
    }

    .icon-logo01:before {
        content: "\f126"
    }

    .icon-logo02:before {
        content: "\f127"
    }

    .icon-minus:before {
        content: "\f128"
    }

    .icon-pinterest:before {
        content: "\f129"
    }

    .icon-play-vid:before {
        content: "\f12a"
    }

    .icon-plus:before {
        content: "\f12b"
    }

    .icon-quiz:before {
        content: "\f12c"
    }

    .icon-quote:before {
        content: "\f12d"
    }

    .icon-reddit:before {
        content: "\f12e"
    }

    .icon-share:before {
        content: "\f12f"
    }

    .icon-share02:before {
        content: "\f130"
    }

    .icon-sign-out:before {
        content: "\f131"
    }

    .icon-tumblr:before {
        content: "\f132"
    }

    .icon-twitter:before {
        content: "\f133"
    }

    .icon-youtube:before {
        content: "\f134"
    }

    .icon-circle-plus:before {
        content: "\f135"
    }

    .icon-feature:before {
        content: "\f136"
    }

    .icon-recipe:before {
        content: "\f137"
    }

    .icon-whatsapp:before {
        content: "\f138"
    }

    img.click-to-play-animated, picture.click-to-play-animated {
        display: none !important;
        position: absolute;
        top: 0
    }

    img.click-to-play-animated, .crop-original img.click-to-play-animated, picture.click-to-play-animated, .crop-original picture.click-to-play-animated {
        width: 100%
    }

    img.click-to-play-animated.active, picture.click-to-play-animated.active {
        display: block !important
    }

    .click-to-play-button {
        position: absolute;
        left: 50%;
        top: 50%;
        -webkit-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        border: 0;
        border-radius: 50%;
        content: "";
        display: block;
        height: 4.375rem;
        outline: none;
        padding: 0;
        width: 4.375rem
    }

    .click-to-play-animated.active + .click-to-play-button {
        display: none
    }

    .click-to-play-button .icon, .click-to-play-button .sidepanel-back-button:before {
        font-size: 1.875rem;
        line-height: 4.375rem
    }

    .item-image .click-to-play-button {
        display: none
    }

    .click-to-play-button {
        background-color: rgba(243, 243, 243, .4)
    }

    .click-to-play-button .icon, .click-to-play-button .sidepanel-back-button:before {
        color: #000;
        padding-left: .4rem
    }

    .sponsor-nav-inner.brand-logo .nav-sponsor-image img {
        max-height: 2.5rem;
        max-width: 14rem
    }

    .sponsor-nav-inner.sponsored-by .nav-sponsor-image img, .sponsor-nav-inner.provided-by .nav-sponsor-image img, .sponsor-nav-inner.created-for .nav-sponsor-image img, .sponsor-nav-inner.custom-label .nav-sponsor-image img {
        max-height: 2.5rem;
        max-width: 7.4rem
    }

    .nav-menu, .nav-submenu {
        margin: 0;
        padding: 0;
        line-height: 0
    }

    @media screen and (min-width: 0\0
    ) {
        .active.nav-menu, .active.nav-submenu, .nav-menu .nav-menu-item.active, .nav-submenu .nav-menu-item.active {
            -webkit-flex: 0 0 auto;
            -ms-flex: 0 0 auto;
            flex: 0 0 auto
        }
    }

    .nav-menu, .nav-submenu, .nav-bar-container, .nav-swipeable-inner {
        height: 3.375rem;
        display: -webkit-flex;
        display: -ms-flexbox;
        display: flex;
        -webkit-align-items: center;
        -ms-flex-align: center;
        align-items: center
    }

    .nav {
        transition: -webkit-transform .3s ease-in-out;
        transition: transform .3s ease-in-out;
        z-index: 5999997
    }

    .marquee + .nav, .sponsored-marquee + .nav {
        padding-bottom: 0
    }

    @media only screen and (min-width: 61.25rem) {
        .nav {
            position: relative
        }

        .nav.sticky {
            transition: none;
            position: fixed;
            max-width: 100%;
            left: 0;
            right: 0;
            top: 0;
            margin: 0 auto;
            z-index: 5999997
        }

        .nav.sticky + .nav-placeholder {
            position: static
        }

        .nav.sticky.unsticky {
            position: relative
        }

        .nav.sticky.unsticky + .nav-placeholder {
            position: absolute
        }
    }

    .nav.sponsor-sticky {
        transition: top .3s ease-in-out;
        position: fixed;
        max-width: 100%;
        left: 0;
        right: 0;
        top: 0;
        margin: 0 auto;
        z-index: 5999997
    }

    .nav.sponsor-sticky + .nav-placeholder {
        position: static
    }

    .nav.sponsor-sticky.inactive {
        top: -3.375rem
    }

    .nav-placeholder {
        background-color: #fff;
        height: 3.375rem;
        position: absolute
    }

    .nav-bar {
        background-color: #fff;
        height: 3.375rem;
        z-index: 1
    }

    .nav-bar-container {
        display: -webkit-flex;
        display: -ms-flexbox;
        display: flex;
        width: 100%
    }

    .sponsor-nav {
        transition: top .3s ease-in-out;
        z-index: 5999997;
        position: fixed;
        top: -3.375rem;
        width: 100%
    }

    @media only screen and (min-width: 61.25rem) {
        .sponsor-nav.active {
            display: block;
            top: 0
        }
    }

    .sponsor-nav .nav-bar .nav-logo path {
        fill: inherit
    }

    .sponsor-nav-menu {
        line-height: 1
    }

    .sponsor-nav-menu .nav-title {
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap
    }

    .sponsor-nav-inner {
        display: -webkit-flex;
        display: -ms-flexbox;
        display: flex;
        -webkit-align-items: center;
        -ms-flex-align: center;
        align-items: center;
        -webkit-justify-content: center;
        justify-content: center;
        -ms-flex-pack: center
    }

    .sponsor-nav-inner.brand-logo {
        display: -webkit-flex;
        display: -ms-flexbox;
        display: flex;
        -webkit-align-items: center;
        -ms-flex-align: center;
        align-items: center;
        -webkit-justify-content: center;
        justify-content: center;
        -ms-flex-pack: center
    }

    .sponsor-nav-inner.brand-logo .nav-sponsor-label {
        line-height: 0
    }

    .sponsor-nav-inner.brand-logo .nav-sponsor-label path {
        fill: #000
    }

    .sponsor-nav-inner.brand-logo .nav-sponsor-label svg {
        height: 1rem;
        vertical-align: middle
    }

    .sponsor-nav-inner.brand-logo .nav-sponsor-image {
        line-height: 0
    }

    .sponsor-nav-inner.sponsored-by .nav-sponsor-label, .sponsor-nav-inner.provided-by .nav-sponsor-label, .sponsor-nav-inner.created-for .nav-sponsor-label, .sponsor-nav-inner.custom-label .nav-sponsor-label {
        display: inline-block;
        white-space: nowrap;
        margin: 0 .3rem
    }

    .sponsor-nav-inner.sponsored-by .nav-sponsor-image, .sponsor-nav-inner.provided-by .nav-sponsor-image, .sponsor-nav-inner.created-for .nav-sponsor-image, .sponsor-nav-inner.custom-label .nav-sponsor-image {
        display: block;
        margin: 0 auto;
        line-height: 0
    }

    .nav-sponsor-image {
        line-height: 0
    }

    .nav-button {
        position: static;
        top: .9375rem
    }

    .homepage .nav-button {
        top: auto
    }

    .nav-button .icon, .nav-button .sidepanel-back-button:before {
        display: inline;
        font-size: 1.5rem
    }

    .nav-logo {
        -webkit-flex-grow: 1;
        -ms-flex-positive: 1;
        flex-grow: 1;
        text-align: center
    }

    .homepage .nav-logo {
        display: none
    }

    @media only screen and (min-width: 61.25rem) {
        .homepage .nav-logo {
            display: -webkit-flex;
            display: -ms-flexbox;
            display: flex
        }
    }

    .nav-logo svg {
        width: 7.5rem;
        height: 1.75rem;
        vertical-align: middle
    }

    @media only screen and (min-width: 61.25rem) {
        .nav-logo {
            display: -webkit-flex;
            display: -ms-flexbox;
            display: flex;
            -webkit-flex-grow: 0;
            -ms-flex-positive: 0;
            flex-grow: 0;
            text-align: left
        }
    }

    .nav-swipeable {
        position: relative;
        display: none;
        opacity: 0
    }

    .homepage .nav-swipeable {
        background-color: #fff;
        display: block;
        opacity: 1;
        transition: opacity .3s linear;
        width: 100%
    }

    @media only screen and (min-width: 61.25rem) {
        .nav-swipeable {
            background-color: #fff;
            display: block;
            opacity: 1;
            transition: opacity .3s linear;
            width: 100%
        }
    }

    .nav-swipeable a, .nav-swipeable .nav-menu-link {
        cursor: pointer;
        white-space: nowrap
    }

    .marquee + .nav .nav-swipeable, .sponsored-marquee + .nav .nav-swipeable {
        top: auto
    }

    @media only screen and (min-width: 61.25rem) {
        .nav-swipeable-inner {
            display: -webkit-flex;
            display: -ms-flexbox;
            display: flex;
            -webkit-flex: 0 0 auto;
            -ms-flex: 0 0 auto;
            flex: 0 0 auto;
            -webkit-flex-grow: 1;
            -ms-flex-positive: 1;
            flex-grow: 1;
            -webkit-justify-content: flex-start;
            -ms-flex-pack: start;
            justify-content: flex-start;
            width: auto
        }
    }

    .nav-primary-menu {
        display: -webkit-flex;
        display: -ms-flexbox;
        display: flex;
        -webkit-flex: 0 1 100%;
        -ms-flex: 0 1 100%;
        flex: 0 1 100%
    }

    @media only screen and (min-width: 61.25rem) {
        .show-social .nav-primary-menu, .show-subscribe .nav-primary-menu {
            opacity: 0;
            width: 0
        }
    }

    @media only screen and (min-width: 73.75rem) {
        .nav-primary-menu {
            -webkit-flex-shrink: 1;
            -ms-flex-negative: 1;
            flex-shrink: 1
        }
    }

    .nav-item {
        line-height: 1
    }

    .nav-primary-menu .nav-item:nth-child(n+4) {
        display: none
    }

    @media only screen and (min-width: 40.625rem) {
        .nav-primary-menu .nav-item:nth-child(n+4) {
            display: block
        }
    }

    @media only screen and (min-width: 61.25rem) {
        .nav-secondary-menu .nav-menu-item {
            display: -webkit-flex;
            display: -ms-flexbox;
            display: flex;
            -webkit-justify-content: flex-end;
            -ms-flex-pack: end;
            justify-content: flex-end
        }
    }

    @media only screen and (min-width: 61.25rem) {
        .nav-submenu {
            display: -webkit-flex;
            display: -ms-flexbox;
            display: flex;
            -webkit-flex: 1 0 auto;
            -ms-flex: 1 0 auto;
            flex: 1 0 auto
        }

        .nav-submenu a {
            transition: opacity 1s ease, color 1s ease
        }

        .show-social .nav-submenu {
            width: auto
        }
    }

    .nav-menu-subscribe {
        display: none
    }

    @media only screen and (min-width: 61.25rem) {
        .nav-menu-subscribe {
            display: -webkit-flex;
            display: -ms-flexbox;
            display: flex;
            -webkit-flex-shrink: 3.7;
            -ms-flex-negative: 3.7;
            flex-shrink: 3.7;
            -webkit-flex-grow: 2;
            -ms-flex-positive: 2;
            flex-grow: 2;
            -webkit-order: 0;
            -ms-flex-order: 0;
            order: 0;
            line-height: 1
        }

        .nav-menu-subscribe ul {
            display: -webkit-flex;
            display: -ms-flexbox;
            display: flex;
            width: 0;
            height: 0
        }

        .show-subscribe .nav-menu-subscribe {
            -webkit-flex-shrink: 0;
            -ms-flex-negative: 0;
            flex-shrink: 0;
            -webkit-flex-grow: 2;
            -ms-flex-positive: 2;
            flex-grow: 2
        }

        .show-subscribe .nav-menu-subscribe .nav-submenu {
            width: 100%;
            -webkit-order: -1;
            -ms-flex-order: -1;
            order: -1;
            white-space: nowrap;
            opacity: 1;
            margin-right: 2rem;
            -webkit-justify-content: flex-end;
            -ms-flex-pack: end;
            justify-content: flex-end;
            width: auto;
            height: auto
        }

        .show-subscribe .nav-menu-subscribe .nav-submenu .nav-item:last-of-type {
            margin-right: 0;
            padding-right: 0
        }

        .show-social .nav-menu-subscribe {
            display: none
        }
    }

    @media only screen and (min-width: 61.25rem) and (min-width: 0\0
    ) {
        .nav-menu-subscribe {
            -webkit-flex-shrink: 1;
            -ms-flex-negative: 1;
            flex-shrink: 1;
            -webkit-flex-grow: 0;
            -ms-flex-positive: 0;
            flex-grow: 0;
            -webkit-flex-basis: auto;
            -ms-flex-preferred-size: auto;
            flex-basis: auto
        }

        .show-subscribe .nav-menu-subscribe {
            -webkit-flex-shrink: 1;
            -ms-flex-negative: 1;
            flex-shrink: 1;
            -webkit-flex-grow: 0;
            -ms-flex-positive: 0;
            flex-grow: 0;
            -webkit-flex-basis: auto;
            -ms-flex-preferred-size: auto;
            flex-basis: auto
        }

        .show-subscribe .nav-menu-subscribe .nav-submenu {
            -webkit-justify-content: flex-start;
            -ms-flex-pack: start;
            justify-content: flex-start
        }
    }

    .nav-menu-social {
        display: none
    }

    @media only screen and (min-width: 61.25rem) {
        .nav-menu-social {
            display: -webkit-flex;
            display: -ms-flexbox;
            display: flex;
            -webkit-flex-shrink: 0;
            -ms-flex-negative: 0;
            flex-shrink: 0;
            -webkit-flex-grow: 1;
            -ms-flex-positive: 1;
            flex-grow: 1;
            -webkit-flex-basis: auto;
            -ms-flex-preferred-size: auto;
            flex-basis: auto
        }

        .show-social .nav-menu-social {
            -webkit-flex-shrink: 0;
            -ms-flex-negative: 0;
            flex-shrink: 0;
            -webkit-flex-grow: 1;
            -ms-flex-positive: 1;
            flex-grow: 1;
            -webkit-flex-basis: auto;
            -ms-flex-preferred-size: auto;
            flex-basis: auto
        }

        .nav-menu-social .nav-submenu {
            -webkit-order: -1;
            -ms-flex-order: -1;
            order: -1;
            display: none
        }

        .show-social .nav-menu-social .nav-submenu {
            display: -webkit-flex;
            display: -ms-flexbox;
            display: flex;
            opacity: 1
        }

        .nav-menu-social .nav-submenu > .nav-item > span {
            -webkit-order: 2;
            -ms-flex-order: 2;
            order: 2
        }
    }

    @media only screen and (min-width: 61.25rem) and (min-width: 0\0
    ) {
        .show-social .nav-menu-social {
            -webkit-flex: 0 0 auto;
            -ms-flex: 0 0 auto;
            flex: 0 0 auto
        }
    }

    .show-social .social-button-group {
        margin-right: 2rem
    }

    @media only screen and (min-width: 61.25rem) {
        .nav-menu-item {
            -webkit-align-items: center;
            -ms-flex-align: center;
            align-items: center
        }

        .nav-menu-subscribe .nav-menu-item, .nav-menu-social .nav-menu-item {
            display: -webkit-flex;
            display: -ms-flexbox;
            display: flex
        }
    }

    .sponsor-bar.brand-logo .sponsor-label svg {
        height: 1.125rem
    }

    @media only screen and (min-width: 40.625rem) {
        .sponsor-bar.brand-logo .sponsor-label svg {
            height: 1.3rem
        }
    }

    @media only screen and (min-width: 61.25rem) {
        .sponsor-bar.brand-logo .sponsor-label svg {
            height: 1.5rem
        }
    }

    .sponsor-bar .sponsor-image img, .sponsor-bar.brand-logo .sponsor-image img {
        max-height: 2.5rem;
        max-width: 9.375rem
    }

    @media only screen and (min-width: 40.625rem) {
        .sponsor-bar .sponsor-image img, .sponsor-bar.brand-logo .sponsor-image img {
            max-width: 10rem
        }
    }

    @media only screen and (min-width: 61.25rem) {
        .sponsor-bar .sponsor-image img, .sponsor-bar.brand-logo .sponsor-image img {
            max-width: 10.9375rem
        }
    }

    .sponsor-label {
        display: inline-block
    }

    .sponsor-image {
        display: inline-block
    }

    .sponsor-bar {
        display: -webkit-flex;
        display: -ms-flexbox;
        display: flex;
        -webkit-align-items: center;
        -ms-flex-align: center;
        align-items: center;
        -webkit-justify-content: center;
        justify-content: center;
        -ms-flex-pack: center;
        text-align: center;
        z-index: 5999995;
        height: 3.375rem
    }

    .sponsor-bar .sponsor-bar-inner {
        display: -webkit-flex;
        display: -ms-flexbox;
        display: flex;
        -webkit-align-items: center;
        -ms-flex-align: center;
        align-items: center;
        -webkit-justify-content: center;
        justify-content: center;
        -ms-flex-pack: center
    }

    @media only screen and (min-width: 61.25rem) {
        .sponsor-bar {
            display: block;
            height: auto
        }

        .sponsor-bar .sponsor-bar-inner {
            display: block
        }
    }

    .sponsor-bar.brand-logo {
        display: -webkit-flex;
        display: -ms-flexbox;
        display: flex;
        -webkit-align-items: center;
        -ms-flex-align: center;
        align-items: center;
        -webkit-justify-content: center;
        justify-content: center;
        -ms-flex-pack: center
    }

    .sponsor-bar.brand-logo .sponsor-bar-inner {
        display: -webkit-flex;
        display: -ms-flexbox;
        display: flex;
        -webkit-align-items: center;
        -ms-flex-align: center;
        align-items: center;
        -webkit-justify-content: center;
        justify-content: center;
        -ms-flex-pack: center
    }

    .sponsor-bar.brand-logo .sponsor-label {
        line-height: 0
    }

    .sponsor-bar.brand-logo .sponsor-image {
        line-height: 0
    }

    .sponsor-bar.sponsored-by .sponsor-label, .sponsor-bar.provided-by .sponsor-label, .sponsor-bar.created-for .sponsor-label, .sponsor-bar.custom-label .sponsor-label {
        display: block
    }

    .sponsor-bar.sponsored-by .sponsor-image, .sponsor-bar.provided-by .sponsor-image, .sponsor-bar.created-for .sponsor-image, .sponsor-bar.custom-label .sponsor-image {
        display: block;
        margin: 0 auto;
        line-height: 0
    }

    .sponsor-bar.sticky {
        -webkit-transform: none;
        transform: none;
        position: fixed;
        max-width: 100%;
        left: 0;
        right: 0;
        top: 0;
        margin: 0 auto;
        z-index: 5999995
    }

    @media only screen and (min-width: 61.25rem) {
        .sponsor-bar.sticky {
            top: 3.375rem
        }
    }

    .sponsor-bar.sticky + .sponsor-bar-placeholder {
        position: static
    }

    .sponsor-bar-placeholder {
        position: absolute
    }

    .sponsor-inline {
        line-height: 1
    }

    .sponsor.created-for .created-for--long {
        display: none
    }

    .sponsor.created-for .created-for--xshort {
        display: none
    }

    .sponsor.created-for .created-for--short {
        display: inline-block
    }

    @media only screen and (min-width: 61.25rem) {
        .sponsor.created-for .created-for--long {
            display: inline-block
        }

        .sponsor.created-for .created-for--short {
            display: none
        }
    }

    .sponsor.custom-label .custom-label--long {
        display: none
    }

    .sponsor.custom-label .custom-label--xshort {
        display: none
    }

    .sponsor.custom-label .custom-label--short {
        display: inline-block
    }

    @media only screen and (min-width: 61.25rem) {
        .sponsor.custom-label .custom-label--long {
            display: inline-block
        }

        .sponsor.custom-label .custom-label--short {
            display: none
        }
    }

    .top-pathing .created-for .created-for--long, .top-pathing .created-for .created-for--short {
        display: none
    }

    .top-pathing .created-for .created-for--xshort {
        display: inline-block
    }

    .top-pathing .custom-label .custom-label--long, .top-pathing .custom-label .custom-label--short {
        display: none
    }

    .top-pathing .custom-label .custom-label--xshort {
        display: inline-block
    }

    .top-pathing .sponsor-inline {
        margin-bottom: 0;
        padding-bottom: 0
    }

    .sponsor + .item-title {
        margin-top: 0;
        padding-top: 0
    }

    .feed-header.sponsored-header, .content-header.sponsored-header {
        margin-top: 0;
        padding-top: 0
    }

    .nav-button {
        color: #fff
    }

    .nav-button.nav-sidepanel-button {
        color: #000;
        left: 1.25rem;
        line-height: 0
    }

    @media only screen and (min-width: 48rem) {
        .nav-button.nav-sidepanel-button {
            padding-right: .625rem
        }
    }

    @media only screen and (min-width: 61.25rem) {
        .nav-button.nav-sidepanel-button:hover {
            color: #e9328c
        }
    }

    .nav-button.nav-search-button {
        color: #000;
        right: 1.25rem;
        line-height: 0
    }

    @media only screen and (min-width: 48rem) {
        .nav-button.nav-search-button {
            padding-left: .625rem
        }
    }

    @media only screen and (min-width: 61.25rem) {
        .nav-button.nav-search-button:hover {
            color: #e9328c
        }
    }

    @media only screen and (min-width: 61.25rem) {
        .nav-logo {
            margin: 0 .625rem 0 0
        }
    }

    .nav-swipeable a, .nav-swipeable .nav-menu-link {
        font-family: Sofia, Helvetica, Arial, Sans-serif;
        font-size: 1.125rem;
        line-height: 1.2;
        color: #000;
        text-transform: uppercase;
        font-weight: 700;
        line-height: .8;
        margin-top: .1rem;
        text-decoration: none
    }

    @media only screen and (min-width: 61.25rem) {
        .nav-swipeable a, .nav-swipeable .nav-menu-link {
            font-size: 1rem;
            line-height: 1.3
        }
    }

    @media only screen and (min-width: 61.25rem) {
        .nav-swipeable a, .nav-swipeable .nav-menu-link {
            border-bottom: 0
        }

        .nav-swipeable a:after, .nav-swipeable .nav-menu-link:after {
            content: "";
            position: relative;
            display: block;
            margin: 0 auto;
            width: 0;
            bottom: 0;
            left: 0;
            right: 0;
            border-bottom: .1875rem solid #000;
            transition: width .3s ease-out
        }

        .nav-swipeable a:hover, .nav-swipeable .nav-menu-link:hover {
            border-bottom: .1875rem solid #fff
        }

        .nav-swipeable a:hover:after, .nav-swipeable .nav-menu-link:hover:after {
            width: 100%
        }
    }

    .nav-primary-menu {
        -webkit-justify-content: center;
        -ms-flex-pack: center;
        justify-content: center
    }

    @media only screen and (min-width: 61.25rem) {
        .nav-primary-menu {
            -webkit-justify-content: flex-start;
            -ms-flex-pack: start;
            justify-content: flex-start
        }
    }

    .sponsor-nav-menu, .nav-item {
        margin: 0 .625rem
    }

    .nav-secondary-menu .nav-menu-item a, .nav-secondary-menu .nav-menu-item .nav-menu-link {
        font-family: Sofia, Helvetica, Arial, Sans-serif;
        font-size: 1rem;
        line-height: 1.3;
        color: #000;
        text-transform: uppercase
    }

    .nav-secondary-menu .nav-menu-item a:after, .nav-secondary-menu .nav-menu-item .nav-menu-link:after {
        border-bottom: 0
    }

    .nav-secondary-menu .nav-menu-item a:hover, .nav-secondary-menu .nav-menu-item .nav-menu-link:hover {
        border-bottom: 0
    }

    .nav-menu-social {
        padding-bottom: .0625rem;
        border-bottom: 0
    }

    .nav-menu-social .nav-item {
        margin-bottom: 0
    }

    .nav-menu-subscribe {
        box-shadow: none
    }

    @media only screen and (min-width: 61.25rem) {
        .nav-menu-subscribe {
            padding-bottom: .0625rem
        }
    }

    .nav-menu-subscribe .nav-submenu {
        padding-top: .1875rem
    }

    .sponsor-nav-menu .nav-title {
        font-family: Sofia, Helvetica, Arial, Sans-serif;
        font-size: 1.125rem;
        line-height: 1.2;
        color: #000;
        text-transform: uppercase;
        font-weight: 700;
        line-height: .8;
        text-decoration: none;
        box-shadow: inset 0 0 0 #fef035
    }

    @media only screen and (min-width: 61.25rem) {
        .sponsor-nav-menu .nav-title {
            font-size: 1rem;
            line-height: 1.3
        }
    }

    .sponsor-bar.brand-logo .sponsor-label svg {
        max-width: 6.25rem
    }

    @media only screen and (min-width: 40.625rem) {
        .sponsor-bar.brand-logo .sponsor-label svg {
            max-width: 7.25rem
        }
    }

    @media only screen and (min-width: 61.25rem) {
        .sponsor-bar.brand-logo .sponsor-label svg {
            max-width: 8.375rem
        }
    }

    .nav-sponsor-label, .sponsor-label, .sponsor-image {
        font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
        font-size: .6875rem;
        line-height: 1.5;
        color: #7b7b7b
    }

    .sponsor-bar.sponsored-by .sponsor-label, .sponsor-bar.provided-by .sponsor-label, .sponsor-bar.created-for .sponsor-label, .sponsor-bar.custom-label .sponsor-label {
        margin: 0 .5rem
    }

    @media only screen and (min-width: 61.25rem) {
        .sponsor-bar.sponsored-by .sponsor-label, .sponsor-bar.provided-by .sponsor-label, .sponsor-bar.created-for .sponsor-label, .sponsor-bar.custom-label .sponsor-label {
            margin-bottom: .5rem
        }
    }

    .sponsor-logo-separator {
        font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
        font-size: .875rem;
        line-height: 1.2;
        color: #7b7b7b;
        line-height: 1.4
    }

    .sponsor-bar {
        background-color: #f8f8f8;
        border-top: .0625rem solid #ececec;
        border-bottom: .0625rem solid #ececec;
        padding: .5rem 0
    }

    @media only screen and (min-width: 61.25rem) {
        .sponsor-bar {
            margin: 0 0 .9375rem
        }
    }

    .nav-sponsor-logo-separator, .sponsor-bar .sponsor-logo-separator {
        font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
        font-size: 1.25rem;
        line-height: 0;
        color: #9f9f9f;
        margin: 0 .625rem;
        padding-bottom: .25rem
    }

    @media only screen and (min-width: 61.25rem) {
        .sponsor-bar.list-header-sponsor {
            margin: 0 0 .375rem
        }
    }

    .sponsor-bar.marquee-sponsor {
        margin: 0
    }

    .sponsor-bar.longform-sponsor {
        margin: 0;
        padding: .9375rem
    }

    .top-pathing .sponsor-inline {
        margin-top: .125rem;
        padding: 0 .625rem
    }

    .feed-list .sponsor-inline {
        margin-bottom: .625rem
    }

    @media only screen and (min-width: 40.625rem) {
        .feed-list .sponsor-inline {
            margin-bottom: .3125rem
        }
    }

    @media only screen and (min-width: 61.25rem) {
        .feed-list .sponsor-inline {
            float: left;
            clear: both
        }
    }

    .collection-breaker .sponsor-inline {
        padding: 0 .9375rem
    }

    @media only screen and (min-width: 61.25rem) {
        .collection-breaker .sponsor-inline {
            width: 100%;
            text-align: center;
            -webkit-transform: translate(0, -3rem);
            transform: translate(0, -3rem);
            transition: -webkit-transform .3s ease-in-out;
            transition: transform .3s ease-in-out
        }
    }

    .curated-breaker .sponsor-inline {
        padding: 0 .625rem
    }

    .feed-header .sponsor-inline {
        margin-bottom: .625rem
    }

    @media only screen and (min-width: 40.625rem) {
        .feed-header .sponsor-inline {
            margin-bottom: .25rem
        }
    }

    .sponsor-inline.feature-item-sponsor {
        text-align: center
    }

    @media only screen and (min-width: 40.625rem) {
        .sponsor-inline.feature-item-sponsor {
            margin-bottom: .625rem;
            text-align: left
        }
    }

    @media only screen and (min-width: 61.25rem) {
        .sponsor-inline.feature-item-sponsor {
            text-align: center
        }
    }

    .feed-grid .sponsor-inline {
        margin-top: .25rem
    }

    .recirculation-module .sponsor-inline {
        margin-top: .125rem;
        padding-left: .3125rem
    }

    @media only screen and (min-width: 61.25rem) {
        .recirculation-module .sponsor-inline {
            margin-top: .25rem
        }
    }

    .marquee-sponsor-wrap + .feed-grid {
        margin-top: 1.25rem
    }

    .grid-header-sponsor + .grid-header-title {
        text-align: center
    }

    .ad-container {
        margin: 0 auto
    }

    .oop-ad {
        font-size: 0;
        line-height: 0;
        height: 0
    }

    .vertical-ad .ad-container {
        min-width: 18.75rem
    }

    .leaderboard-ad {
        display: none
    }

    @media only screen and (min-width: 48rem) {
        .leaderboard-ad {
            display: block;
            background-color: #f3f3f3;
            padding: .9375rem 0;
            margin-bottom: 1.25rem;
            min-height: 7.5625rem;
            text-align: center;
            z-index: 5999995
        }

        .leaderboard-ad .ad-container {
            min-width: 45.5rem
        }
    }

    @media only screen and (min-width: 61.25rem) {
        .leaderboard-ad {
            width: 100vw;
            margin-left: calc(-50vw + 50%)
        }
    }

    @media only screen and (min-width: 48rem) {
        .marquee + .leaderboard-ad {
            margin-top: 1.25rem
        }
    }

    .breaker-ad {
        position: relative;
        background-color: #f3f3f3;
        margin-top: 1.25rem;
        margin-bottom: 1.25rem;
        padding-top: .625rem;
        padding-bottom: .625rem;
        text-align: center
    }

    .breaker-ad .ad-container {
        min-width: 18.75rem
    }

    @media only screen and (min-width: 61.25rem) {
        .list-vertical-ad, .transporter-vertical-ad {
            background-color: transparent;
            border-top: 0;
            display: block;
            float: right;
            margin: 0 0 1.25rem;
            padding: 0;
            text-align: center;
            width: 32%
        }

        .list-vertical-ad .ad-container, .transporter-vertical-ad .ad-container {
            float: right
        }

        .list-vertical-ad .breaker-ad-text, .transporter-vertical-ad .breaker-ad-text {
            display: none
        }
    }

    .list-breaker-ad.transporter-breaker-ad {
        border: 0
    }

    .standard-article-breaker-ad {
        clear: both
    }

    @media only screen and (min-width: 61.25rem) {
        .standard-article-breaker-ad {
            width: 100vw;
            margin-left: calc(-1 * ((100vw - 151.5%) / 2))
        }

        .standard-article-breaker-ad.mobile-breaker-ad {
            display: none
        }
    }

    .listicle-slide-list-ad, .listicle-breaker-ad {
        margin-bottom: 1.25rem
    }

    @media only screen and (min-width: 61.25rem) {
        .listicle-slide-list-ad, .listicle-breaker-ad {
            width: 100vw;
            margin-left: calc(-1 * ((100vw - 151.5%) / 2))
        }

        .listicle-slide-list-ad.listicle-mobile-breaker-ad, .listicle-breaker-ad.listicle-mobile-breaker-ad {
            display: none
        }
    }

    .slideshow-leaderboard {
        display: none
    }

    @media only screen and (min-width: 48rem) {
        .slideshow-leaderboard {
            display: block;
            margin: 0
        }
    }

    @media only screen and (min-width: 61.25rem) {
        .slideshow-leaderboard {
            width: 100%
        }
    }

    .mobile-slideshow .slideshow-list-ad {
        display: none
    }

    @media only screen and (min-width: 61.25rem) {
        .slideshow-list-ad {
            display: none
        }
    }

    .slideshow-slide-ad {
        display: none
    }

    .mobile-slideshow .slideshow-slide-ad {
        float: left;
        height: 100%;
        margin-bottom: 0;
        width: calc(100% / 1000);
        display: block;
        text-align: center
    }

    .mobile-slideshow .slideshow-slide-ad .ad-container {
        position: absolute;
        top: 50%;
        -webkit-transform: translateY(-50%);
        transform: translateY(-50%);
        position: relative;
        display: inline-block;
        margin: 0 auto
    }

    .mobile-slideshow .slideshow-slide-ad .breaker-ad-text {
        display: none
    }

    .slideshow-slide-ad.hidden .ad-container {
        display: none
    }

    .transporter-vertical-ad {
        clear: both;
        margin: 1.25rem 0
    }

    @media only screen and (min-width: 61.25rem) {
        .transporter-vertical-ad {
            clear: none;
            float: right;
            margin: 0;
            text-align: right;
            width: auto
        }
    }

    .breaker-ad-text {
        width: 100%;
        text-align: center
    }

    @media only screen and (min-width: 61.25rem) {
        .vertical-ad .breaker-ad-text, .transporter-breaker-ad .breaker-ad-text {
            display: none
        }
    }

    @media only screen and (min-width: 61.25rem) {
        .ad-article-breaker-text {
            display: none
        }
    }

    .breaker-ad-text {
        font-family: Sofia, Helvetica, Arial, Sans-serif;
        font-size: .875rem;
        line-height: 1.4;
        text-transform: uppercase;
        color: #9f9f9f;
        padding: 0 0 .625rem
    }

    .transporter-vertical-ad {
        margin-bottom: 2.5rem
    }

    .transporter-vertical-ad:after {
        border-bottom: .0625rem solid #7b7b7b;
        bottom: -1.25rem;
        clear: both;
        content: "";
        display: inline-block;
        left: 0;
        position: absolute;
        width: 100%
    }

    @media only screen and (min-width: 61.25rem) {
        .transporter-vertical-ad:after {
            display: none
        }
    }

    .list-breaker-ad {
        padding-bottom: 2rem
    }

    .site-content {
        transition: -webkit-transform .3s ease-in-out;
        transition: transform .3s ease-in-out;
        position: relative
    }

    .sidepanel {
        background-color: transparent;
        background-image: linear-gradient(to bottom, #e9328c, #f180b8);
        -webkit-transform: translateX(-17rem);
        transform: translateX(-17rem);
        transition: -webkit-transform .3s ease-in-out;
        transition: transform .3s ease-in-out;
        position: fixed;
        top: 0;
        width: 17rem;
        height: 100%;
        overflow-y: scroll;
        z-index: 5999997
    }

    .sidepanel.active {
        -webkit-transform: translateX(0);
        transform: translateX(0)
    }

    .sidepanel-menu, .sidepanel-submenu {
        margin: 0
    }

    .sidepanel-submenu {
        background-color: transparent;
        background-image: linear-gradient(to top, #e9328c, #f180b8);
        -webkit-transform: translateX(-13rem);
        transform: translateX(-13rem);
        transition: -webkit-transform .3s ease-in-out;
        transition: transform .3s ease-in-out;
        position: absolute;
        top: 0;
        left: 0;
        width: 13rem;
        height: 100%;
        padding-right: 0
    }

    .sidepanel-submenu.active {
        -webkit-transform: translateX(0);
        transform: translateX(0)
    }

    .sidepanel-back-button {
        position: relative;
        text-indent: -9999em;
        margin-bottom: .9375rem
    }

    .sidepanel-back-button:before {
        position: absolute;
        left: 0;
        text-indent: 0
    }

    .sidepanel-close-button {
        display: block;
        text-align: right
    }

    .sidepanel-back-button, .sidepanel-close-button {
        font-size: 1.5rem;
        color: #fff;
        cursor: pointer
    }

    .sidepanel-menu {
        padding: .9375rem 4.375rem 0 1.875rem
    }

    .sidepanel-submenu {
        padding: .9375rem 1.25rem 0 1.875rem
    }

    .sidepanel-menu a, .sidepanel-submenu a {
        font-family: Sofia, Helvetica, Arial, Sans-serif;
        font-size: 1.25rem;
        line-height: 1.2;
        color: #fff;
        text-transform: uppercase;
        font-weight: 700;
        text-decoration: none;
        transition: color .3s ease-in-out
    }

    @media only screen and (min-width: 61.25rem) {
        .sidepanel-menu a:hover, .sidepanel-submenu a:hover {
            color: #000
        }
    }

    .sidepanel-submenu-item:nth-child(2) a {
        color: #000
    }

    .sidepanel-close-button {
        margin: .5rem 1.25rem 0 0
    }

    @media only screen and (min-width: 61.25rem) {
        .sidepanel-close-button:hover {
            color: #ef69ab
        }
    }

    .sidepanel-item, .sidepanel-submenu-item {
        margin-bottom: .9375rem;
        line-height: 1
    }

    .search-overlay {
        position: fixed;
        top: 0;
        left: 0;
        z-index: -1
    }

    .search-overlay.active {
        background-color: rgba(0, 0, 0, .9);
        width: 100%;
        height: 100%;
        z-index: 5999997
    }

    .search-overlay-close-button {
        cursor: pointer;
        float: right
    }

    .search-overlay-form {
        margin: 0 auto;
        clear: both
    }

    .search-overlay-autosuggest-list {
        list-style: none;
        text-decoration: none
    }

    .search-header-inner {
        position: relative
    }

    .search-header .search-overlay-autosuggest {
        position: relative;
        z-index: 1
    }

    .search-header .search-overlay-close-button {
        display: none
    }

    .search-header .search-overlay-close-button.active {
        display: inline;
        z-index: 2;
        position: absolute;
        bottom: 0;
        right: 1.3rem
    }

    @media only screen and (min-width: 40.625rem) {
        .search-header .search-overlay-close-button.active {
            right: 3rem
        }
    }

    .search-header .search-overlay-autosuggest-list {
        position: absolute;
        width: 100%
    }

    .search-overlay-inner {
        padding: 1.25rem
    }

    @media only screen and (min-width: 40.625rem) {
        .search-overlay-inner {
            padding: 4.375rem 1.875rem 1.875rem
        }
    }

    .search-overlay-close-button {
        color: #7b7b7b
    }

    .search-overlay-close-button .icon, .search-overlay-close-button .sidepanel-back-button:before {
        font-size: 1.875rem
    }

    .search-overlay-form .search-input, .search-overlay-form .search-input::-webkit-input-placeholder {
        color: #f8f8f8;
        text-transform: lowercase;
        line-height: 2.5rem
    }

    .search-overlay-form .search-input, .search-overlay-form .search-input:-ms-input-placeholder {
        color: #f8f8f8;
        text-transform: lowercase;
        line-height: 2.5rem
    }

    .search-overlay-form .search-input, .search-overlay-form .search-input::placeholder {
        color: #f8f8f8;
        text-transform: lowercase;
        line-height: 2.5rem
    }

    @media only screen and (min-width: 40.625rem) {
        .search-overlay-form .search-input, .search-overlay-form .search-input::-webkit-input-placeholder {
            line-height: 4.6875rem
        }

        .search-overlay-form .search-input, .search-overlay-form .search-input:-ms-input-placeholder {
            line-height: 4.6875rem
        }

        .search-overlay-form .search-input, .search-overlay-form .search-input::placeholder {
            line-height: 4.6875rem
        }
    }

    .search-overlay-form .search-input::-webkit-input-placeholder {
        color: #676767
    }

    .search-overlay-form .search-input:-ms-input-placeholder {
        color: #676767
    }

    .search-overlay-form .search-input::placeholder {
        color: #676767
    }

    .search-overlay-form .search-label {
        font-family: Sofia, Helvetica, Arial, Sans-serif;
        font-size: .875rem;
        line-height: 1.4;
        color: #7b7b7b;
        border-top-color: #fff;
        padding-top: .5rem
    }

    .search-overlay-autosuggest-list {
        font-family: Sofia, Helvetica, Arial, Sans-serif;
        font-size: 1.25rem;
        line-height: 1.2;
        line-height: 2rem;
        margin-top: .9375rem;
        padding-left: 0;
        text-transform: lowercase;
        line-height: 2.1875rem;
        letter-spacing: -.03rem
    }

    @media only screen and (min-width: 40.625rem) {
        .search-overlay-autosuggest-list {
            font-size: 1.5rem;
            line-height: 1.3
        }
    }

    @media only screen and (min-width: 30rem) {
        .search-overlay-autosuggest-list {
            line-height: 3.125rem
        }
    }

    @media only screen and (min-width: 40.625rem) {
        .search-overlay-autosuggest-list {
            line-height: 3.575rem
        }
    }

    .search-overlay-autosuggest-link {
        color: #7b7b7b
    }

    .highlight .search-overlay-autosuggest-link {
        color: #e9328c
    }

    .search-overlay-autosuggest-link-type {
        color: #f8f8f8
    }

    .search-header .search-overlay-close-button.active {
        color: #9f9f9f;
        transition: color .3s ease-in-out
    }

    @media only screen and (min-width: 61.25rem) {
        .search-header .search-overlay-close-button.active:hover {
            color: #e9328c
        }
    }

    .search-header .search-overlay-autosuggest-list {
        background-color: #fff;
        box-shadow: 0 .05rem .625rem rgba(102, 102, 102, .1);
        padding-left: .9375rem
    }

    @media only screen and (min-width: 40.625rem) {
        .search-header .search-overlay-autosuggest-list {
            padding-left: 1.25rem
        }
    }

    .search-header .search-overlay-autosuggest-link-type {
        color: #2c2c2c;
        padding: .9375rem 0
    }

    @media only screen and (min-width: 40.625rem) {
        .search-header .search-overlay-autosuggest-link-type {
            padding: 0
        }
    }

    .item-image {
        display: block;
        overflow: hidden
    }

    .item-image img {
        height: auto
    }

    .item-image .content-indicator {
        position: absolute;
        left: 50%;
        top: 50%;
        -webkit-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);
        width: auto;
        height: auto
    }

    .item-image .content-type-icon {
        position: absolute;
        top: 0;
        left: auto;
        right: 0;
        width: auto;
        height: auto;
        pointer-events: none;
        line-height: 1
    }

    .item-image .content-type-icon .icon, .item-image .content-type-icon .sidepanel-back-button:before {
        position: absolute;
        left: 50%;
        top: 50%;
        -webkit-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%)
    }

    .item-image .content-indicator {
        width: .625rem;
        height: .625rem;
        line-height: .625rem;
        border-radius: .3125rem;
        color: #fff;
        text-decoration: none
    }

    .item-image .content-type-icon {
        width: 2.5rem;
        height: 2.5rem;
        line-height: 2.5rem;
        border-radius: 1.25rem;
        font-size: 1rem;
        color: #000;
        background-color: rgba(255, 255, 255, .65);
        margin: .3125rem .3125rem 0 0
    }

    @media only screen and (min-width: 48rem) {
        .item-image .content-type-icon {
            width: 3.125rem;
            height: 3.125rem;
            line-height: 3.125rem;
            border-radius: 1.5625rem;
            font-size: 1.2rem;
            margin: .625rem .625rem 0 0
        }
    }

    .item-image .content-type-icon .icon-play {
        padding-left: .125rem
    }

    .item-image .content-type-icon .icon-gallery {
        padding-bottom: .0625rem
    }

    .item-image .content-type-icon .icon-quiz {
        padding-bottom: .0625rem
    }

    .item-image .content-type-icon .icon-quiz {
        position: absolute;
        left: 50%;
        top: 50%;
        -webkit-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%)
    }

    .simple-item-metadata {
        display: none
    }

    @media only screen and (min-width: 40.625rem) {
        .simple-item-metadata {
            display: block
        }
    }

    .simple-item-publish-date {
        display: inline-block
    }

    .simple-item-dek p {
        margin-top: 0;
        margin-bottom: 0
    }

    .simple-item-image {
        margin-bottom: .625rem
    }

    @media only screen and (min-width: 40.625rem) {
        .simple-item-metadata {
            margin-bottom: .9375rem
        }
    }

    @media only screen and (min-width: 61.25rem) {
        .simple-item-metadata {
            position: relative;
            display: inline;
            top: 1.875rem;
            background: #fff;
            width: 80%;
            padding: .1875rem .9375rem .4375rem;
            margin-bottom: 0;
            border: .1875rem solid #000
        }
    }

    .simple-item-parent-link {
        color: #e9328c;
        display: inline;
        margin-right: .3125rem
    }

    .simple-item-publish-date {
        cursor: default;
        pointer-events: none
    }

    .simple-item-dek {
        display: none
    }

    .simple-item-byline {
        margin-top: .625rem
    }

    .top-pathing {
        margin-bottom: 1.875rem;
        display: none
    }

    .homepage .top-pathing {
        display: block
    }

    @media only screen and (min-width: 40.625rem) {
        .top-pathing {
            display: block
        }
    }

    .top-pathing-item .simple-item-sponsor .sponsor-image {
        display: inline
    }

    @media only screen and (min-width: 61.25rem) {
        .top-pathing-item.show-numbers .item-title, .top-pathing-item.show-numbers .simple-item-sponsor {
            padding-left: 0;
            margin-left: 0
        }
    }

    .simple-item-index {
        display: none
    }

    @media only screen and (min-width: 40.625rem) {
        .simple-item-index {
            display: inline-block;
            float: left;
            margin-bottom: .9375rem
        }
    }

    .top-pathing-label {
        display: none
    }

    @media only screen and (min-width: 40.625rem) {
        .top-pathing-label {
            display: block;
            position: absolute;
            bottom: 0;
            left: 0;
            width: auto;
            height: auto;
            top: initial;
            display: none
        }
    }

    .top-pathing {
        margin-bottom: .625rem
    }

    .top-pathing-item .item-title {
        font-family: Sofia, Helvetica, Arial, Sans-serif;
        font-size: .875rem;
        line-height: 1.4;
        color: #000;
        padding: 0 .625rem;
        letter-spacing: -.03rem
    }

    @media only screen and (min-width: 40.625rem) {
        .simple-item-index {
            font-family: Sofia, Helvetica, Arial, Sans-serif;
            font-size: 2.625rem;
            line-height: 1.1;
            -webkit-text-fill-color: transparent;
            -webkit-text-stroke-width: .05rem;
            -webkit-text-stroke-color: #000;
            font-weight: 700;
            line-height: .8;
            margin: 0 .9375rem .625rem .625rem
        }
    }

    @media only screen and (min-width: 40.625rem) {
        .top-pathing-label {
            font-family: Sofia, Helvetica, Arial, Sans-serif;
            font-size: .75rem;
            line-height: 1
        }
    }

    .content-dek p {
        margin: 0
    }

    .content-header-inner > .sponsor {
        margin-top: 0
    }

    .content-header {
        margin: 1.25rem 0
    }

    .content-dek {
        font-family: Sofia, Helvetica, Arial, Sans-serif;
        font-size: 1.25rem;
        line-height: 1.2;
        color: #7b7b7b;
        letter-spacing: -.03rem;
        padding-top: .3125rem;
        font-weight: 400
    }

    @media only screen and (min-width: 40.625rem) {
        .content-dek {
            font-size: 1.5rem;
            line-height: 1.3
        }
    }

    @media only screen and (min-width: 40.625rem) {
        .content-dek {
            padding-top: .625rem
        }
    }

    .content-info.slideshow-info {
        margin-bottom: 1.25rem
    }

    .content-info.standard-info, .content-info.listicle-info {
        margin-top: 1.25rem;
        margin-bottom: 1.25rem
    }

    @media only screen and (min-width: 61.25rem) {
        .content-info-inner {
            padding: 0
        }
    }

    .content-info-metadata {
        -webkit-align-items: center;
        -ms-flex-align: center;
        align-items: center;
        display: -webkit-inline-flex;
        display: -ms-inline-flexbox;
        display: inline-flex
    }

    @media only screen and (min-width: 40.625rem) {
        .content-info-metadata {
            float: left;
            min-height: 2.625rem
        }
    }

    @media only screen and (min-width: 40.625rem) {
        .content-info-byline-with-image {
            display: -webkit-inline-flex;
            display: -ms-inline-flexbox;
            display: inline-flex;
            -webkit-align-items: center;
            -ms-flex-align: center;
            align-items: center
        }
    }

    .content-info-byline-image {
        display: none
    }

    @media only screen and (min-width: 40.625rem) {
        .content-info-byline-image {
            width: 2.5rem;
            height: 2.5rem;
            line-height: 2.5rem;
            border-radius: 1.25rem;
            overflow: hidden;
            display: block;
            margin-right: .625rem
        }

        .content-info-byline-image .icon-author {
            display: inline
        }
    }

    .content-info-social-buttons {
        display: -webkit-inline-flex;
        display: -ms-inline-flexbox;
        display: inline-flex;
        -webkit-align-items: center;
        -ms-flex-align: center;
        align-items: center;
        width: 100%
    }

    @media only screen and (min-width: 40.625rem) {
        .content-info-social-buttons {
            float: right;
            width: auto
        }
    }

    .content-info-aggregate-count .aggregate-count-number.show-count {
        padding-right: .625rem
    }

    .content-info-social-button-group {
        -webkit-flex-grow: 1;
        -ms-flex-positive: 1;
        flex-grow: 1
    }

    .content-info-social-button {
        margin-right: .3125rem
    }

    .content-info-social-button .social-button-link {
        margin: 0 auto
    }

    .content-info-social-button:last-child {
        margin-right: 0
    }

    .content-info-metadata {
        margin-bottom: 1.25rem
    }

    @media only screen and (min-width: 40.625rem) {
        .content-info-metadata {
            margin-bottom: 0
        }
    }

    .content-info-byline-image {
        font-size: 1.063rem;
        color: #000;
        background-color: #ececec;
        line-height: 2.4rem;
        text-align: center
    }

    .content-info-byline {
        margin-right: .4375rem
    }

    .content-info-date {
        color: #9f9f9f
    }

    .content-info-aggregate-count .aggregate-count-number {
        font-weight: 700
    }

    .content-info-social-button .social-button-link {
        width: 100%;
        height: 2.5rem;
        line-height: 2.4rem
    }

    @media only screen and (min-width: 40.625rem) {
        .content-info-social-button .social-button-link {
            width: 2.5rem
        }
    }

    .content-lede-image, .content-lede-video {
        position: relative
    }

    .content-lede-image-wrap {
        width: 100%;
        overflow: hidden
    }

    .content-lede-image-wrap img {
        height: auto
    }

    .content-lede-video {
        width: 100%
    }

    .content-lede-video iframe {
        width: 100%;
        height: 100%
    }

    .content-lede-loop .desktop-only-video {
        width: 100%;
        display: none
    }

    @media only screen and (min-width: 61.25rem) {
        .content-lede-loop .desktop-only-video {
            display: block
        }
    }

    .content-lede-loop .desktop-only-video video {
        width: 100%
    }

    .content-lede-loop .desktop-only-video-fallback {
        width: 100%
    }

    .content-lede-image-social-button {
        position: absolute;
        bottom: 0;
        right: 0
    }

    .content-lede-image-social-button {
        width: 2.5rem;
        height: 2.5rem;
        line-height: 2.5rem;
        margin-right: .3125rem
    }

    .content-lede-image-social-button:last-child {
        margin-right: 0
    }

    .zoom-icon {
        width: auto;
        height: auto;
        position: absolute;
        top: 0;
        left: auto !important;
        right: 0 !important;
        font-size: inherit;
        pointer-events: none;
        text-align: center;
    }

    @media only screen and (min-width: 61.25rem) {
        .zoom-icon {
            cursor: pointer
        }
    }

    .zoom-icon .icon, .zoom-icon .sidepanel-back-button:before {
        width: inherit;
        text-align: center
    }

    .zoom-icon {
        width: 2rem !important;
        height: 2rem !important;
        color: #fff;
        font-size: 17px;
        background-color: rgba(0, 0, 0, .2)
    }

    .zoom-icon .icon, .zoom-icon .sidepanel-back-button:before {
        line-height: 2.5rem
    }

    .image-credit .image-copyright + .image-photo-credit:before {
        content: " / "
    }

    .longform-lede-image-credit {
        position: absolute
    }

    .standard-lede-image .content-lede-image-credit, .listicle-lede-image .content-lede-image-credit {
        top: auto;
        bottom: 0;
        height: auto;
        width: auto
    }

    .image-credit, .slide-image-credit, .standard-lede-image .content-lede-image-credit, .listicle-lede-image .content-lede-image-credit {
        font-family: Sofia, Helvetica, Arial, Sans-serif;
        font-size: .625rem;
        line-height: 1.5;
        color: #9f9f9f;
        margin-top: .3125rem;
        text-transform: uppercase
    }

    .slide-image-credit {
        margin-top: .4375rem
    }

    .mobile-slideshow .slide-image-credit {
        margin: 0 0 .625rem .625rem
    }

    .longform-lede-image-credit {
        font-family: Sofia, Helvetica, Arial, Sans-serif;
        font-size: .5625rem;
        line-height: 1.5;
        background: rgba(255, 255, 255, .5);
        bottom: 0;
        color: #414141;
        left: 0;
        padding: .3125rem .625rem;
        letter-spacing: -.03rem
    }

    .standard-lede-image .content-lede-image-credit, .listicle-lede-image .content-lede-image-credit {
        background-color: rgba(255, 255, 255, .6);
        color: #000;
        margin-top: 0;
        padding: .3125rem .9375rem
    }

    .opinion-label {
        text-align: center;
        background-color: #ececec
    }

    .opinion-label {
        position: relative
    }

    .opinion-label:after {
        width: 0;
        height: 0;
        border-left: .5rem solid transparent;
        border-right: .5rem solid transparent;
        border-top: .5rem solid #ececec;
        position: absolute;
        left: 50%;
        -webkit-transform: translateX(-50%);
        transform: translateX(-50%);
        content: "";
        top: 100%;
        z-index: 1
    }

    .longform-header .opinion-label {
        margin: 0
    }

    @media only screen and (min-width: 40.625rem) {
        .longform-header .opinion-label {
            margin: 0
        }
    }

    .opinion-disclaimer p {
        margin: 0
    }

    .opinion-label {
        padding: .625rem 0;
        margin: 0 0 .9375rem
    }

    @media only screen and (min-width: 40.625rem) {
        .opinion-label {
            padding: .75rem 0;
            margin: 0 0 1.25rem
        }
    }

    .opinion-label-text {
        font-family: Sofia, Helvetica, Arial, Sans-serif;
        font-size: .875rem;
        line-height: 1.4;
        text-transform: uppercase;
        color: #000
    }

    @media only screen and (min-width: 40.625rem) {
        .opinion-label-text {
            font-size: 1rem;
            line-height: 1.3
        }
    }

    .opinion-disclaimer {
        margin-bottom: 1.875rem;
        border-bottom: .0625rem dotted #9f9f9f
    }

    .opinion-disclaimer p {
        font-family: Sofia, Helvetica, Arial, Sans-serif;
        font-size: .75rem;
        line-height: 1;
        color: #7b7b7b;
        letter-spacing: .02em;
        text-align: left;
        padding: .625rem 0
    }

    @media only screen and (min-width: 40.625rem) {
        .opinion-disclaimer p {
            font-size: .875rem;
            line-height: 1.4
        }
    }</style>
    <script type="text/javascript">
        var HRST = HRST || {};
        HRST.site = {
            "name": "Cosmopolitan",
            "prefix": "cosmopolitan",
            "domain": "www.cosmopolitan.com",
            "dartzone": "\/36117602\/hdm-cosmopolitan\/"
        };
        HRST.article = {
            "canonicalUrl": "http:\/\/www.cosmopolitan.com\/food-cocktails\/news\/a38276\/20-things-you-didnt-know-you-could-order-at-starbucks\/",
            "formerShareCount": "",
            "pageUrl": "http:\/\/www.cosmopolitan.com\/food-cocktails\/news\/a38276\/20-things-you-didnt-know-you-could-order-at-starbucks\/",
            "author": {
                "name": "Carina Hsieh",
                "role": ""
            },
            "adCategory": {
                "id": "bc5a6919-79ec-4ec4-83ec-692e43edef8d",
                "name": "Food & Entertaining",
                "prefix": "food_entertaining"
            },
            "autoSocial": "evergreen",
            "collection": [],
            "createDate": {
                "year": "2016",
                "month": "09",
                "day": "10",
                "hour": "0",
                "minute": "45"
            },
            "display": "standard-article",
            "id": "cosmo.article.38276",
            "image": {
                "thumb": "https:\/\/hips.hearstapps.com\/hmg-prod.s3.amazonaws.com\/images\/pin-starbucksexisted-1493760756.jpg?crop=1.00xw:0.334xh;0,0&resize=100:*",
                "large": "https:\/\/hips.hearstapps.com\/hmg-prod.s3.amazonaws.com\/images\/pin-starbucksexisted-1493760756.jpg"
            },
            "modifiedDate": {
                "year": "2017",
                "month": "05",
                "day": "03",
                "hour": "16",
                "minute": "42"
            },
            "ogUrl": "http:\/\/www.cosmopolitan.com\/food-cocktails\/news\/a38276\/20-things-you-didnt-know-you-could-order-at-starbucks\/",
            "publishDate": {
                "year": "2017",
                "month": "05",
                "day": "02",
                "hour": "21",
                "minute": "55"
            },
            "section": {
                "name": "Food & Cocktails",
                "prefix": "food-cocktails"
            },
            "subSection": {
                "name": "",
                "prefix": ""
            },
            "sourceName": "Hearst Editorial",
            "sponsor": [],
            "syndicatingSite": "Cosmopolitan",
            "syndicateSiteOrigin": "Cosmopolitan",
            "tags": [],
            "template": "article",
            "themes": [
                "Food & Cooking"
            ],
            "title": "26 Starbucks Drinks You Had No Idea Actually Existed",
            "type": "News",
            "universalID": "cosmo.article.38276",
            "wordCount": 740
        };
        HRST.datalayer = {
            "currency": "$",
            "propertyName": "www.cosmopolitan.com",
            "autoSocial": "evergreen",
            "contentType": "News",
            "embeddedMedia": {
                "video": {
                    "aol": 0,
                    "abcvideo": 0,
                    "funnyordie": 0,
                    "hulu": 0,
                    "kaltura": 0,
                    "mtv": 0,
                    "ndn": 0,
                    "tmz": 0,
                    "vevo": 0,
                    "vimeo": 0,
                    "video": 0,
                    "gopher": 0,
                    "yahoo": 0,
                    "youtube": 0
                },
                "music": {
                    "soundcloud": 0,
                    "spotify": 0
                },
                "quiz": {
                    "playbuzz": 0,
                    "quizatious": 0
                },
                "shop": {
                    "commerce": 0
                },
                "social": {
                    "facebook": 0,
                    "instagram": 0,
                    "pinterest": 0,
                    "twitter": 0,
                    "vine": 0
                }
            },
            "pageType": "Standard Article",
            "channelName": "Food & Cocktails",
            "subChannelName": "",
            "contentTitle": "26 Starbucks Drinks You Had No Idea Actually Existed",
            "contentId": "cosmo.article.38276",
            "canonicalUrl": "http:\/\/www.cosmopolitan.com\/food-cocktails\/news\/a38276\/20-things-you-didnt-know-you-could-order-at-starbucks\/",
            "ogUrl": "http:\/\/www.cosmopolitan.com\/food-cocktails\/news\/a38276\/20-things-you-didnt-know-you-could-order-at-starbucks\/",
            "contentSource": "Hearst Editorial",
            "contentTopic": "",
            "contentPublishDate": "1493762100",
            "contentCollectionName": [],
            "contentAuthor": "Carina Hsieh and Danielle Tullo",
            "photoNonInteraction": "",
            "photoId": "",
            "photoLocation": "",
            "syndicationRights": "3",
            "themes": [
                "Food & Cooking"
            ],
            "articleLength": 740
        };
        HRST.contentTesting = {
            "kriegerUrl": "https:\/\/krieger.hdmtools.com",
            "kriegerVersion": "v2",
            "babouUrl": "http:\/\/babou.hdmtools.com\/api",
            "babouVersion": "v2",
            "site": "cosmopolitan"
        };
    </script>
    <script type="application/json" id="data-layer">
        {
            "canonicalUrl": "http://www.cosmopolitan.com/food-cocktails/news/a38276/20-things-you-didnt-know-you-could-order-at-starbucks/",
            "contentTesting": {
                "kriegerUrl": "https://krieger.hdmtools.com",
                "kriegerVersion": "v2",
                "babouUrl": "http://babou.hdmtools.com/api",
                "babouVersion": "v2"
            },
            "locale": {
                "language": "en",
                "urlPath": ""
            },
            "site": {
                "name": "Cosmopolitan",
                "domain": "www.cosmopolitan.com",
                "dartZone": "/36117602/hdm-cosmopolitan/"
            },
            "content": {
                "authors": [
                    "Carina Hsieh",
                    "Danielle Tullo"
                ],
                "adCategory": {
                    "id": "bc5a6919-79ec-4ec4-83ec-692e43edef8d",
                    "name": "Food & Entertaining",
                    "prefix": "food_entertaining"
                },
                "autoSocial": "evergreen",
                "contentType": "News",
                "collections": [],
                "createdDate": {
                    "year": "2016",
                    "month": "09",
                    "day": "10",
                    "hour": "0",
                    "minute": "45"
                },
                "displayType": "Standard Article",
                "display_id": "2645610",
                "embeddedMedia": {
                    "video": {
                        "aol": 0,
                        "abcvideo": 0,
                        "funnyordie": 0,
                        "hulu": 0,
                        "kaltura": 0,
                        "mtv": 0,
                        "ndn": 0,
                        "tmz": 0,
                        "vevo": 0,
                        "vimeo": 0,
                        "video": 0,
                        "gopher": 0,
                        "yahoo": 0,
                        "youtube": 0
                    },
                    "music": {
                        "soundcloud": 0,
                        "spotify": 0
                    },
                    "quiz": {
                        "playbuzz": 0,
                        "quizatious": 0
                    },
                    "shop": {
                        "commerce": 0
                    },
                    "social": {
                        "facebook": 0,
                        "instagram": 0,
                        "pinterest": 0,
                        "twitter": 0,
                        "vine": 0
                    }
                },
                "id": "b1b373e5-e4f8-4711-b0f6-48826a35ac45",
                "images": {
                    "lede": {
                        "width": 1000,
                        "height": 3000,
                        "thumb_url": "https://hips.hearstapps.com/hmg-prod.s3.amazonaws.com/images/pin-starbucksexisted-1493760756.jpg?crop=1.00xw:0.334xh;0,0&resize=100:*",
                        "url": "https://hips.hearstapps.com/hmg-prod.s3.amazonaws.com/images/pin-starbucksexisted-1493760756.jpg"
                    },
                    "social": {
                        "width": 1000,
                        "height": 3000,
                        "thumb_url": "https://hips.hearstapps.com/hmg-prod.s3.amazonaws.com/images/pin-starbucksexisted-1493760756.jpg?crop=1.00xw:0.334xh;0,0&resize=100:*",
                        "url": "https://hips.hearstapps.com/hmg-prod.s3.amazonaws.com/images/pin-starbucksexisted-1493760756.jpg"
                    }
                },
                "modifiedDate": {
                    "year": "2017",
                    "month": "05",
                    "day": "03",
                    "hour": "16",
                    "minute": "42"
                },
                "publishDate": {
                    "year": "2017",
                    "month": "05",
                    "day": "02",
                    "hour": "21",
                    "minute": "55"
                },
                "slug": "20-things-you-didnt-know-you-could-order-at-starbucks",
                "sourceName": "Hearst Editorial",
                "section": {
                    "name": "Food & Cocktails",
                    "prefix": "food-cocktails"
                },
                "subsection": {
                    "name": "",
                    "prefix": ""
                },
                "sponsor": [],
                "syndicationRights": "3",
                "tags": [],
                "themes": [
                    "Food & Cooking"
                ],
                "title": "26 Starbucks Drinks You Had No Idea Actually Existed",
                "hide_all_recirc": false,
                "hide_breaker_ads": false,
                "wordCount": 740
            },
            "template": "Standard Article",
            "ogUrl": "http://www.cosmopolitan.com/food-cocktails/news/a38276/20-things-you-didnt-know-you-could-order-at-starbucks/"
        }
    </script>

    <link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css">
    <style>
        .clearfix::after, .standard-container::after, .feed-transporter::after, .seo-tags-container::after, .footer-inner::after, .footer-social-menu::after, .footer-menu::after, .playlist-thumbnails::after, .playlist-thumb--img::after, .end-of-content-module::after {
            content: " ";
            display: table;
            clear: both
        }

        .standard-container, .social-menu-inner, .transporter, .seo-tags-container, .footer-inner, .recommended-module.contained-width, .ct-unit, .end-of-content-module {
            padding-left: .938rem;
            padding-right: .938rem
        }

        @media (min-width: 40.625rem) {
            .standard-container, .social-menu-inner, .transporter, .seo-tags-container, .footer-inner, .recommended-module.contained-width, .ct-unit, .end-of-content-module {
                padding-left: 2.5rem;
                padding-right: 2.5rem
            }
        }

        .standard-container, .social-menu-inner, .transporter, .seo-tags-container, .footer-inner, .recommended-module.contained-width, .ct-unit, .end-of-content-module {
            max-width: 75rem;
            margin: 0 auto
        }

        .embed-video.embed-video-center-large, .embed-youtube-playlist {
            -webkit-transform: translate(-.938rem, 0);
            transform: translate(-.938rem, 0);
            width: calc(100% + (.938rem * 2))
        }

        @media only screen and (min-width: 40.625rem) {
            .embed-video.embed-video-center-large, .embed-youtube-playlist {
                -webkit-transform: none;
                transform: none;
                width: auto
            }
        }

        @media only screen and (min-width: 40.625rem) {
            .embed-video.embed-video-center-large, .embed-youtube-playlist {
                -webkit-transform: translate(-2.5rem, 0);
                transform: translate(-2.5rem, 0);
                width: calc(100% + (2.5rem * 2))
            }
        }

        @media only screen and (min-width: 61.25rem) {
            .embed-video.embed-video-center-large, .embed-youtube-playlist {
                -webkit-transform: none;
                transform: none;
                width: auto
            }
        }

        .sponsor-bar {
            -webkit-transform: translate(-.938rem, 0);
            transform: translate(-.938rem, 0);
            width: calc(100% + (.938rem * 2));
            clear: both
        }

        @media only screen and (min-width: 40.625rem) {
            .sponsor-bar {
                -webkit-transform: none;
                transform: none;
                width: 100vw;
                position: relative;
                left: calc(-50vw + 50%)
            }
        }

        .aspect-ratio-8x1 {
            position: relative
        }

        .aspect-ratio-8x1:before {
            content: "";
            display: block;
            width: 100%;
            padding-bottom: 12.5%
        }

        .aspect-ratio-8x1 > * {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%
        }

        .aspect-ratio-5x1 {
            position: relative
        }

        .aspect-ratio-5x1:before {
            content: "";
            display: block;
            width: 100%;
            padding-bottom: 20%
        }

        .aspect-ratio-5x1 > * {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%
        }

        .aspect-ratio-8x10 {
            position: relative
        }

        .aspect-ratio-8x10:before {
            content: "";
            display: block;
            width: 100%;
            padding-bottom: 125%
        }

        .aspect-ratio-8x10 > * {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%
        }

        .aspect-ratio-16x9, .embed-video {
            position: relative
        }

        .aspect-ratio-16x9:before, .embed-video:before {
            content: "";
            display: block;
            width: 100%;
            padding-bottom: 56.25%
        }

        .aspect-ratio-16x9 > *, .embed-video > * {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%
        }

        .aspect-ratio-3x1 {
            position: relative
        }

        .aspect-ratio-3x1:before {
            content: "";
            display: block;
            width: 100%;
            padding-bottom: 33.3333333333%
        }

        .aspect-ratio-3x1 > * {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%
        }

        .aspect-ratio-1x1 {
            position: relative
        }

        .aspect-ratio-1x1:before {
            content: "";
            display: block;
            width: 100%;
            padding-bottom: 100%
        }

        .aspect-ratio-1x1 > * {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%
        }

        .aspect-ratio-6x4 {
            position: relative
        }

        .aspect-ratio-6x4:before {
            content: "";
            display: block;
            width: 100%;
            padding-bottom: 66.6666666667%
        }

        .aspect-ratio-6x4 > * {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%
        }

        .aspect-ratio-2x1, .recirculation-module-image, .end-of-content-simple-item .item-image {
            position: relative
        }

        .aspect-ratio-2x1:before, .recirculation-module-image:before, .end-of-content-simple-item .item-image:before {
            content: "";
            display: block;
            width: 100%;
            padding-bottom: 50%
        }

        .aspect-ratio-2x1 > *, .recirculation-module-image > *, .end-of-content-simple-item .item-image > * {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%
        }

        .aspect-ratio-4x6 {
            position: relative
        }

        .aspect-ratio-4x6:before {
            content: "";
            display: block;
            width: 100%;
            padding-bottom: 150%
        }

        .aspect-ratio-4x6 > * {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%
        }

        .aspect-ratio-4x3 {
            position: relative
        }

        .aspect-ratio-4x3:before {
            content: "";
            display: block;
            width: 100%;
            padding-bottom: 75%
        }

        .aspect-ratio-4x3 > * {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%
        }

        .footer-social-menu-item {
            transition: color .3s ease-in-out
        }

        .footer-menu, .footer-legal-menu {
            list-style-type: none
        }

        .link, .playlist-thumb {
            text-decoration: none;
            cursor: pointer
        }

        .link-button {
            outline: none;
            border: none
        }

        .icon {
            line-height: inherit
        }

        body {
            position: relative;
            font-kerning: normal
        }

        img {
            max-width: 100%
        }

        ul {
            list-style-position: inside;
            list-style-type: disc
        }

        ol {
            list-style-position: outside;
            list-style-type: decimal
        }

        strong, b {
            font-weight: 600
        }

        em, i, q {
            font-style: italic
        }

        /*! normalize.css v3.0.2 | MIT License | git.io/normalize */
        html {
            font-family: sans-serif;
            -ms-text-size-adjust: 100%;
            -webkit-font-smoothing: antialiased;
            -webkit-text-size-adjust: 100%
        }

        body {
            margin: 0
        }

        * {
            box-sizing: border-box
        }

        article, aside, details, figcaption, figure, footer, header, hgroup, main, menu, nav, section, summary {
            display: block
        }

        audio, canvas, progress, video {
            display: inline-block;
            vertical-align: baseline
        }

        audio:not([controls]) {
            display: none;
            height: 0
        }

        [hidden], template {
            display: none
        }

        a {
            background-color: transparent
        }

        a:active, a:hover {
            outline: 0
        }

        abbr[title] {
            border-bottom: 1px dotted
        }

        b, strong {
            font-weight: 700
        }

        dfn {
            font-style: italic
        }

        h1 {
            font-size: 2em;
            margin: 0
        }

        h2 {
            margin: 0
        }

        mark {
            background: #ff0;
            color: #000
        }

        small {
            font-size: 80%
        }

        sub, sup {
            font-size: 75%;
            line-height: 0;
            position: relative;
            vertical-align: baseline
        }

        sup {
            top: -.5em
        }

        sub {
            bottom: -.25em
        }

        img {
            border: 0
        }

        svg:not(:root) {
            overflow: hidden
        }

        figure {
            margin: 1em 40px
        }

        hr {
            box-sizing: content-box;
            height: 0
        }

        pre {
            overflow: auto
        }

        code, kbd, pre, samp {
            font-family: monospace, monospace;
            font-size: 1em
        }

        button, input, optgroup, select, textarea {
            color: inherit;
            font: inherit;
            margin: 0
        }

        button {
            overflow: visible
        }

        button, select {
            text-transform: none
        }

        button, html input[type=button], input[type=reset], input[type=submit] {
            -webkit-appearance: button;
            cursor: pointer
        }

        button[disabled], html input[disabled] {
            cursor: default
        }

        button::-moz-focus-inner, input::-moz-focus-inner {
            border: 0;
            padding: 0
        }

        input {
            line-height: normal
        }

        input[type=checkbox], input[type=radio] {
            box-sizing: border-box;
            padding: 0
        }

        input[type=number]::-webkit-inner-spin-button, input[type=number]::-webkit-outer-spin-button {
            height: auto
        }

        input[type=search] {
            -webkit-appearance: textfield;
            box-sizing: content-box
        }

        input[type=search]::-webkit-search-cancel-button, input[type=search]::-webkit-search-decoration {
            -webkit-appearance: none
        }

        fieldset {
            border: 1px solid silver;
            margin: 0 2px;
            padding: .35em .625em .75em
        }

        legend {
            border: 0;
            padding: 0
        }

        textarea {
            overflow: auto
        }

        optgroup {
            font-weight: 700
        }

        table {
            border-collapse: collapse;
            border-spacing: 0
        }

        td, th {
            padding: 0
        }

        @-webkit-keyframes dropdown-menu-hide {
            0% {
                visibility: visible;
                opacity: 1
            }
            1% {
                z-index: -1
            }
            30% {
                visibility: visible;
                opacity: 1
            }
            100% {
                z-index: -1;
                -webkit-transform: translateY(-100%);
                transform: translateY(-100%)
            }
        }

        @keyframes dropdown-menu-hide {
            0% {
                visibility: visible;
                opacity: 1
            }
            1% {
                z-index: -1
            }
            30% {
                visibility: visible;
                opacity: 1
            }
            100% {
                z-index: -1;
                -webkit-transform: translateY(-100%);
                transform: translateY(-100%)
            }
        }

        @-webkit-keyframes dropdown-menu-show {
            0% {
                z-index: -1;
                -webkit-transform: translateY(-100%);
                transform: translateY(-100%)
            }
            99% {
                z-index: -1
            }
            100% {
                z-index: 9999999;
                -webkit-transform: translateY(0);
                transform: translateY(0)
            }
        }

        @keyframes dropdown-menu-show {
            0% {
                z-index: -1;
                -webkit-transform: translateY(-100%);
                transform: translateY(-100%)
            }
            99% {
                z-index: -1
            }
            100% {
                z-index: 9999999;
                -webkit-transform: translateY(0);
                transform: translateY(0)
            }
        }

        @-webkit-keyframes input-add-button {
            0% {
                visibility: hidden;
                display: none;
                -webkit-transform: scale(.95);
                transform: scale(.95);
                opacity: 0
            }
            100% {
                top: 0;
                visibility: visible;
                display: block;
                -webkit-transform: scale(1);
                transform: scale(1);
                opacity: 1
            }
        }

        @keyframes input-add-button {
            0% {
                visibility: hidden;
                display: none;
                -webkit-transform: scale(.95);
                transform: scale(.95);
                opacity: 0
            }
            100% {
                top: 0;
                visibility: visible;
                display: block;
                -webkit-transform: scale(1);
                transform: scale(1);
                opacity: 1
            }
        }

        @-webkit-keyframes input-hide {
            0% {
                -webkit-transform: scale(1);
                transform: scale(1);
                opacity: 1;
                display: block
            }
            20% {
                -webkit-transform: scale(1.01);
                transform: scale(1.01)
            }
            100% {
                -webkit-transform: scale(.87);
                transform: scale(.87);
                opacity: 0;
                display: none
            }
        }

        @keyframes input-hide {
            0% {
                -webkit-transform: scale(1);
                transform: scale(1);
                opacity: 1;
                display: block
            }
            20% {
                -webkit-transform: scale(1.01);
                transform: scale(1.01)
            }
            100% {
                -webkit-transform: scale(.87);
                transform: scale(.87);
                opacity: 0;
                display: none
            }
        }

        @-webkit-keyframes input-show {
            0% {
                -webkit-transform: scale(.98);
                transform: scale(.98);
                opacity: 0
            }
            95% {
                -webkit-transform: scale(1.004);
                transform: scale(1.004)
            }
            100% {
                -webkit-transform: scale(1);
                transform: scale(1);
                opacity: 1
            }
        }

        @keyframes input-show {
            0% {
                -webkit-transform: scale(.98);
                transform: scale(.98);
                opacity: 0
            }
            95% {
                -webkit-transform: scale(1.004);
                transform: scale(1.004)
            }
            100% {
                -webkit-transform: scale(1);
                transform: scale(1);
                opacity: 1
            }
        }

        @-webkit-keyframes modal {
            0% {
                top: 55%
            }
            100% {
                top: 50%
            }
        }

        @keyframes modal {
            0% {
                top: 55%
            }
            100% {
                top: 50%
            }
        }

        @-webkit-keyframes tabbed-modal {
            0% {
                opacity: 0;
                -webkit-transform: scale(.97);
                transform: scale(.97)
            }
            100% {
                opacity: 1;
                -webkit-transform: scale(1);
                transform: scale(1)
            }
        }

        @keyframes tabbed-modal {
            0% {
                opacity: 0;
                -webkit-transform: scale(.97);
                transform: scale(.97)
            }
            100% {
                opacity: 1;
                -webkit-transform: scale(1);
                transform: scale(1)
            }
        }

        @-webkit-keyframes rotate {
            0% {
                -webkit-transform: rotate(0deg);
                transform: rotate(0deg)
            }
            100% {
                -webkit-transform: rotate(360deg);
                transform: rotate(360deg)
            }
        }

        @keyframes rotate {
            0% {
                -webkit-transform: rotate(0deg);
                transform: rotate(0deg)
            }
            100% {
                -webkit-transform: rotate(360deg);
                transform: rotate(360deg)
            }
        }

        @-webkit-keyframes animation-hue-rotate {
            0% {
                -webkit-filter: hue-rotate(0deg);
                filter: hue-rotate(0deg)
            }
            100% {
                -webkit-filter: hue-rotate(-100deg);
                filter: hue-rotate(-100deg)
            }
        }

        @keyframes animation-hue-rotate {
            0% {
                -webkit-filter: hue-rotate(0deg);
                filter: hue-rotate(0deg)
            }
            100% {
                -webkit-filter: hue-rotate(-100deg);
                filter: hue-rotate(-100deg)
            }
        }

        @-webkit-keyframes shine {
            100% {
                left: 125%
            }
        }

        @keyframes shine {
            100% {
                left: 125%
            }
        }

        .grid-guide {
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
            position: fixed;
            z-index: 5999997
        }

        .grid-guide-vert-inner {
            max-width: 75rem;
            margin: 0 auto;
            height: 100%;
            padding: 0 .938rem
        }

        @media only screen and (min-width: 40.625rem) {
            .grid-guide-vert-inner {
                padding: 0 2.5rem
            }
        }

        .grid-guide-col {
            float: left;
            margin-right: 2%;
            width: 2.25%;
            background: rgba(100, 100, 225, .25);
            height: 100%
        }

        .grid-guide-col:last-child {
            margin: 0
        }

        .grid-guide-row {
            background: rgba(100, 100, 225, .25)
        }

        html {
            font-family: breakpoint-0
        }

        @media only screen and (min-width: 17.5rem) {
            html {
                font-family: breakpoint-280
            }
        }

        @media only screen and (min-width: 20rem) {
            html {
                font-family: breakpoint-320
            }
        }

        @media only screen and (min-width: 25rem) {
            html {
                font-family: breakpoint-400
            }
        }

        @media only screen and (min-width: 28.125rem) {
            html {
                font-family: breakpoint-450
            }
        }

        @media only screen and (min-width: 30rem) {
            html {
                font-family: breakpoint-480
            }
        }

        @media only screen and (min-width: 31.25rem) {
            html {
                font-family: breakpoint-500
            }
        }

        @media only screen and (min-width: 34.375rem) {
            html {
                font-family: breakpoint-550
            }
        }

        @media only screen and (min-width: 37.5rem) {
            html {
                font-family: breakpoint-600
            }
        }

        @media only screen and (min-width: 40.625rem) {
            html {
                font-family: breakpoint-650
            }
        }

        @media only screen and (min-width: 43.75rem) {
            html {
                font-family: breakpoint-700
            }
        }

        @media only screen and (min-width: 48rem) {
            html {
                font-family: breakpoint-768
            }
        }

        @media only screen and (min-width: 50rem) {
            html {
                font-family: breakpoint-800
            }
        }

        @media only screen and (min-width: 61.25rem) {
            html {
                font-family: breakpoint-980
            }
        }

        @media only screen and (min-width: 62.5rem) {
            html {
                font-family: breakpoint-1000
            }
        }

        @media only screen and (min-width: 64rem) {
            html {
                font-family: breakpoint-1024
            }
        }

        @media only screen and (min-width: 73.75rem) {
            html {
                font-family: breakpoint-1180
            }
        }

        @media only screen and (min-width: 75rem) {
            html {
                font-family: breakpoint-1200
            }
        }

        @media only screen and (min-width: 100rem) {
            html {
                font-family: breakpoint-1600
            }
        }

        head {
            font-family: '{"mobile":320,"mobile-wide":480,"tablet":650,"tablet-wide":768,"desktop":980,"desktop-wide":1180,"desktop-max":1200,"desktop-extra-wide":1600}'
        }

        .standard-body-content {
            font-family: Helvetica, Arial, Sans-serif;
            font-size: 1rem;
            line-height: 1.2;
            color: #000
        }

        .recirculation-module-feed-link, .recirculation-module-item-title, .recirculation-module-item-title a, .transporter-hed, .seo-tag .seo-link, .footer a, .embed-related-content .item-title.recirculation-module-item-title, .syndicate-source-link a, .end-of-content-title, .end-of-content-title a {
            transition: color .3s ease-in-out;
            text-decoration: none
        }

        @media only screen and (min-width: 61.25rem) {
            .recirculation-module-feed-link:hover, .recirculation-module-item-title:hover, .recirculation-module-item-title a:hover, .transporter-hed:hover, .seo-tag .seo-link:hover, .footer a:hover, .embed-related-content .item-title.recirculation-module-item-title:hover, .syndicate-source-link a:hover, .end-of-content-title:hover, .end-of-content-title a:hover {
                color: #fff
            }
        }

        .standard-body-content {
            font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
            font-size: 1.0625rem;
            line-height: 1.8;
            color: #000;
            letter-spacing: .02em;
            -webkit-font-smoothing: antialiased
        }

        .search-input, .search-input::-webkit-input-placeholder {
            font-family: TriviaSerif, Georgia, Times, Serif;
            font-size: 1.875rem;
            line-height: 1.1;
            color: #000;
            letter-spacing: -.03rem;
            font-weight: 400
        }

        .search-input, .search-input:-ms-input-placeholder {
            font-family: TriviaSerif, Georgia, Times, Serif;
            font-size: 1.875rem;
            line-height: 1.1;
            color: #000;
            letter-spacing: -.03rem;
            font-weight: 400
        }

        .search-input, .search-input::placeholder {
            font-family: TriviaSerif, Georgia, Times, Serif;
            font-size: 1.875rem;
            line-height: 1.1;
            color: #000;
            letter-spacing: -.03rem;
            font-weight: 400
        }

        @media only screen and (min-width: 30rem) {
            .search-input, .search-input::-webkit-input-placeholder {
                font-size: 2.5rem;
                line-height: 1.1
            }

            .search-input, .search-input:-ms-input-placeholder {
                font-size: 2.5rem;
                line-height: 1.1
            }

            .search-input, .search-input::placeholder {
                font-size: 2.5rem;
                line-height: 1.1
            }
        }

        @media only screen and (min-width: 40.625rem) {
            .search-input, .search-input::-webkit-input-placeholder {
                font-size: 3rem;
                line-height: 1
            }

            .search-input, .search-input:-ms-input-placeholder {
                font-size: 3rem;
                line-height: 1
            }

            .search-input, .search-input::placeholder {
                font-size: 3rem;
                line-height: 1
            }
        }

        @media only screen and (min-width: 61.25rem) {
            .search-input, .search-input::-webkit-input-placeholder {
                font-size: 3.5rem;
                line-height: 1.1
            }

            .search-input, .search-input:-ms-input-placeholder {
                font-size: 3.5rem;
                line-height: 1.1
            }

            .search-input, .search-input::placeholder {
                font-size: 3.5rem;
                line-height: 1.1
            }
        }

        .recirculation-module-feed-link, .recirculation-module-item-title, .recirculation-module-item-title a, .transporter-hed, .seo-tag .seo-link, .footer a, .embed-related-content .item-title.recirculation-module-item-title, .syndicate-source-link a, .end-of-content-title, .end-of-content-title a {
            text-decoration: none;
            transition: color .3s ease-in-out
        }

        @media only screen and (min-width: 61.25rem) {
            .recirculation-module-feed-link:hover, .recirculation-module-item-title:hover, .recirculation-module-item-title a:hover, .transporter-hed:hover, .seo-tag .seo-link:hover, .footer a:hover, .embed-related-content .item-title.recirculation-module-item-title:hover, .syndicate-source-link a:hover, .end-of-content-title:hover, .end-of-content-title a:hover {
                color: #e9328c
            }
        }

        .standard-body-content p a, .standard-body-content .body-h2 a, .standard-body-content .body-h3 a, .standard-body-content .body-h4 a, .standard-body-content .body-ul a, .standard-body-content .body-ol a, .embed-image-info figcaption a, .syndicate-source-link a {
            transition: color .3s ease-in-out;
            color: #676767;
            text-decoration: underline
        }

        @media only screen and (min-width: 61.25rem) {
            .standard-body-content p a:hover, .standard-body-content .body-h2 a:hover, .standard-body-content .body-h3 a:hover, .standard-body-content .body-h4 a:hover, .standard-body-content .body-ul a:hover, .standard-body-content .body-ol a:hover, .embed-image-info figcaption a:hover, .syndicate-source-link a:hover {
                color: #000
            }
        }

        .transporter-simple-item .item-title {
            text-decoration: none;
            transition: color .3s ease-in-out, text-stroke .3s ease-in-out
        }

        @media only screen and (min-width: 61.25rem) {
            .transporter-simple-item .item-title:hover {
                color: #e9328c;
                -webkit-text-stroke: .01rem #e9328c
            }
        }

        .recirculation-module-item {
            display: none;
            float: left;
            width: 50%
        }

        .recirculation-module-item:nth-child(-n+2) {
            display: block
        }

        .recirculation-module-item .item-title {
            padding: 0 .938rem;
            display: block
        }

        .recirculation-module-item .item-image {
            margin-bottom: .625rem
        }

        @media only screen and (min-width: 40.625rem) {
            .recirculation-module-item {
                width: 33.3333333333%
            }

            .recirculation-module-item:nth-child(-n+3) {
                display: block
            }
        }

        .embed-iframe {
            position: relative;
            clear: both
        }

        .embed-iframe .embed-inner {
            position: relative
        }

        .embed-iframe .embed-inner:before {
            content: "";
            display: block;
            width: 100%;
            padding-bottom: 56.25%
        }

        .embed-iframe .embed-inner > * {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%
        }

        .embed-image-center.embed-image-large {
            width: 100vw;
            position: relative;
            left: calc(-50vw + 50%)
        }

        .social-menu-button .social-button-link, .embed-image-social-button .social-button-link {
            display: block;
            width: 100%;
            text-align: center;
            text-decoration: none
        }

        .social-menu-button .social-button-icon, .embed-image-social-button .social-button-icon {
            font-size: 1.063rem
        }

        .footer-social-menu-item .social-button-link {
            text-decoration: none
        }

        .social-menu-button .social-button-link, .embed-image-social-button .social-button-link {
            color: #fff
        }

        .social-button-facebook.social-menu-button, .social-button-facebook.embed-image-social-button {
            background-color: #3b5998
        }

        .social-button-pinterest.social-menu-button, .social-button-pinterest.embed-image-social-button {
            background-color: #c92228
        }

        .social-button-twitter.social-menu-button, .social-button-twitter.embed-image-social-button {
            background-color: #00aced
        }

        .social-button-googleplus.social-menu-button, .social-button-googleplus.embed-image-social-button {
            background-color: #dd4b39
        }

        .social-button-youtube.social-menu-button, .social-button-youtube.embed-image-social-button {
            background-color: #b00
        }

        .social-button-email.social-menu-button, .social-button-email.embed-image-social-button {
            background-color: #333
        }

        .social-button-instagram.social-menu-button, .social-button-instagram.embed-image-social-button {
            background-color: #517fa4
        }

        .social-button-tumblr.social-menu-button, .social-button-tumblr.embed-image-social-button {
            background-color: #35465c
        }

        .social-button-reddit.social-menu-button, .social-button-reddit.embed-image-social-button {
            background-color: #ff4500
        }

        .social-button-whatsapp.social-menu-button, .social-button-whatsapp.embed-image-social-button {
            background-color: #5cbe4a
        }

        .social-button-line.social-menu-button, .social-button-line.embed-image-social-button {
            background-color: #00c300
        }

        .social-button-facebook.footer-social-menu-item .social-button-link:hover {
            color: #3b5998
        }

        .social-button-pinterest.footer-social-menu-item .social-button-link:hover {
            color: #c92228
        }

        .social-button-twitter.footer-social-menu-item .social-button-link:hover {
            color: #00aced
        }

        .social-button-googleplus.footer-social-menu-item .social-button-link:hover {
            color: #dd4b39
        }

        .social-button-youtube.footer-social-menu-item .social-button-link:hover {
            color: #b00
        }

        .social-button-email.footer-social-menu-item .social-button-link:hover {
            color: #333
        }

        .social-button-instagram.footer-social-menu-item .social-button-link:hover {
            color: #517fa4
        }

        .social-button-tumblr.footer-social-menu-item .social-button-link:hover {
            color: #35465c
        }

        .social-button-reddit.footer-social-menu-item .social-button-link:hover {
            color: #ff4500
        }

        .social-button-whatsapp.footer-social-menu-item .social-button-link:hover {
            color: #5cbe4a
        }

        .social-button-line.footer-social-menu-item .social-button-link:hover {
            color: #00c300
        }

        .social-menu-button {
            position: relative
        }

        .social-menu-button [class^=PIN_] {
            position: absolute;
            width: 100%;
            height: 100%;
            opacity: 0
        }

        .social-menu-button-group, .embed-image-social-button-group, .embed-pullquote-social-button-group {
            display: -webkit-flex;
            display: -ms-flexbox;
            display: flex;
            -webkit-flex-direction: row;
            -ms-flex-direction: row;
            flex-direction: row;
            -webkit-align-items: center;
            -ms-flex-align: center;
            align-items: center
        }

        .social-menu-button-group .social-button, .embed-image-social-button-group .social-button, .embed-pullquote-social-button-group .social-button {
            -webkit-flex-grow: 1;
            -ms-flex-positive: 1;
            flex-grow: 1
        }

        .search-input {
            background: transparent;
            border: 0;
            outline: none;
            padding: 0;
            width: 100%
        }

        .search-label {
            display: inline-block;
            width: 100%
        }

        @font-face {
            font-family: IconFont;
            src: url("/sites/cosmopolitan/assets/fonts/IconFont.woff2?cb=1494278239677") format("woff2"), url("/sites/cosmopolitan/assets/fonts/IconFont.woff?cb=1494278239677") format("woff")
        }

        .icon {
            font-family: IconFont;
            display: inline-block;
            vertical-align: middle;
            line-height: 1;
            font-weight: 400;
            font-style: normal;
            speak: none;
            text-decoration: inherit;
            text-transform: none;
            text-rendering: auto;
            -webkit-font-smoothing: antialiased;
            -moz-osx-font-smoothing: grayscale
        }

        .icon-author:before {
            content: "\f101"
        }

        .icon-expand-arrows:before {
            content: "\f102"
        }

        .icon-gallery:before {
            content: "\f103"
        }

        .icon-grid-view:before {
            content: "\f104"
        }

        .icon-heart:before {
            content: "\f105"
        }

        .icon-magnify:before {
            content: "\f106"
        }

        .icon-menu:before {
            content: "\f107"
        }

        .icon-play:before {
            content: "\f108"
        }

        .icon-search:before {
            content: "\f109"
        }

        .icon-rating-empty:before {
            content: "\f10a"
        }

        .icon-rating-half:before {
            content: "\f10b"
        }

        .icon-rating:before {
            content: "\f10c"
        }

        .icon-arrow-down01:before {
            content: "\f10d"
        }

        .icon-arrow-down02:before {
            content: "\f10e"
        }

        .icon-arrow-left01:before {
            content: "\f10f"
        }

        .icon-arrow-left02:before {
            content: "\f110"
        }

        .icon-arrow-right01:before {
            content: "\f111"
        }

        .icon-arrow-right02:before {
            content: "\f112"
        }

        .icon-arrow-up01:before {
            content: "\f113"
        }

        .icon-article:before {
            content: "\f114"
        }

        .icon-audio:before {
            content: "\f115"
        }

        .icon-avatar:before {
            content: "\f116"
        }

        .icon-clock:before {
            content: "\f117"
        }

        .icon-close01:before {
            content: "\f118"
        }

        .icon-collection:before {
            content: "\f119"
        }

        .icon-comments:before {
            content: "\f11a"
        }

        .icon-comments02:before {
            content: "\f11b"
        }

        .icon-email:before {
            content: "\f11c"
        }

        .icon-facebook:before {
            content: "\f11d"
        }

        .icon-googleplus:before {
            content: "\f11e"
        }

        .icon-info:before {
            content: "\f11f"
        }

        .icon-instagram:before {
            content: "\f120"
        }

        .icon-lightbulb:before {
            content: "\f121"
        }

        .icon-link-out-arrow:before {
            content: "\f122"
        }

        .icon-linked-in:before {
            content: "\f123"
        }

        .icon-list:before {
            content: "\f124"
        }

        .icon-loader:before {
            content: "\f125"
        }

        .icon-logo01:before {
            content: "\f126"
        }

        .icon-logo02:before {
            content: "\f127"
        }

        .icon-minus:before {
            content: "\f128"
        }

        .icon-pinterest:before {
            content: "\f129"
        }

        .icon-play-vid:before {
            content: "\f12a"
        }

        .icon-plus:before {
            content: "\f12b"
        }

        .icon-quiz:before {
            content: "\f12c"
        }

        .icon-quote:before {
            content: "\f12d"
        }

        .icon-reddit:before {
            content: "\f12e"
        }

        .icon-share:before {
            content: "\f12f"
        }

        .icon-share02:before {
            content: "\f130"
        }

        .icon-sign-out:before {
            content: "\f131"
        }

        .icon-tumblr:before {
            content: "\f132"
        }

        .icon-twitter:before {
            content: "\f133"
        }

        .icon-youtube:before {
            content: "\f134"
        }

        .icon-circle-plus:before {
            content: "\f135"
        }

        .icon-feature:before {
            content: "\f136"
        }

        .icon-recipe:before {
            content: "\f137"
        }

        .icon-whatsapp:before {
            content: "\f138"
        }

        .search-input, .search-input::-webkit-input-placeholder {
            color: #2c2c2c;
            text-transform: lowercase;
            line-height: 2.1875rem
        }

        .search-input, .search-input:-ms-input-placeholder {
            color: #2c2c2c;
            text-transform: lowercase;
            line-height: 2.1875rem
        }

        .search-input, .search-input::placeholder {
            color: #2c2c2c;
            text-transform: lowercase;
            line-height: 2.1875rem
        }

        @media only screen and (min-width: 30rem) {
            .search-input, .search-input::-webkit-input-placeholder {
                line-height: 3.125rem
            }

            .search-input, .search-input:-ms-input-placeholder {
                line-height: 3.125rem
            }

            .search-input, .search-input::placeholder {
                line-height: 3.125rem
            }
        }

        @media only screen and (min-width: 40.625rem) {
            .search-input, .search-input::-webkit-input-placeholder {
                line-height: 4.6875rem
            }

            .search-input, .search-input:-ms-input-placeholder {
                line-height: 4.6875rem
            }

            .search-input, .search-input::placeholder {
                line-height: 4.6875rem
            }
        }

        .search-label {
            font-family: Sofia, Helvetica, Arial, Sans-serif;
            font-size: 1rem;
            line-height: 1.3;
            color: #2c2c2c;
            padding-top: .9375rem;
            border-top: .0625rem solid #e4e4e4
        }

        img.click-to-play-animated, picture.click-to-play-animated {
            display: none !important;
            position: absolute;
            top: 0
        }

        img.click-to-play-animated, .crop-original img.click-to-play-animated, picture.click-to-play-animated, .crop-original picture.click-to-play-animated {
            width: 100%
        }

        img.click-to-play-animated.active, picture.click-to-play-animated.active {
            display: block !important
        }

        .click-to-play-button {
            position: absolute;
            left: 50%;
            top: 50%;
            -webkit-transform: translate(-50%, -50%);
            transform: translate(-50%, -50%);
            -webkit-appearance: none;
            -moz-appearance: none;
            appearance: none;
            border: 0;
            border-radius: 50%;
            content: "";
            display: block;
            height: 4.375rem;
            outline: none;
            padding: 0;
            width: 4.375rem
        }

        .click-to-play-animated.active + .click-to-play-button {
            display: none
        }

        .click-to-play-button .icon {
            font-size: 1.875rem;
            line-height: 4.375rem
        }

        .item-image .click-to-play-button {
            display: none
        }

        .click-to-play-button {
            background-color: rgba(243, 243, 243, .4)
        }

        .click-to-play-button .icon {
            color: #000;
            padding-left: .4rem
        }

        .sponsor-bar.brand-logo .sponsor-label svg {
            height: 1.125rem
        }

        @media only screen and (min-width: 40.625rem) {
            .sponsor-bar.brand-logo .sponsor-label svg {
                height: 1.3rem
            }
        }

        @media only screen and (min-width: 61.25rem) {
            .sponsor-bar.brand-logo .sponsor-label svg {
                height: 1.5rem
            }
        }

        .sponsor-bar .sponsor-image img, .sponsor-bar.brand-logo .sponsor-image img {
            max-height: 2.5rem;
            max-width: 9.375rem
        }

        @media only screen and (min-width: 40.625rem) {
            .sponsor-bar .sponsor-image img, .sponsor-bar.brand-logo .sponsor-image img {
                max-width: 10rem
            }
        }

        @media only screen and (min-width: 61.25rem) {
            .sponsor-bar .sponsor-image img, .sponsor-bar.brand-logo .sponsor-image img {
                max-width: 10.9375rem
            }
        }

        .sponsor-label {
            display: inline-block
        }

        .sponsor-image {
            display: inline-block
        }

        .sponsor-bar {
            display: -webkit-flex;
            display: -ms-flexbox;
            display: flex;
            -webkit-align-items: center;
            -ms-flex-align: center;
            align-items: center;
            -webkit-justify-content: center;
            justify-content: center;
            -ms-flex-pack: center;
            text-align: center;
            z-index: 5999995;
            height: 3.375rem
        }

        .sponsor-bar .sponsor-bar-inner {
            display: -webkit-flex;
            display: -ms-flexbox;
            display: flex;
            -webkit-align-items: center;
            -ms-flex-align: center;
            align-items: center;
            -webkit-justify-content: center;
            justify-content: center;
            -ms-flex-pack: center
        }

        @media only screen and (min-width: 61.25rem) {
            .sponsor-bar {
                display: block;
                height: auto
            }

            .sponsor-bar .sponsor-bar-inner {
                display: block
            }
        }

        .sponsor-bar.brand-logo {
            display: -webkit-flex;
            display: -ms-flexbox;
            display: flex;
            -webkit-align-items: center;
            -ms-flex-align: center;
            align-items: center;
            -webkit-justify-content: center;
            justify-content: center;
            -ms-flex-pack: center
        }

        .sponsor-bar.brand-logo .sponsor-bar-inner {
            display: -webkit-flex;
            display: -ms-flexbox;
            display: flex;
            -webkit-align-items: center;
            -ms-flex-align: center;
            align-items: center;
            -webkit-justify-content: center;
            justify-content: center;
            -ms-flex-pack: center
        }

        .sponsor-bar.brand-logo .sponsor-label {
            line-height: 0
        }

        .sponsor-bar.brand-logo .sponsor-image {
            line-height: 0
        }

        .sponsor-bar.sponsored-by .sponsor-label, .sponsor-bar.provided-by .sponsor-label, .sponsor-bar.created-for .sponsor-label, .sponsor-bar.custom-label .sponsor-label {
            display: block
        }

        .sponsor-bar.sponsored-by .sponsor-image, .sponsor-bar.provided-by .sponsor-image, .sponsor-bar.created-for .sponsor-image, .sponsor-bar.custom-label .sponsor-image {
            display: block;
            margin: 0 auto;
            line-height: 0
        }

        .sponsor-bar.sticky {
            -webkit-transform: none;
            transform: none;
            position: fixed;
            max-width: 100%;
            left: 0;
            right: 0;
            top: 0;
            margin: 0 auto;
            z-index: 5999995
        }

        @media only screen and (min-width: 61.25rem) {
            .sponsor-bar.sticky {
                top: 3.375rem
            }
        }

        .sponsor-bar.sticky + .sponsor-bar-placeholder {
            position: static
        }

        .sponsor-bar-placeholder {
            position: absolute
        }

        .sponsor-inline {
            line-height: 1
        }

        .sponsor.created-for .created-for--long {
            display: none
        }

        .sponsor.created-for .created-for--xshort {
            display: none
        }

        .sponsor.created-for .created-for--short {
            display: inline-block
        }

        @media only screen and (min-width: 61.25rem) {
            .sponsor.created-for .created-for--long {
                display: inline-block
            }

            .sponsor.created-for .created-for--short {
                display: none
            }
        }

        .sponsor.custom-label .custom-label--long {
            display: none
        }

        .sponsor.custom-label .custom-label--xshort {
            display: none
        }

        .sponsor.custom-label .custom-label--short {
            display: inline-block
        }

        @media only screen and (min-width: 61.25rem) {
            .sponsor.custom-label .custom-label--long {
                display: inline-block
            }

            .sponsor.custom-label .custom-label--short {
                display: none
            }
        }

        .top-pathing .created-for .created-for--long, .top-pathing .created-for .created-for--short {
            display: none
        }

        .top-pathing .created-for .created-for--xshort {
            display: inline-block
        }

        .top-pathing .custom-label .custom-label--long, .top-pathing .custom-label .custom-label--short {
            display: none
        }

        .top-pathing .custom-label .custom-label--xshort {
            display: inline-block
        }

        .top-pathing .sponsor-inline {
            margin-bottom: 0;
            padding-bottom: 0
        }

        .sponsor + .item-title {
            margin-top: 0;
            padding-top: 0
        }

        .feed-header.sponsored-header, .content-header.sponsored-header {
            margin-top: 0;
            padding-top: 0
        }

        @media only screen and (min-width: 40.625rem) {
            .standard-body-content p, .standard-body-content .recirculation-module, .standard-body-content .body-h2, .standard-body-content .body-h3, .standard-body-content .body-h4, .standard-body-content .body-ol, .standard-body-content .body-ul, .standard-body-content .body-tip, .standard-body-content .opinion-disclaimer, .standard-body-content hr, .standard-body-content .embed-rating, .standard-body-content .embed-center {
                margin-left: 4.25%;
                margin-right: 4.25%
            }
        }

        @media only screen and (min-width: 61.25rem) {
            .standard-body-content p, .standard-body-content .recirculation-module, .standard-body-content .body-h2, .standard-body-content .body-h3, .standard-body-content .body-h4, .standard-body-content .body-ol, .standard-body-content .body-ul, .standard-body-content .body-tip, .standard-body-content .opinion-disclaimer, .standard-body-content hr, .standard-body-content .embed-rating, .standard-body-content .embed-center {
                margin-left: 6.4393939394%;
                margin-right: 0
            }
        }

        .standard-container {
            position: relative;
            margin-bottom: 1.25rem
        }

        .standard-rail {
            display: none
        }

        @media only screen and (min-width: 61.25rem) {
            .standard-rail {
                width: 32%;
                display: block;
                float: right;
                min-height: 37.5rem
            }

            .standard-rail .ad-container {
                float: right
            }
        }

        @media only screen and (min-width: 61.25rem) {
            .standard-body {
                float: left;
                margin-right: 2%;
                width: 66%
            }
        }

        .standard-info {
            margin-bottom: 1.25rem
        }

        .standard-body-content .body-ol, .standard-body-content .body-ul {
            margin-bottom: 1.25rem;
            padding: 0
        }

        .standard-body-content .body-ol {
            list-style-position: inside
        }

        .standard-body-content .body-blockquote {
            margin-left: 0;
            margin-right: 0;
            clear: both
        }

        .standard-body-content .embed {
            margin-bottom: 1.25rem
        }

        .standard-body-content hr {
            margin-bottom: 1.25rem
        }

        .standard-body-content .embed-center {
            clear: both
        }

        .standard-body-content p {
            margin-top: 0;
            margin-bottom: 1.25rem
        }

        .standard-body-content .embed-image + .embed-image {
            clear: both
        }

        @media only screen and (min-width: 40.625rem) {
            .standard-body-content .body-tip {
                width: calc(100% - 1.876rem)
            }

            .standard-body-content .body-blockquote {
                margin-left: 4.25%;
                margin-right: 4.25%
            }
        }

        @media only screen and (min-width: 61.25rem) {
            .standard-body-content .body-tip {
                width: 93.5606060606%
            }

            .standard-body-content .body-blockquote {
                margin-left: 6.4393939394%;
                margin-right: 0
            }

            .standard-body-content .recirculation-module {
                padding-left: 0
            }

            .standard-body-content .image-credit {
                padding-left: 0
            }
        }

        @media only screen and (min-width: 61.25rem) {
            .embed {
                margin-left: 6.4393939394%
            }
        }

        .embed-image picture {
            display: block;
            overflow: hidden
        }

        .embed-image picture img {
            display: block;
            width: 100%;
            min-height: .0625rem
        }

        .embed-image .crop-original {
            margin-left: auto;
            margin-right: auto
        }

        .embed-image-center {
            clear: both;
            margin-left: auto;
            margin-right: auto;
            text-align: center;
            width: 100%
        }

        .embed-image-center.embed-image-extrasmall {
            width: 49%
        }

        @media only screen and (min-width: 40.625rem) {
            .embed-image-center.embed-image-extrasmall {
                width: 32%
            }
        }

        @media only screen and (min-width: 61.25rem) {
            .embed-image-center.embed-image-extrasmall {
                margin-left: 32.196969697%;
                width: 42.0454545455%
            }
        }

        .embed-image-center.embed-image-small {
            width: 49%
        }

        @media only screen and (min-width: 40.625rem) {
            .embed-image-center.embed-image-small {
                width: 66%
            }
        }

        @media only screen and (min-width: 61.25rem) {
            .embed-image-center.embed-image-small {
                width: 67.803030303%
            }
        }

        @media only screen and (min-width: 40.625rem) {
            .embed-image-center.embed-image-medium {
                width: 91.5%
            }
        }

        @media only screen and (min-width: 61.25rem) {
            .embed-image-center.embed-image-medium {
                margin-left: 6.4393939394%;
                width: 93.5606060606%
            }
        }

        @media only screen and (min-width: 61.25rem) {
            .embed-image-center.embed-image-large {
                width: 100%;
                left: auto
            }
        }

        .embed-image-center.embed-image-screenheight {
            width: 100%
        }

        @media only screen and (min-width: 61.25rem) {
            .embed-image-center.embed-image-screenheight {
                margin-left: 6.4393939394%;
                width: 93.5606060606%
            }
        }

        .embed-image-center.embed-image-screenheight img {
            width: auto;
            height: 85vh;
            max-width: 100%;
            max-height: 100%;
            margin: 0 auto
        }

        .embed-image-center.embed-image-screenheight .embed-inner, .embed-image-center.embed-image-screenheight .embed-image-wrap, .embed-image-center.embed-image-screenheight .zoomable {
            max-height: 85vh
        }

        .embed-image-left {
            margin-left: 0
        }

        .embed-image-left.embed-image-small {
            clear: left;
            float: left;
            margin-right: 2%;
            width: 40.5%
        }

        @media only screen and (min-width: 40.625rem) {
            .embed-image-left.embed-image-small {
                width: 23.5%
            }
        }

        @media only screen and (min-width: 61.25rem) {
            .embed-image-left.embed-image-small {
                margin-right: 3.0303030303%;
                width: 22.7272727273%
            }
        }

        @media only screen and (min-width: 40.625rem) {
            .embed-image-left.embed-image-medium {
                clear: left;
                float: left;
                margin-right: 2%;
                width: 40.5%
            }
        }

        @media only screen and (min-width: 61.25rem) {
            .embed-image-left.embed-image-medium {
                margin-right: 3.0303030303%;
                width: 35.6060606061%
            }
        }

        @media only screen and (min-width: 40.625rem) {
            .embed-image-left.embed-image-large {
                clear: left;
                float: left;
                margin-right: 2%;
                width: 49%
            }
        }

        @media only screen and (min-width: 61.25rem) {
            .embed-image-left.embed-image-large {
                margin-right: 3.0303030303%;
                width: 48.4848484848%
            }
        }

        .embed-image-right.embed-image-small {
            clear: right;
            float: right;
            margin-left: 2%;
            width: 40.5%
        }

        @media only screen and (min-width: 40.625rem) {
            .embed-image-right.embed-image-small {
                width: 23.5%
            }
        }

        @media only screen and (min-width: 61.25rem) {
            .embed-image-right.embed-image-small {
                margin-left: 3.0303030303%;
                width: 22.7272727273%
            }
        }

        @media only screen and (min-width: 40.625rem) {
            .embed-image-right.embed-image-medium {
                clear: right;
                float: right;
                margin-left: 2%;
                width: 40.5%
            }
        }

        @media only screen and (min-width: 61.25rem) {
            .embed-image-right.embed-image-medium {
                margin-left: 3.0303030303%;
                width: 35.6060606061%
            }
        }

        @media only screen and (min-width: 40.625rem) {
            .embed-image-right.embed-image-large {
                clear: right;
                float: right;
                margin-left: 2%;
                width: 49%
            }
        }

        @media only screen and (min-width: 61.25rem) {
            .embed-image-right.embed-image-large {
                width: 48.4848484848%;
                margin-left: 3.0303030303%
            }
        }

        .embed-pullquote-align-left {
            width: 100%
        }

        @media only screen and (min-width: 40.625rem) {
            .embed-pullquote-align-left {
                float: left;
                width: 44.75%;
                margin-right: 2%
            }
        }

        @media only screen and (min-width: 61.25rem) {
            .embed-pullquote-align-left {
                float: left;
                margin-right: 2%;
                width: 48.4848484848%;
                margin-left: 0;
                margin-right: 3.0303030303%
            }
        }

        .embed-pullquote-align-center {
            width: 100%
        }

        @media only screen and (min-width: 40.625rem) {
            .embed-pullquote-align-center {
                margin-left: 4.25%;
                margin-right: 4.25%;
                margin-bottom: .9375rem;
                width: 91.5%
            }
        }

        @media only screen and (min-width: 61.25rem) {
            .embed-pullquote-align-center {
                margin-left: 6.4393939394%;
                margin-right: 0;
                margin-bottom: 1rem;
                width: auto
            }
        }

        .embed-pullquote-align-right {
            width: 100%
        }

        @media only screen and (min-width: 40.625rem) {
            .embed-pullquote-align-right {
                width: 44.75%;
                margin-left: 51%
            }
        }

        @media only screen and (min-width: 61.25rem) {
            .embed-pullquote-align-right {
                width: 48.4848484848%;
                margin-left: 51.5151515152%
            }
        }

        .body-dropcap:first-letter {
            float: left
        }

        .embed-related-content {
            margin-left: auto;
            margin-right: auto;
            width: 100%
        }

        @media only screen and (min-width: 40.625rem) {
            .embed-related-content {
                width: 91.5%;
                margin-left: 4.375%
            }
        }

        @media only screen and (min-width: 61.25rem) {
            .embed-related-content {
                width: 93.5606060606%;
                margin-left: 6.4393939394%
            }
        }

        .embed-related-content .image-container {
            float: left;
            margin-right: 2%;
            width: 27.75%
        }

        @media only screen and (min-width: 30rem) {
            .embed-related-content .image-container {
                width: 23.5%
            }
        }

        @media only screen and (min-width: 40.625rem) {
            .embed-related-content .image-container {
                margin-right: 2.1857923497%;
                width: 21.0382513661%
            }
        }

        @media only screen and (min-width: 48rem) {
            .embed-related-content .image-container {
                width: 25.6830601093%
            }
        }

        @media only screen and (min-width: 61.25rem) {
            .embed-related-content .image-container {
                margin-right: 3.0303030303%;
                width: 24.2914979757%
            }
        }

        .embed-related-content .info-container {
            float: left;
            width: auto
        }

        @media only screen and (min-width: 40.625rem) {
            .embed-video.embed-video-center-small {
                width: 91.5%;
                margin-left: 4.375%
            }
        }

        @media only screen and (min-width: 61.25rem) {
            .embed-video.embed-video-center-small {
                width: 93.5606060606%;
                margin-left: 6.4393939394%
            }
        }

        @media only screen and (min-width: 61.25rem) {
            .embed-video.embed-video-center-large {
                width: 100%;
                margin-left: 0
            }
        }

        @media only screen and (min-width: 40.625rem) {
            .embed-video.embed-video-left-large {
                float: left;
                width: 57.5%;
                margin-right: 4.375%
            }
        }

        @media only screen and (min-width: 61.25rem) {
            .embed-video.embed-video-left-large {
                width: 61.3636363636%;
                margin-left: 0
            }
        }

        @media only screen and (min-width: 40.625rem) {
            .embed-video.embed-video-right-large {
                float: right;
                width: 57.5%;
                margin-left: 4.375%
            }
        }

        @media only screen and (min-width: 61.25rem) {
            .embed-video.embed-video-right-large {
                width: 54.9242424242%
            }
        }

        @media only screen and (min-width: 61.25rem) {
            .embed-youtube-playlist {
                width: 93.5606060606%
            }
        }

        .standard-body-content .body-h2, .standard-body-content .body-h3, .standard-body-content .body-h4 {
            margin-bottom: .625rem
        }

        .standard-body-content .body-tip, .standard-body-content .body-blockquote {
            margin-top: 1.25rem;
            margin-bottom: 1.25rem
        }

        .standard-body-content .body-h2 {
            font-family: Sofia, Helvetica, Arial, Sans-serif;
            font-size: 1.5rem;
            line-height: 1.3;
            letter-spacing: -.05rem;
            padding-bottom: .3125rem
        }

        @media only screen and (min-width: 40.625rem) {
            .standard-body-content .body-h2 {
                font-size: 1.75rem;
                line-height: 1.3
            }
        }

        @media only screen and (min-width: 61.25rem) {
            .standard-body-content .body-h2 {
                font-size: 2rem;
                line-height: 1.1
            }
        }

        .standard-body-content .body-h3 {
            font-family: TriviaSerif, Georgia, Times, Serif;
            font-size: 1.3125rem;
            line-height: 1.2;
            font-weight: 400;
            letter-spacing: -.03rem
        }

        @media only screen and (min-width: 40.625rem) {
            .standard-body-content .body-h3 {
                font-size: 1.5rem;
                line-height: 1.2
            }
        }

        @media only screen and (min-width: 61.25rem) {
            .standard-body-content .body-h3 {
                font-size: 1.75rem;
                line-height: 1.2
            }
        }

        .standard-body-content .body-h4 {
            font-family: Sofia, Helvetica, Arial, Sans-serif;
            font-size: 1.25rem;
            line-height: 1.2;
            letter-spacing: -.05rem
        }

        @media only screen and (min-width: 40.625rem) {
            .standard-body-content .body-h4 {
                font-size: 1.375rem;
                line-height: 1.1
            }
        }

        @media only screen and (min-width: 61.25rem) {
            .standard-body-content .body-h4 {
                font-size: 1.5rem;
                line-height: 1.3
            }
        }

        .standard-body-content .body-tip {
            font-family: Sofia, Helvetica, Arial, Sans-serif;
            font-size: 1.125rem;
            line-height: 1.2;
            border-top: .0625rem solid #7b7b7b;
            border-bottom: .0625rem solid #7b7b7b;
            padding: .9375rem .9375rem 1.25rem;
            text-align: center
        }

        @media only screen and (min-width: 40.625rem) {
            .standard-body-content .body-tip {
                font-size: 1.25rem;
                line-height: 1.2
            }
        }

        .standard-body-content .body-tip a {
            color: #000;
            text-decoration: none
        }

        .standard-body-content .body-blockquote {
            border-left: .25rem solid #000;
            color: #414141;
            padding: .625rem 1.25rem
        }

        .sponsor-bar.brand-logo .sponsor-label svg {
            max-width: 6.25rem
        }

        @media only screen and (min-width: 40.625rem) {
            .sponsor-bar.brand-logo .sponsor-label svg {
                max-width: 7.25rem
            }
        }

        @media only screen and (min-width: 61.25rem) {
            .sponsor-bar.brand-logo .sponsor-label svg {
                max-width: 8.375rem
            }
        }

        .sponsor-label, .sponsor-image {
            font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
            font-size: .6875rem;
            line-height: 1.5;
            color: #7b7b7b
        }

        .sponsor-bar.sponsored-by .sponsor-label, .sponsor-bar.provided-by .sponsor-label, .sponsor-bar.created-for .sponsor-label, .sponsor-bar.custom-label .sponsor-label {
            margin: 0 .5rem
        }

        @media only screen and (min-width: 61.25rem) {
            .sponsor-bar.sponsored-by .sponsor-label, .sponsor-bar.provided-by .sponsor-label, .sponsor-bar.created-for .sponsor-label, .sponsor-bar.custom-label .sponsor-label {
                margin-bottom: .5rem
            }
        }

        .sponsor-logo-separator {
            font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
            font-size: .875rem;
            line-height: 1.2;
            color: #7b7b7b;
            line-height: 1.4
        }

        .sponsor-bar {
            background-color: #f8f8f8;
            border-top: .0625rem solid #ececec;
            border-bottom: .0625rem solid #ececec;
            padding: .5rem 0
        }

        @media only screen and (min-width: 61.25rem) {
            .sponsor-bar {
                margin: 0 0 .9375rem
            }
        }

        .sponsor-bar .sponsor-logo-separator {
            font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
            font-size: 1.25rem;
            line-height: 0;
            color: #9f9f9f;
            margin: 0 .625rem;
            padding-bottom: .25rem
        }

        @media only screen and (min-width: 61.25rem) {
            .sponsor-bar.list-header-sponsor {
                margin: 0 0 .375rem
            }
        }

        .sponsor-bar.marquee-sponsor {
            margin: 0
        }

        .sponsor-bar.longform-sponsor {
            margin: 0;
            padding: .9375rem
        }

        .top-pathing .sponsor-inline {
            margin-top: .125rem;
            padding: 0 .625rem
        }

        .feed-list .sponsor-inline {
            margin-bottom: .625rem
        }

        @media only screen and (min-width: 40.625rem) {
            .feed-list .sponsor-inline {
                margin-bottom: .3125rem
            }
        }

        @media only screen and (min-width: 61.25rem) {
            .feed-list .sponsor-inline {
                float: left;
                clear: both
            }
        }

        .collection-breaker .sponsor-inline {
            padding: 0 .9375rem
        }

        @media only screen and (min-width: 61.25rem) {
            .collection-breaker .sponsor-inline {
                width: 100%;
                text-align: center;
                -webkit-transform: translate(0, -3rem);
                transform: translate(0, -3rem);
                transition: -webkit-transform .3s ease-in-out;
                transition: transform .3s ease-in-out
            }
        }

        .curated-breaker .sponsor-inline {
            padding: 0 .625rem
        }

        .feed-header .sponsor-inline {
            margin-bottom: .625rem
        }

        @media only screen and (min-width: 40.625rem) {
            .feed-header .sponsor-inline {
                margin-bottom: .25rem
            }
        }

        .sponsor-inline.feature-item-sponsor {
            text-align: center
        }

        @media only screen and (min-width: 40.625rem) {
            .sponsor-inline.feature-item-sponsor {
                margin-bottom: .625rem;
                text-align: left
            }
        }

        @media only screen and (min-width: 61.25rem) {
            .sponsor-inline.feature-item-sponsor {
                text-align: center
            }
        }

        .feed-grid .sponsor-inline {
            margin-top: .25rem
        }

        .recirculation-module .sponsor-inline {
            margin-top: .125rem;
            padding-left: .3125rem
        }

        @media only screen and (min-width: 61.25rem) {
            .recirculation-module .sponsor-inline {
                margin-top: .25rem
            }
        }

        .marquee-sponsor-wrap + .feed-grid {
            margin-top: 1.25rem
        }

        .grid-header-sponsor + .grid-header-title {
            text-align: center
        }

        .recirculation-module {
            display: none
        }

        @media only screen and (min-width: 61.25rem) {
            .recirculation-module {
                display: block;
                position: absolute;
                margin: 1.25rem 0;
                right: 2.5rem;
                width: 18.75rem;
                transition: opacity .3s ease;
                opacity: 0
            }

            .recirculation-module.active {
                opacity: 1
            }
        }

        @media only screen and (min-width: 61.25rem) {
            .recirculation-module-item {
                width: 100%;
                margin-bottom: 1.25rem
            }

            .recirculation-module-item.hidden {
                visibility: hidden
            }
        }

        .recirculation-module {
            border-bottom: 0;
            padding: 1.25rem 0 .9375rem
        }

        .recirculation-module-header {
            font-family: TriviaSerif, Georgia, Times, Serif;
            font-size: 1.5rem;
            line-height: 1.2;
            font-weight: 700;
            text-transform: uppercase;
            color: #000;
            padding-bottom: .3125rem;
            margin-bottom: .625rem
        }

        .recirculation-module-feed-link {
            color: #e9328c
        }

        .recirculation-module-item-title {
            font-family: Sofia, Helvetica, Arial, Sans-serif;
            font-size: .875rem;
            line-height: 1.4;
            color: #000;
            font-weight: 700;
            letter-spacing: -.05rem
        }

        @media only screen and (min-width: 61.25rem) {
            .recirculation-module-item-title {
                font-size: 1.125rem;
                line-height: 1.2
            }
        }

        .item-title.recirculation-module-item-title {
            padding-left: .3125rem
        }

        .recirculation-module-image {
            margin-bottom: .625rem
        }

        .social-menu {
            transition: bottom .3s ease-in-out;
            position: fixed;
            width: 100%;
            z-index: 999;
            bottom: -3.125rem;
            padding: .3125rem 0
        }

        .social-menu.active {
            bottom: 0
        }

        @media only screen and (min-width: 61.25rem) {
            .social-menu {
                transition: left .3s ease-in-out;
                width: auto;
                border: 0;
                padding: 0;
                bottom: 0;
                left: -2.5rem
            }

            .social-menu.active {
                left: 0
            }
        }

        @media only screen and (min-width: 61.25rem) {
            .social-menu-inner {
                padding: 0;
                width: 2.5rem
            }
        }

        @media only screen and (min-width: 61.25rem) {
            .social-menu-button-group {
                -webkit-flex-direction: column;
                -ms-flex-direction: column;
                flex-direction: column;
                margin: 0 1%
            }
        }

        .social-menu-button {
            width: 100%;
            height: 2.5rem;
            line-height: 2.5rem
        }

        .social-menu-button:last-child {
            margin-right: 0
        }

        .social-menu-button .social-button-label {
            display: none
        }

        @media only screen and (min-width: 40.625rem) {
            .social-menu-button .social-button-label {
                margin-left: .3125rem;
                display: inline-block
            }
        }

        @media only screen and (min-width: 61.25rem) {
            .social-menu-button .social-button-label {
                display: none
            }
        }

        .social-menu {
            background: rgba(242, 242, 242, .8);
            border-top: .0625rem solid #ececec
        }

        .social-menu-button .social-button-label {
            font-family: Sofia, Helvetica, Arial, Sans-serif;
            font-size: .875rem;
            line-height: 1.4;
            color: #fff;
            text-transform: uppercase
        }

        .horizontal-rule-mobile, .horizontal-rule-tablet {
            display: none
        }

        .transporter {
            margin-top: 1.875rem
        }

        .feed-transporter :nth-of-type(2), .feed-transporter :nth-of-type(2n+5) {
            /*margin-right: 0*/
        }

        @media only screen and (min-width: 61.25rem) {
            .feed-transporter :nth-of-type(2n+5) {
                margin-right: 2%
            }

            .feed-transporter :nth-of-type(5), .feed-transporter :nth-of-type(3n+8) {
                margin-right: 0
            }

            .feed-transporter :nth-of-type(4), .feed-transporter :nth-of-type(3n+6) {
                clear: left
            }
        }

        .transporter-simple-item {
            float: left;
            margin-right: .5%;
            width: 40%
        }

        .transporter-simple-item .item-title {
            display: block
        }

        @media only screen and (min-width: 61.25rem) {
            .transporter-simple-item {
                float: left;
                /*margin-right: 2%;*/
                width: 32%
            }
        }

        .transporter-header-inner {
            border-top: .125rem solid #000;
            padding: 1.25rem 0;
            text-align: center
        }

        .transporter-label {
            font-family: Sofia, Helvetica, Arial, Sans-serif;
            font-size: .625rem;
            line-height: 1.5;
            color: #000;
            text-transform: uppercase;
            border: .125rem solid #000;
            display: inline-block;
            padding: .3125rem .625rem
        }

        @media only screen and (min-width: 40.625rem) {
            .transporter-label {
                font-size: .75rem;
                line-height: 1
            }
        }

        .transporter-hed {
            font-family: TriviaSerif, Georgia, Times, Serif;
            font-size: 2.3125rem;
            line-height: 1;
            text-transform: capitalize;
            color: #000;
            font-weight: 700;
            letter-spacing: -.03rem;
            display: block;
            margin-top: .625rem
        }

        @media only screen and (min-width: 40.625rem) {
            .transporter-hed {
                font-size: 3.75rem;
                line-height: 1
            }
        }

        .transporter-simple-item {
            margin-bottom: 1.875rem
        }

        .transporter-simple-item .simple-item-sponsor {
            text-align: left
        }

        @media only screen and (min-width: 40.625rem) {
            .transporter-simple-item .simple-item-sponsor {
                text-align: center
            }
        }

        .transporter-simple-item .item-title {
            font-family: Sofia, Helvetica, Arial, Sans-serif;
            font-size: 1rem;
            line-height: 1.3;
            color: #000;
            text-align: left;
            letter-spacing: -.03rem;
            font-weight: 700
        }

        @media only screen and (min-width: 40.625rem) {
            .transporter-simple-item .item-title {
                font-family: TriviaSerif, Georgia, Times, Serif;
                font-size: 1rem;
                line-height: 1;
                text-align: center;
                font-weight: 400;
                -webkit-text-stroke: .01rem #000;
                -webkit-font-smoothing: auto
            }
        }

        @media only screen and (min-width: 40.625rem) and (min-width: 40.625rem) {
            .transporter-simple-item .item-title {
                font-size: 1.125rem;
                line-height: 1.4
            }
        }

        @media only screen and (min-width: 40.625rem) and (min-width: 48rem) {
            .transporter-simple-item .item-title {
                font-size: 1.25rem;
                line-height: 1.4
            }
        }

        @media only screen and (min-width: 40.625rem) and (min-width: 61.25rem) {
            .transporter-simple-item .item-title {
                font-size: 1.125rem;
                line-height: 1.4
            }
        }

        @media only screen and (min-width: 40.625rem) and (min-width: 73.75rem) {
            .transporter-simple-item .item-title {
                font-size: 1.5rem;
                line-height: 1.2
            }
        }

        .seo-tags-container {
            text-align: center
        }

        .seo-tag-list {
            list-style: none
        }

        .seo-tag-list {
            margin: 0;
            padding: 1.875rem 0 .625rem;
            border-top: .0625rem solid #7b7b7b
        }

        .seo-tag {
            display: inline-block;
            margin: 0 .3125rem .9375rem 0
        }

        .seo-tag .seo-link {
            font-family: Sofia, Helvetica, Arial, Sans-serif;
            font-size: .625rem;
            line-height: 1.5;
            color: #000;
            display: block;
            border: .0625rem solid #000;
            color: #7b7b7b;
            text-transform: uppercase;
            padding: .3125rem .625rem
        }

        .footer {
            background-color: #fff;
            opacity: 1 !important
        }

        .footer-inner {
            position: relative
        }

        @media only screen and (min-width: 40.625rem) {
            .footer-logo {
                float: left;
                margin-right: 2%;
                width: 40.5%
            }
        }

        @media only screen and (min-width: 61.25rem) {
            .footer-logo {
                float: left;
                margin-right: 2%;
                width: 19.25%
            }
        }

        .footer-logo a {
            display: block;
            font-size: 0
        }

        .footer-logo svg {
            max-width: 11.875rem;
            max-height: 2.1875rem
        }

        @media only screen and (min-width: 40.625rem) {
            .footer-social-menu {
                float: right
            }
        }

        @media only screen and (min-width: 61.25rem) {
            .footer-social-menu {
                position: absolute;
                top: 3.125rem;
                margin-bottom: 0
            }
        }

        .footer-social-menu-item {
            float: left
        }

        .footer-social-menu-item:last-child {
            margin-right: 0
        }

        .footer-social-menu-item .icon {
            font-size: 1.063rem
        }

        .footer-network-tagline {
            display: block
        }

        .footer-menu {
            width: 100%;
            padding: 0
        }

        @media only screen and (min-width: 40.625rem) {
            .footer-menu {
                clear: both
            }
        }

        @media only screen and (min-width: 61.25rem) {
            .footer-menu {
                float: left;
                margin-right: 0;
                width: 78.75%;
                margin-top: 0;
                clear: none
            }
        }

        .footer-menu-item {
            float: left;
            width: 50%
        }

        @media only screen and (min-width: 30rem) {
            .footer-menu-item {
                width: 33%
            }
        }

        @media only screen and (min-width: 48rem) {
            .footer-menu-item {
                width: 25%
            }
        }

        .footer-affiliate-disclosure {
            float: left;
            width: 100%
        }

        .footer-copyright {
            clear: both
        }

        @media only screen and (min-width: 61.25rem) {
            .footer-copyright {
                float: left;
                margin-right: 2%;
                width: 36.25%
            }
        }

        @media only screen and (min-width: 75rem) {
            .footer-copyright {
                float: left;
                margin-right: 2%;
                width: 44.75%
            }
        }

        .footer-legal-menu {
            margin: 0;
            padding: 0
        }

        @media only screen and (min-width: 61.25rem) {
            .footer-legal-menu {
                float: left;
                margin-right: 0;
                width: 61.75%
            }
        }

        @media only screen and (min-width: 75rem) {
            .footer-legal-menu {
                float: left;
                margin-right: 0;
                width: 53.25%
            }
        }

        .footer-legal-menu-item {
            display: inline-block
        }

        .footer {
            margin-top: .625rem;
            padding: 1.875rem 0
        }

        .footer-logo path {
            fill: #e9328c
        }

        .footer a {
            font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
            font-size: .75rem;
            line-height: 1.5;
            color: #000
        }

        .footer-logo {
            margin-bottom: 1.25rem
        }

        .footer-social-menu-item {
            margin-right: 1.25rem
        }

        @media only screen and (min-width: 61.25rem) {
            .footer-social-menu-item {
                margin-right: .625rem
            }
        }

        @media only screen and (min-width: 61.25rem) {
            .footer-menu {
                margin-bottom: 3.25rem
            }
        }

        .footer-network-tagline {
            font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
            font-size: .75rem;
            line-height: 1.5;
            color: #7b7b7b;
            margin-bottom: .625rem
        }

        .footer-legal-menu-item {
            padding-right: .9375rem
        }

        .footer-affiliate-disclosure {
            font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
            font-size: .6875rem;
            line-height: 1.5;
            color: #cdcdcd;
            margin-bottom: .625rem
        }

        .footer-copyright {
            font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
            font-size: .75rem;
            line-height: 1.5;
            color: #7b7b7b
        }

        .footer-menu-item.nav-item {
            margin: 0 0 .3125rem
        }

        .embed-image .embed-inner {
            position: relative
        }

        .embed-image .embed-inner .embed-image-wrap {
            position: relative
        }

        .embed-image .image-credit {
            text-align: left
        }

        .embed-image-social-button-group {
            position: absolute;
            bottom: 0;
            right: 0
        }

        .embed-image-info figcaption p {
            margin-left: 0;
            margin-bottom: 0
        }

        .embed-image-info .embed-image-credit {
            padding-left: 0
        }

        .embed-giphy .embed-inner:before {
            padding-bottom: 0
        }

        .embed-instagram iframe.instagram-media {
            box-shadow: none !important
        }

        @media only screen and (min-width: 40.625rem) {
            .embed-instagram iframe.instagram-media {
                border: .0625rem solid #ececec !important
            }
        }

        @media only screen and (min-width: 61.25rem) {
            .embed-instagram iframe.instagram-media {
                border: none !important;
                box-shadow: rgba(0, 0, 0, .498039) 0 0 1px 0, rgba(0, 0, 0, .14902) 0 1px 10px 0 !important
            }
        }

        .embed-spotify {
            max-height: 5rem
        }

        @media only screen and (min-width: 48rem) {
            .embed-spotify {
                max-height: 100%
            }
        }

        .embed-spotify iframe {
            max-height: 5rem
        }

        @media only screen and (min-width: 48rem) {
            .embed-spotify iframe {
                max-height: 100%
            }
        }

        .embed-pullquote p {
            margin: 0
        }

        .embed-pullquote .pullquote {
            margin: 0;
            padding: 0
        }

        .embed-pullquote-social-button:last-child {
            margin-right: 0
        }

        .embed-rating {
            color: #e9328c
        }

        .embed-rating .rating-prop {
            display: none
        }

        .embed-rating.embed-center {
            text-align: center
        }

        .embed-rating.embed-right {
            text-align: right
        }

        .embed-related-content {
            display: inline-block;
            position: relative
        }

        .embed-video {
            width: 100%
        }

        .embed-video .video-iframe {
            width: 100%
        }

        .embed-video:before {
            display: none
        }

        .playlist-thumbnails {
            margin-top: .3125rem
        }

        .playlist-arrow {
            position: relative;
            cursor: pointer;
            height: 5.625rem;
            outline: none;
            width: 5%
        }

        @media only screen and (min-width: 40.625rem) {
            .playlist-arrow {
                height: 6.25rem
            }
        }

        @media only screen and (min-width: 73.75rem) {
            .playlist-arrow {
                height: 5.75rem
            }
        }

        .playlist-arrow .icon {
            position: absolute;
            left: 50%;
            top: 50%;
            -webkit-transform: translate(-50%, -50%);
            transform: translate(-50%, -50%)
        }

        .playlist-arrow.left-arrow {
            float: left
        }

        .playlist-arrow.right-arrow {
            float: right
        }

        .touchevents .playlist-arrow {
            display: none
        }

        .playlist-thumbs {
            box-sizing: border-box;
            overflow: hidden
        }

        .touchevents .playlist-thumbs {
            padding: 0
        }

        .playlist-thumbs--wrapper {
            overflow: hidden;
            white-space: nowrap
        }

        .touchevents .playlist-thumbs--wrapper {
            overflow-x: scroll;
            -webkit-overflow-scrolling: touch
        }

        .playlist-thumbs--inner-wrap {
            display: inline-block;
            opacity: 0;
            transition: opacity .3s ease-in
        }

        .enabled .playlist-thumbs--inner-wrap {
            opacity: 1
        }

        .playlist-thumb {
            display: inline-block;
            position: relative;
            vertical-align: top
        }

        .playlist-thumb--img {
            margin-bottom: .3125rem;
            background-color: #7b7b7b;
            position: relative;
            height: 5.625rem
        }

        @media only screen and (min-width: 40.625rem) {
            .playlist-thumb--img {
                height: 6.25rem
            }
        }

        @media only screen and (min-width: 73.75rem) {
            .playlist-thumb--img {
                height: 5.75rem
            }
        }

        .playlist-thumb--img img {
            -webkit-transform: translateZ(0);
            transform: translateZ(0);
            display: block;
            max-width: 100%;
            position: absolute
        }

        .playlist-thumb--play-btn {
            width: 100%;
            height: 100%;
            visibility: visible
        }

        .playlist-thumb--play-btn:before {
            position: absolute;
            left: 50%;
            top: 50%;
            -webkit-transform: translate(-50%, -50%);
            transform: translate(-50%, -50%)
        }

        .selected .playlist-thumb--play-btn {
            visibility: hidden
        }

        .playlist-thumb--title {
            white-space: normal
        }

        .embed-image-social-button {
            width: 2.5rem;
            height: 2.5rem;
            line-height: 2.5rem;
            margin-right: .3125rem
        }

        .embed-image-social-button:last-child {
            margin-right: 0
        }

        .embed-image-info {
            border-bottom: .0625rem solid #ececec;
            background-color: #f3f3f3;
            padding: .9375rem;
            margin-bottom: .625rem
        }

        .embed-image-info figcaption {
            font-family: Sofia, Helvetica, Arial, Sans-serif;
            font-size: .9375rem;
            line-height: 1.4;
            color: #2c2c2c;
            display: block;
            text-align: left
        }

        .embed-pullquote {
            color: #000
        }

        .embed-pullquote p {
            padding: 1.625rem 1.625rem 2rem;
            word-wrap: break-word
        }

        .embed-pullquote-align-left {
            font-family: Sofia, Helvetica, Arial, Sans-serif;
            font-size: 1.25rem;
            line-height: 1.2;
            text-transform: uppercase;
            border: solid .3125rem;
            border-image: linear-gradient(to bottom right, #ef69ab 0, #fd4cfc 50%, #e9328c 100%);
            border-image-slice: 1
        }

        @media only screen and (min-width: 40.625rem) {
            .embed-pullquote-align-left {
                font-size: 1.5rem;
                line-height: 1.3
            }
        }

        .embed-pullquote-align-center {
            font-family: TriviaSerif, Georgia, Times, Serif;
            font-size: 1.625rem;
            line-height: 1.2;
            text-align: center
        }

        @media only screen and (min-width: 40.625rem) {
            .embed-pullquote-align-center {
                font-size: 2.1875rem;
                line-height: 1.2
            }
        }

        .embed-pullquote-align-center:before, .embed-pullquote-align-center:after {
            content: "";
            background: #000;
            position: relative;
            display: inline-block;
            height: .3125rem;
            width: 5rem;
            transition: width .3s ease-in-out;
            margin-bottom: .625rem
        }

        .embed-pullquote-align-center p {
            padding: .9rem 1.625rem 1rem
        }

        .embed-pullquote-align-center:hover:before, .embed-pullquote-align-center:hover:after {
            width: 6.75em
        }

        .embed-pullquote .icon-quote {
            display: none
        }

        .embed-related-content {
            border-top: .0625rem dotted #e4e4e4;
            border-bottom: .0625rem dotted #e4e4e4;
            margin-bottom: .625rem;
            padding: .3125rem 0
        }

        .embed-related-content .item-title.recirculation-module-item-title {
            font-family: TriviaSerif, Georgia, Times, Serif;
            font-size: 1rem;
            line-height: 1;
            position: absolute;
            top: 50%;
            -webkit-transform: translateY(-50%);
            transform: translateY(-50%);
            color: #000;
            padding-left: 0
        }

        @media only screen and (min-width: 30rem) {
            .embed-related-content .item-title.recirculation-module-item-title {
                font-size: 1.125rem;
                line-height: 1.4
            }
        }

        @media only screen and (min-width: 40.625rem) {
            .embed-related-content .item-title.recirculation-module-item-title {
                font-size: 1.3125rem;
                line-height: 1.2
            }
        }

        .embed-rating {
            font-size: 1.5rem
        }

        .playlist-arrow {
            background: #e9328c;
            border: 0;
            padding: 0;
            transition: background .3s ease-in-out
        }

        .playlist-arrow:hover {
            background: rgba(233, 50, 140, .75)
        }

        .playlist-arrow .icon {
            color: #fff;
            font-size: 1.25rem
        }

        @media only screen and (min-width: 40.625rem) {
            .playlist-arrow .icon {
                font-size: 1.5rem
            }
        }

        @media only screen and (min-width: 73.75rem) {
            .playlist-arrow .icon {
                font-size: 1.25rem
            }
        }

        .playlist-thumbs {
            padding: 0 .3125rem
        }

        .playlist-thumb {
            -webkit-filter: grayscale(100%) contrast(120%);
            filter: grayscale(100%) contrast(120%);
            margin: 0 .125rem .625rem 0;
            transition: -webkit-filter .3s ease-in-out, filter .3s ease-in-out;
            width: 10rem
        }

        .selected.playlist-thumb {
            -webkit-filter: grayscale(0) contrast(100%);
            filter: grayscale(0) contrast(100%)
        }

        @media only screen and (min-width: 40.625rem) {
            .playlist-thumb {
                width: 11.0625rem
            }
        }

        @media only screen and (min-width: 61.25rem) {
            .playlist-thumb:hover {
                -webkit-filter: grayscale(0) contrast(100%);
                filter: grayscale(0) contrast(100%)
            }
        }

        @media only screen and (min-width: 73.75rem) {
            .playlist-thumb {
                width: 10.25rem
            }
        }

        .playlist-thumb--title {
            font-family: Sofia, Helvetica, Arial, Sans-serif;
            font-size: .875rem;
            line-height: 1.4;
            padding-left: .3125rem;
            transition: color .3s ease-in-out
        }

        @media only screen and (min-width: 61.25rem) {
            .playlist-thumb:hover .playlist-thumb--title {
                text-decoration: none;
                transition: color .3s ease-in-out;
                color: #e9328c
            }

            .playlist-thumb:hover .playlist-thumb--title:hover {
                color: #7b7b7b
            }
        }

        @media only screen and (min-width: 61.25rem) {
            .playlist-thumb--play-btn:before {
                color: #fff;
                font-size: 3.4375rem;
                transition: all .3s ease-in-out
            }
        }

        .playlist-thumb:hover .playlist-thumb--img .playlist-thumb--play-btn:before {
            color: rgba(255, 255, 255, .6)
        }

        .embed-image-info .body-btn-link {
            margin-top: .625rem
        }

        img.zoomable:not(.inline) {
            cursor: pointer
        }

        #zoom-overlay {
            display: none;
            margin-bottom: 20px;
            text-align: center;
            background: #000;
            position: fixed;
            top: 0;
            left: 0;
            z-index: 9999999;
            height: 100%;
            min-height: 100%;
            width: 100%;
            max-width: 100%;
            overflow: hidden
        }

        #zoom-overlay.active {
            display: block
        }

        #zoom-close {
            position: fixed;
            top: 0;
            right: 0;
            height: 40px;
            width: 40px;
            z-index: 1000;
            display: table;
            background-color: rgba(0, 0, 0, .2)
        }

        #zoom-close .icon {
            position: relative;
            text-align: center;
            display: table-cell;
            vertical-align: middle;
            color: #fff;
            font-size: 24px;
            cursor: pointer;
            width: 40px
        }

        .vertical-helper {
            display: inline-block;
            height: 100%;
            vertical-align: middle
        }

        #zoom-overlay-image {
            max-width: 100%;
            max-height: 100%;
            vertical-align: middle
        }

        .zoom-loader {
            position: absolute;
            top: 50%;
            left: 50%
        }

        .loading .zoom-loader {
            width: 2.5rem;
            height: 2.5rem;
            border-top-color: #fff;
            border-right-color: #fff;
            border-bottom-color: rgba(255, 255, 255, .3);
            border-left-color: rgba(255, 255, 255, .3);
            border-radius: 1.25rem;
            border-style: solid;
            border-width: .3rem;
            opacity: .8;
            -webkit-transform-origin: center center;
            transform-origin: center center;
            -webkit-animation: rotate 1s infinite linear;
            animation: rotate 1s infinite linear
        }

        .syndicate-source-link .link-label {
            font-style: italic
        }

        .recommended-module {
            width: 100%
        }

        .ct-unit {
            margin-top: 1.25rem;
            margin-bottom: 1.25rem
        }

        @media only screen and (min-width: 40.625rem) {
            .ct-unit {
                padding-left: 2.5rem;
                padding-right: 2.5rem
            }
        }

        @media only screen and (min-width: 40.625rem) {
            .ct-unit-inner {
                display: -webkit-flex;
                display: -ms-flexbox;
                display: flex
            }
        }

        @media only screen and (min-width: 40.625rem) {
            .ct-unit-text-container, .ct-unit-image-container {
                width: 50%
            }
        }

        .ct-unit-heading {
            display: inline-block;
            text-decoration: none
        }

        .ct-unit-title {
            display: block;
            text-decoration: none
        }

        .ct-unit-image-container {
            display: block
        }

        .ct-unit-image {
            display: block;
            min-height: .0625rem;
            width: 100%
        }

        .end-of-content-simple-item {
            width: 100%
        }

        @media only screen and (min-width: 40.625rem) {
            .end-of-content-simple-item {
                float: left;
                margin-right: 2%;
                width: 49%
            }

            .end-of-content-simple-item:last-child {
                margin-right: 0
            }
        }

        .end-of-content-module {
            margin-top: 1.875rem
        }

        .end-of-content-simple-item {
            margin-bottom: .9375rem
        }

        .end-of-content-simple-item .recirculation-sponsor {
            padding-left: 0
        }

        .end-of-content-header {
            font-family: TriviaSerif, Georgia, Times, Serif;
            font-size: 2.3125rem;
            line-height: 1;
            color: #000;
            font-weight: 700;
            padding: .625rem 0;
            letter-spacing: -.03rem;
            text-align: center
        }

        @media only screen and (min-width: 61.25rem) {
            .end-of-content-header {
                font-size: 3.125rem;
                line-height: 1
            }
        }

        .end-of-content-title {
            font-family: Sofia, Helvetica, Arial, Sans-serif;
            font-size: 1.125rem;
            line-height: 1.2;
            color: #000;
            font-weight: 700;
            letter-spacing: -.05rem
        }

        @media only screen and (min-width: 40.625rem) {
            .end-of-content-title {
                font-size: 1.25rem;
                line-height: 1.2
            }
        }

        a[class].body-btn-link {
            display: inline-block
        }

        a[class].body-btn-link {
            font-family: Sofia, Helvetica, Arial, Sans-serif;
            font-size: .75rem;
            background-color: #fff;
            border: .1875rem solid #000;
            color: #000;
            line-height: 1;
            font-weight: 700;
            text-transform: uppercase;
            padding: .8125rem 1.25rem .75rem;
            transition: background-color .3s ease-in-out
        }

        @media only screen and (min-width: 61.25rem) {
            a[class].body-btn-link:hover {
                background-color: #f180b8
            }
        }

        #demoSmall {
            display: none;
        }

        @media (min-width: 320px) and (max-width: 61.25rem) {
            #demoSmall {
                text-align: center;
                display: block;
            }
        }


    </style>
</head>

<body class="locale-en standard-article">
<nav class="nav" data-tracking-id="topNav">
    <div class="nav-bar">
        <div class="nav-bar-container">
            <a class="nav-button nav-sidepanel-button" href="/sitemap/" title="Navigation">
                <!--<span class="icon icon-menu"></span>-->
                <i class="fa fa-bars" aria-hidden="true"></i>

            </a>
            <a class="nav-logo" href="/">
                <svg version="1.1" class="logo-svg" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 800 143" enable-background="new 0 0 800 143" xml:space="preserve">
	<defs></defs>
	<g transform="translate(1.000000, 1.000000)" fill="#EC008C">
		<path d="M533.769,-0.096 L507.923,-0.096 L507.923,48.519 C504.231,12.211 490.692,-0.096 471,-0.096 C456.231,-0.096 445.154,7.288 438.385,26.365 C433.461,7.288 419.308,-0.096 395.923,-0.096 L370.077,-0.096 L370.077,48.519 L369.461,48.519 C365.769,12.211 352.231,-0.096 332.539,-0.096 C313.462,-0.096 299.923,12.211 295.615,48.519 L295,48.519 L295,-0.096 L261.769,-0.096 L249.462,72.519 L248.846,72.519 L238.385,-0.096 L203.923,-0.096 L203.923,27.596 C200.846,10.98 191,-0.096 172.538,-0.096 C152.231,-0.096 141.154,14.057 139.308,31.904 C133.769,7.904 121.462,-0.096 105.462,-0.096 C87.615,-0.096 74.692,10.365 69.769,40.519 C68.539,18.98 62.385,-0.096 36.539,-0.096 C16.231,-0.096 -0.385,18.365 -0.385,70.673 C-0.385,115.596 8.846,141.442 36.539,141.442 C61.154,141.442 67.923,121.75 69.769,102.057 C74.692,131.596 87.615,141.442 105.462,141.442 C122.692,141.442 135,131.596 140.538,103.904 C141.769,121.75 148.538,141.442 173.769,141.442 C187.923,141.442 198.385,135.288 203.923,124.826 L203.923,140.827 L223,140.827 L223,37.442 L223.615,37.442 L240.846,140.827 L255,140.827 L272.231,37.442 L272.846,37.442 L272.846,140.827 L295.615,140.827 L295.615,92.211 L296.231,92.211 C299.923,128.519 313.461,140.827 333.154,140.827 C352.231,140.827 365.769,128.519 370.077,92.211 L370.692,92.211 L370.692,140.827 L396.538,140.827 L396.538,84.211 L407,84.211 C419.923,84.211 428.538,79.288 434.077,71.288 C434.077,124.211 448.846,140.827 471.615,140.827 C490.692,140.827 504.231,128.519 508.538,92.211 L508.538,140.827 L567,140.827 L567,119.288 L534.385,119.288 L534.385,-0.096 L533.769,-0.096 L533.769,-0.096 Z M48.846,87.288 C48.231,106.98 46.385,119.288 37.769,119.288 C29.769,119.288 27.308,114.365 27.308,69.442 C27.308,23.904 32.846,20.827 38.385,20.827 C44.539,20.827 47.615,29.442 47.615,51.596 L69.154,50.98 C68.539,57.134 68.539,63.288 68.539,70.673 C68.539,77.442 68.539,83.596 69.154,89.134 L48.846,87.288 L48.846,87.288 Z M115.308,84.827 C115.308,114.365 111.615,119.903 106.077,119.903 C99.923,119.903 96.846,113.75 96.846,84.827 L96.846,55.904 C96.846,26.365 100.538,20.827 106.077,20.827 C112.231,20.827 115.308,26.98 115.308,55.904 L115.308,84.827 L115.308,84.827 Z M175,119.904 C163.923,119.904 163.923,106.365 163.923,98.98 L141.769,98.98 C143,90.98 143.615,81.134 143.615,70.057 C143.615,64.519 143.615,58.98 143,54.057 C154.077,79.288 186.077,86.673 186.077,106.98 C186.077,111.904 183.615,119.904 175,119.904 L175,119.904 Z M162.692,33.134 C162.692,25.75 166.385,20.827 172.538,20.827 C183,20.827 183,33.75 183,41.134 L204.539,41.134 L204.539,82.365 C192.231,60.211 162.692,51.596 162.692,33.134 L162.692,33.134 Z M342.385,84.827 C342.385,114.365 338.692,120.519 333.154,120.519 C327,120.519 323.923,114.365 323.923,84.827 L323.923,55.904 C323.923,26.365 327.615,20.211 333.154,20.211 C339.308,20.211 342.385,26.365 342.385,55.904 L342.385,84.827 L342.385,84.827 Z M398.385,63.904 L395.923,63.904 L395.923,21.442 L397.769,21.442 C406.385,21.442 414.385,22.057 414.385,42.365 C414.385,59.596 408.846,63.904 398.385,63.904 L398.385,63.904 Z M480.231,84.827 C480.231,114.365 476.539,120.519 471,120.519 C464.846,120.519 461.769,114.365 461.769,84.827 L461.769,55.904 C461.769,26.365 465.461,20.211 471,20.211 C477.154,20.211 480.231,26.365 480.231,55.904 L480.231,84.827 L480.231,84.827 Z" id="Fill-1"></path>
		<path d="M570.692,-0.096 L596.538,-0.096 L596.538,140.827 L570.692,140.827 L570.692,-0.096 Z"></path>
		<path d="M670.385,-0.096 L600.231,-0.096 L600.231,21.442 L622.385,21.442 L622.385,140.827 L648.231,140.827 L648.231,21.442 L670.385,21.442 L670.385,-0.096"></path>
		<path d="M776.846,-0.096 L776.846,74.365 L776.231,74.365 L752.846,-0.096 L727.615,-0.096 L727.615,122.98 L712.231,-0.096 L674.692,-0.096 L655,140.827 L676.539,140.827 L680.231,109.442 L701.154,109.442 L704.846,140.827 L749.769,140.827 L749.769,55.288 L750.385,55.288 L778.077,140.827 L798.385,140.827 L798.385,-0.096 L776.846,-0.096 L776.846,-0.096 Z M683.308,89.134 L691.308,21.442 L691.923,21.442 L699.308,89.134 L683.308,89.134 L683.308,89.134 Z"></path>
	</g>
</svg>
            </a>

            <div class="nav-swipeable">
                <div class="nav-swipeable-inner">
                    <ul class="nav-menu nav-mobile-content nav-primary-menu active">
                        <li class="nav-item" data-id="1"><a href="/style-beauty/fashion/">Style</a></li>
                        <li class="nav-item" data-id="2"><a href="/style-beauty/beauty/">Beauty</a></li>
                        <li class="nav-item" data-id="3"><a href="/sex-love/positions/">Love</a></li>
                        <li class="nav-item" data-id="4"><a href="/videos/">Video</a></li>
                        <li class="nav-item" data-id="5"><a href="/bridal/">Weddings</a></li>
                    </ul>

                    <ul class="nav-menu nav-mobile-content nav-secondary-menu nav-menu-subscribe active">
                        <li class="nav-menu-item nav-item active has-children" data-id="1"><a
                                href="https://subscribe.hearstmags.com/subscribe/splits/cosmopolitan/cos_sub_nav_link">Subscribe</a>
                            <ul class='nav-submenu' data-parent-id='1'>
                                <li class="nav-item"><a
                                        href="https://subscribe.hearstmags.com/subscribe/splits/cosmopolitan/cos_gift_nav_link">Give
                                    a Gift</a></li>
                                <li class="nav-item"><a
                                        href="https://subscribe.hearstmags.com/subscribe/splits/cosmopolitan/cos_digital_nav_link">Digital
                                    Editions</a></li>
                            </ul>
                        </li>
                    </ul>

                    <ul class="nav-menu nav-secondary-menu nav-menu-social active">
                        <li class="nav-menu-item nav-item active">
                            <span class="nav-menu-link">Follow</span>
                            <div class="social-button-group nav-submenu" data-share-location="social-btns-follow">
                                <div class="social-button social-button-facebook nav-item"
                                     data-tracking-id="share-button-facebook" title="Share on Facebook"
                                >
                                    <a class="social-button-link" href="https://facebook.com/Cosmopolitan"
                                       target="_blank" data-social-key="facebook">
                                        <i class="fa fa-facebook"></i>


                                    </a>
                                </div>
                                <div class="social-button social-button-twitter nav-item"
                                     data-tracking-id="share-button-twitter" title="Share on Twitter"
                                >
                                    <a class="social-button-link" href="https://twitter.com/Cosmopolitan"
                                       target="_blank" data-social-key="twitter">
                                        <i class="fa fa-twitter"></i>


                                    </a>
                                </div>
                                <div class="social-button social-button-googleplus nav-item"
                                     data-tracking-id="share-button-googleplus" title="Share on Google Plus"
                                >
                                    <a class="social-button-link"
                                       href="https://plus.google.com/u/0/111347932293989723742/posts" target="_blank"
                                       data-social-key="googleplus">
                                        <span class="icon social-button-icon icon-googleplus"></span>


                                    </a>
                                </div>
                                <div class="social-button social-button-pinterest nav-item"
                                     data-tracking-id="share-button-pinterest" title="Share on Pinterest"
                                >

                                    <a class="social-button-link" href="https://www.pinterest.com/Cosmopolitan/"
                                       target="_blank" data-pin-do="nothing">
                                        <i class="fa fa-pinterest-p"></i>


                                    </a>
                                </div>
                                <div class="social-button social-button-instagram nav-item"
                                     data-tracking-id="share-button-instagram" title="Share on Instagram"
                                >
                                    <a class="social-button-link" href="http://instagram.com/cosmopolitan"
                                       target="_blank" data-social-key="instagram">
                                        <span class="icon social-button-icon icon-instagram"></span>


                                    </a>
                                </div>
                                <div class="social-button social-button-youtube nav-item"
                                     data-tracking-id="share-button-youtube" title="Share on YouTube"
                                >
                                    <a class="social-button-link" href="http://www.youtube.com/cosmopolitan"
                                       target="_blank" data-social-key="youtube">
                                        <span class="icon social-button-icon icon-youtube"></span>


                                    </a>
                                </div>
                                <div class="social-button social-button-tumblr nav-item"
                                     data-tracking-id="share-button-tumblr" title="Share on Tumblr"
                                >
                                    <a class="social-button-link" href="http://cosmopolitanmagazine.tumblr.com"
                                       target="_blank" data-social-key="tumblr">
                                        <span class="icon social-button-icon icon-tumblr"></span>


                                    </a>
                                </div>

                            </div>

                        </li>
                    </ul>
                </div>
            </div>

            <a class="nav-button nav-search-button" href="/search/" title="Search">
                <i class="fa fa-search" aria-hidden="true"></i>
            </a>
        </div>
    </div>
</nav>
<nav class="nav-placeholder"></nav>
<!-- menus/sidepanel -->


<nav class="sidepanel">
	<span class="sidepanel-close-button">
		<span class="icon icon-close01"></span>
	</span>

    <ul class="sidepanel-menu">
        <li class="sidepanel-item has-children" data-id="1"><a href="/entertainment/">Celebrities &amp;
            Entertainment</a>
            <ul class='sidepanel-submenu' data-parent-id='1'>
                <li class="sidepanel-back-button sidepanel-submenu-item">Back</li>
                <li class="sidepanel-submenu-item"><a href="/entertainment/">Celebrities &amp; Entertainment</a></li>
                <li class="sidepanel-submenu-item"><a href="/entertainment/news/">Celeb News</a></li>
                <li class="sidepanel-submenu-item"><a href="/entertainment/celebs/">Celebs</a></li>
                <li class="sidepanel-submenu-item"><a href="/entertainment/tv/">TV</a></li>
                <li class="sidepanel-submenu-item"><a href="/entertainment/movies/">Movies</a></li>
                <li class="sidepanel-submenu-item"><a href="/entertainment/books/">Books</a></li>
                <li class="sidepanel-submenu-item"><a href="/entertainment/music/">Music</a></li>
            </ul>
        </li>
        <li class="sidepanel-item has-children" data-id="2"><a href="/style-beauty/">Beauty &amp; Style</a>
            <ul class='sidepanel-submenu' data-parent-id='2'>
                <li class="sidepanel-back-button sidepanel-submenu-item">Back</li>
                <li class="sidepanel-submenu-item"><a href="/style-beauty/">Beauty &amp; Style</a></li>
                <li class="sidepanel-submenu-item"><a href="/style-beauty/news/">Beauty &amp; Style News</a></li>
                <li class="sidepanel-submenu-item"><a href="/style-beauty/beauty/advice/">Beauty Advice</a></li>
                <li class="sidepanel-submenu-item"><a href="/style-beauty/beauty/how-to/">Beauty How Tos</a></li>
                <li class="sidepanel-submenu-item"><a href="/style-beauty/fashion/">Style</a></li>
                <li class="sidepanel-submenu-item"><a href="/style-beauty/fashion/how-to/">Style How Tos</a></li>
                <li class="sidepanel-submenu-item"><a href="/beauty-closet/">Cosmo Beauty Closet</a></li>
            </ul>
        </li>
        <li class="sidepanel-item" data-id="3"><a href="/politics/">Politics</a></li>
        <li class="sidepanel-item" data-id="4"><a href="/college/">College</a></li>
        <li class="sidepanel-item" data-id="5"><a href="/career/">Career</a></li>
        <li class="sidepanel-item has-children" data-id="6"><a href="/health-fitness/">Health &amp; Fitness</a>
            <ul class='sidepanel-submenu' data-parent-id='6'>
                <li class="sidepanel-back-button sidepanel-submenu-item">Back</li>
                <li class="sidepanel-submenu-item"><a href="/health-fitness/">Health &amp; Fitness</a></li>
                <li class="sidepanel-submenu-item"><a href="/health-fitness/how-to/">Health &amp; Fitness How Tos</a>
                </li>
            </ul>
        </li>
        <li class="sidepanel-item" data-id="7"><a href="/food-cocktails/">Food &amp; Cocktails</a></li>
        <li class="sidepanel-item has-children" data-id="8"><a href="/sex-love/">Sex &amp; Relationships</a>
            <ul class='sidepanel-submenu' data-parent-id='8'>
                <li class="sidepanel-back-button sidepanel-submenu-item">Back</li>
                <li class="sidepanel-submenu-item"><a href="/sex-love/">Sex &amp; Relationships</a></li>
                <li class="sidepanel-submenu-item"><a href="/sex-love/news/">Sex News</a></li>
                <li class="sidepanel-submenu-item"><a href="/sex-love/confessions/">Cosmo Confessions</a></li>
                <li class="sidepanel-submenu-item"><a href="/sex-love/positions/">Sex Positions</a></li>
                <li class="sidepanel-submenu-item"><a href="/sex-love/tips/">Sex Tips</a></li>
                <li class="sidepanel-submenu-item"><a href="/guys/">Guys</a></li>
                <li class="sidepanel-submenu-item"><a href="/weddings/">Weddings</a></li>
                <li class="sidepanel-submenu-item"><a href="/bedroom-blog/">Bedroom Blog</a></li>
            </ul>
        </li>
        <li class="sidepanel-item" data-id="9"><a href="/pregnancy-parenting-tips/">Parenting</a></li>
        <li class="sidepanel-item" data-id="10"><a href="/cosmo-latina/">Cosmo For Latinas</a></li>
        <li class="sidepanel-item" data-id="11"><a href="/horoscopes/">Horoscopes</a></li>
        <li class="sidepanel-item" data-id="12"><a href="/lennyletter/">Lenny Letter</a></li>
        <li class="sidepanel-item" data-id="13"><a href="/news/">All News</a></li>
        <li class="sidepanel-item" data-id="14"><a href="/videos/">All Videos</a></li>
        <li class="sidepanel-item has-children" data-id="15"><a href="/subscribe/">Subscribe</a>
            <ul class='sidepanel-submenu' data-parent-id='15'>
                <li class="sidepanel-back-button sidepanel-submenu-item">Back</li>
                <li class="sidepanel-submenu-item"><a
                        href="https://subscribe.hearstmags.com/subscribe/splits/cosmopolitan/cos_sub_nav_link">Subscribe</a>
                </li>
                <li class="sidepanel-submenu-item"><a
                        href="https://subscribe.hearstmags.com/subscribe/splits/cosmopolitan/cos_sub_nav_link">Print
                    Edition</a></li>
                <li class="sidepanel-submenu-item"><a
                        href="https://subscribe.hearstmags.com/subscribe/splits/cosmopolitan/cos_digital_nav_link">Digital
                    Edition</a></li>
                <li class="sidepanel-submenu-item"><a
                        href="https://subscribe.hearstmags.com/subscribe/splits/cosmopolitan/cos_gift_nav_link">Give a
                    Gift</a></li>
            </ul>
        </li>
        <li class="sidepanel-item" data-id="16"><a href="http://newsletters.cosmopolitan.com">Newsletter</a></li>
        <li class="sidepanel-item has-children" data-id="17"><a href="#follow">Follow</a>
            <ul class='sidepanel-submenu' data-parent-id='17'>
                <li class="sidepanel-back-button sidepanel-submenu-item">Back</li>
                <li class="sidepanel-submenu-item"><a href="https://www.facebook.com/Cosmopolitan" target="_blank">Facebook</a>
                </li>
                <li class="sidepanel-submenu-item"><a href="https://twitter.com/Cosmopolitan"
                                                      target="_blank">Twitter</a></li>
                <li class="sidepanel-submenu-item"><a href="https://plus.google.com/u/0/111347932293989723742/posts"
                                                      target="_blank">Google+</a></li>
                <li class="sidepanel-submenu-item"><a href="https://www.pinterest.com/follow/Cosmopolitan"
                                                      target="_blank">Pinterest</a></li>
                <li class="sidepanel-submenu-item"><a href="https://www.instagram.com/cosmopolitan/" target="_blank">Instagram</a>
                </li>
                <li class="sidepanel-submenu-item"><a href="https://www.youtube.com/c/cosmopolitan?sub_confirmation=1">Youtube</a>
                </li>
                <li class="sidepanel-submenu-item"><a href="http://cosmopolitanmagazine.tumblr.com/" target="_blank">Tumblr</a>
                </li>
            </ul>
        </li>
        <li class="sidepanel-item" data-id="18"><a href="/promotions/">Promotions</a></li>
        <li class="sidepanel-item" data-id="19"><a href="http://sweepstakes.cosmopolitan.com/">Win</a></li>
    </ul>
</nav>
<!-- / menus/sidepanel -->
<div class="oop-ad ">
    <div id="gpt-ad-oop-1" class="ad-container"></div>
</div>

<div class="site-content">
    <div class="search-overlay">
        <div class="search-overlay-inner">
		<span class="search-overlay-close-button">
			<span class="icon icon-close01"></span>
		</span>


            <form class="search-form search-overlay-form" action="/search/">
                <input type="search" id="search-input" class="search-input" name="q" value="" placeholder="search"
                       autocomplete="off">

                <label class="search-label" for="search-input">Type keyword(s) to search</label>
            </form>


            <div class="search-overlay-autosuggest">
                <ul class="search-overlay-autosuggest-list">
                </ul>
            </div>

            <script type="text/template" id="autosuggest-link-template">
                <li>
                    <a href="<%= data.searchLink %>" class="search-overlay-autosuggest-link"
                       data-type="<%= data.type %>">
                        <%= data.label.replace( data.term, "<span class=\"search-overlay-autosuggest-link-type\">" + data.term + "</span>"
                        ) %>
                    </a>
                </li>
            </script>

        </div>
    </div>


    <header class="content-header standard-header">


        <div class="content-header-inner">
            <h1 class="content-hed standard-hed">26 Starbucks Drinks You Had No Idea Actually Existed</h1>

            <h2 class="content-dek standard-dek"><p>Its "secret" drink menu is more limitless and mind-blowing than you
                <em>every imagined</em>.</p></h2>
        </div>
    </header>


     <!--WIDGET AREA-->
    <div class="content-container standard-container">
        <div class="content-rail standard-rail">
            <div class="demo demo-big">
                <video id="video1" name="desktop-large" style="width:300px;height:600px;" class="responsive-video" autoplay loop muted>
                    <source src="https://s3.amazonaws.com/klickly/demo-videos/multi+600.mp4" type="video/mp4">
                    Your browser does not support the video tag.
                </video>
            </div>
            <div class="demo demo-small" style="margin-top: 50px">
                <video id="video2" name="desktop-small" style="width:300px;height:250px;" class="responsive-video" autoplay loop muted>
                    <source src="https://s3.amazonaws.com/klickly/demo-videos/multi+300.mp4" type="video/mp4">
                    Your browser does not support the video tag.
                </video>
            </div>
        </div>


        <!--END WIDGET AREA-->
        <div class="standard-body">
            <div class="content-lede-image standard-lede-image">
                <div class="content-lede-image-wrap">


                    <img class="zoomable lazyload-in-view"
                         src="https://hips.hearstapps.com/hmg-prod.s3.amazonaws.com/images/pin-starbucksexisted-1493760756.jpg?crop=1.00xw:0.167xh;0,0.108xh&resize=480:*"
                         title=""
                         alt=""
                    />


                    <div class="zoom-icon">
                        <i class="fa fa-arrows-alt"></i>
                    </div>


                    <div class="image-credit content-lede-image-credit">
                        <span class="image-photo-credit">Sade Adeyina</span></div>

                </div>

                <div class="social-button-group lede-image-social-button-group"
                     data-share-location="social-btns-content-lede-image">
                    <div class="social-button social-button-pinterest content-lede-image-social-button social-share-button"
                         data-tracking-id="share-button-pinterest" title="Share on Pinterest"
                    >

                        <a class="social-button-link"
                           href="//pinterest.com/pin/create/button/?url=http%3A%2F%2Fwww.cosmopolitan.com%2Ffood-cocktails%2Fnews%2Fa38276%2F20-things-you-didnt-know-you-could-order-at-starbucks%2F&amp;description=26%20Starbucks%20Drinks%20You%20Had%20No%20Idea%20Actually%20Existed%20-%20Cosmopolitan.com&amp;media=https%3A%2F%2Fhips.hearstapps.com%2Fhmg-prod.s3.amazonaws.com%2Fimages%2Fpin-starbucksexisted-1493760756.jpg%3Fcrop%3D1.00xw%3A0.167xh%3B0%2C0.126xh%26resize%3D1600%3A%2A"
                           target="_blank" data-pin-do="nothing">
                            <i class="fa fa-pinterest-p"></i>


                        </a>
                    </div>

                </div>

            </div>


            <div class="content-info standard-info">
                <div class="content-info-inner">
                    <div class="content-info-metadata">


                        <div class="byline-with-image content-info-byline-with-image" data-tracking-id="recirc-byline"
                             data-tracking-label="Carina Hsieh and Danielle Tullo">
                            <div class="content-info-byline-image">
                                <i class="fa fa-user-o"></i>
                            </div>

                            <!-- shared/byline -->


                            <div class="byline content-info-byline" itemprop="author" itemscope=""
                                 itemtype="http://schema.org/Person">By
                                <a href="/author/7022/carina-hsieh/" class="byline-name" rel="author" itemprop="name">Carina
                                    Hsieh</a> and <a href="/author/1650/danielle-tullo/" class="byline-name"
                                                     rel="author" itemprop="name">Danielle Tullo</a>
                            </div>
                            <!-- / shared/byline -->

                        </div>


                        <div class="content-info-date js-date" data-publish-date="2017-05-02T21:55:00Z">
                            May 2, 2017
                        </div>
                    </div>

                    <div class="content-info-social-buttons primary-social-buttons standard-social-buttons">
                        <div class="aggregate-count content-info-aggregate-count">
                            <span class="aggregate-count-number " data-social-providers="facebook twitter email"></span>
                        </div>


                        <div class="social-button-group content-info-social-button-group"
                             data-share-location="social-btns-primary">
                            <div class="social-button social-button-facebook content-info-social-button social-share-button"
                                 data-tracking-id="share-button-facebook" title="Share on Facebook"
                            >
                                <a class="social-button-link"
                                   href="//facebook.com/v2.3/dialog/feed?display=popup&amp;link=http%3A%2F%2Fwww.cosmopolitan.com%2Ffood-cocktails%2Fnews%2Fa38276%2F20-things-you-didnt-know-you-could-order-at-starbucks%2F&amp;redirect_uri=http%3A%2F%2Fwww.cosmopolitan.com%2Ffood-cocktails%2Fnews%2Fa38276%2F20-things-you-didnt-know-you-could-order-at-starbucks%2F&amp;name=26%20Starbucks%20Drinks%20You%20Had%20No%20Idea%20Actually%20Existed&amp;description=Its%20%22secret%22%20drink%20menu%20is%20more%20limitless%20and%20mind-blowing%20than%20you%20every%20imagined.&amp;picture=https%3A%2F%2Fhips.hearstapps.com%2Fhmg-prod.s3.amazonaws.com%2Fimages%2Fpin-starbucksexisted-1493760756.jpg%3Fcrop%3D1.00xw%3A0.167xh%3B0%2C0.126xh%26resize%3D1600%3A%2A&amp;app_id=162305873819997"
                                   target="_blank" data-social-key="facebook">
                                    <i class="fa fa-facebook"></i>


                                </a>
                            </div>
                            <div class="social-button social-button-twitter content-info-social-button social-share-button"
                                 data-tracking-id="share-button-twitter" title="Share on Twitter"
                            >
                                <a class="social-button-link"
                                   href="//www.twitter.com/share?url=http%3A%2F%2Fwww.cosmopolitan.com%2Ffood-cocktails%2Fnews%2Fa38276%2F20-things-you-didnt-know-you-could-order-at-starbucks%2F&amp;text=26%20Starbucks%20Drinks%20You%20Had%20No%20Idea%20Actually%20Existed&amp;via=Cosmopolitan"
                                   target="_blank" data-social-key="twitter">
                                    <i class="fa fa-twitter"></i>


                                </a>
                            </div>
                            <div class="social-button social-button-email content-info-social-button social-share-button"
                                 data-tracking-id="share-button-email" title="Email"
                            >
                                <a class="social-button-link"
                                   href="mailto:?body=http%3A%2F%2Fwww.cosmopolitan.com%2Ffood-cocktails%2Fnews%2Fa38276%2F20-things-you-didnt-know-you-could-order-at-starbucks%2F&amp;subject=26%20Starbucks%20Drinks%20You%20Had%20No%20Idea%20Actually%20Existed"
                                   target="_self" data-social-key="email">
                                    <span class="fa fa-envelope-o"></span>


                                </a>
                            </div>

                        </div>

                    </div>
                </div>
            </div>

            <div id="demoSmall">
                <video id="video3" name="mobile" style="width:300px;height:250px;" class="responsive-video" autoplay loop muted>
                    <source src="https://s3.amazonaws.com/klickly/demo-videos/multi+300.mp4" type="video/mp4">
                    Your browser does not support the video tag.
                </video>
            </div>


            <div class="article-body-content standard-body-content">
                <p class="body-text">If you're like most Starbucks customers you probably go in there every day and
                    order the same one or two things. But you might want to start branching out because the chain has a
                    whole slew of <a class="body-link" href="http://hackthemenu.com/starbucks/secret-menu/"
                                     target="_blank">"secret" drinks</a>. So before you freak out over the announcement
                    of the forthcoming Birthday Cake Frappuccino, please note that a cake batter Frappuccino is already
                    ~secretly~ on the menu. Along with many other mind-blowing treats:</p>
                <div class="breaker-ad article-breaker-ad standard-article-breaker-ad mobile-breaker-ad">
                    <div class="breaker-ad-text">Advertisement - Continue Reading Below</div>
                    <div id="gpt-ad-vertical-top-mobile" class="ad-container"></div>
                </div>

                <div class="deferred-recirculation-module" data-template="#recirculation-module-template"></div>
                <h4 class="body-h4">1. Mermaid Frappuccino</h4>
                <div class="embed embed-image embed-image-center embed-image-medium">
                    <div class="embed-inner crop-original">
                        <div class="embed-image-wrap aspect-ratio-original">
                            <picture class="zoomable  lazyload-in-view">
                                <source data-srcset="https://hips.hearstapps.com/hmg-prod.s3.amazonaws.com/images/img-8721-jpg-1493652689.jpg?crop=1xw:1xh;center,top&amp;resize=768:*"
                                        media="(min-width: 75rem)"></source>
                                <source data-srcset="https://hips.hearstapps.com/hmg-prod.s3.amazonaws.com/images/img-8721-jpg-1493652689.jpg?crop=1xw:1xh;center,top&amp;resize=768:*"
                                        media="(min-width: 61.25rem)"></source>
                                <source data-srcset="https://hips.hearstapps.com/hmg-prod.s3.amazonaws.com/images/img-8721-jpg-1493652689.jpg?crop=1xw:1xh;center,top&amp;resize=980:*"
                                        media="(min-width: 48rem)"></source>
                                <source data-srcset="https://hips.hearstapps.com/hmg-prod.s3.amazonaws.com/images/img-8721-jpg-1493652689.jpg?crop=1xw:1xh;center,top&amp;resize=640:*"
                                        media="(min-width: 40.625rem)"></source>
                                <source data-srcset="https://hips.hearstapps.com/hmg-prod.s3.amazonaws.com/images/img-8721-jpg-1493652689.jpg?crop=1xw:1xh;center,top&amp;resize=640:*"
                                        media="(min-width: 30rem)"></source>

                                <img data-srcset="https://hips.hearstapps.com/hmg-prod.s3.amazonaws.com/images/img-8721-jpg-1493652689.jpg?crop=1xw:1xh;center,top&amp;resize=480:*"
                                     alt=""
                                     title=""
                                     src="https://hips.hearstapps.com/hmg-prod.s3.amazonaws.com/images/img-8721-jpg-1493652689.jpg?crop=1xw:1xh;center,top&resize=480:*"
                                     data-src="https://hips.hearstapps.com/hmg-prod.s3.amazonaws.com/images/img-8721-jpg-1493652689.jpg?crop=1xw:1xh;center,top&amp;resize=480:*"
                                />
                            </picture>


                            <div class="zoom-icon">
                                <i class="fa fa-arrows-alt"></i>
                            </div>

                        </div>

                        <div class="social-button-group embed-image-social-button-group"
                             data-share-location="social-btns-image">
                            <div class="social-button social-button-pinterest embed-image-social-button social-share-button"
                                 data-tracking-id="share-button-pinterest" title="Share on Pinterest"
                            >

                                <a class="social-button-link"
                                   href="//pinterest.com/pin/create/button/?url=http%3A%2F%2Fwww.cosmopolitan.com%2Ffood-cocktails%2Fnews%2Fa38276%2F20-things-you-didnt-know-you-could-order-at-starbucks%2F&amp;description=26%20Starbucks%20Drinks%20You%20Had%20No%20Idea%20Actually%20Existed%20-%20Cosmopolitan.com&amp;media=https%3A%2F%2Fhips.hearstapps.com%2Fhmg-prod.s3.amazonaws.com%2Fimages%2Fpin-starbucksexisted-1493760756.jpg%3Fcrop%3D1.00xw%3A0.167xh%3B0%2C0.126xh%26resize%3D1600%3A%2A"
                                   target="_blank" data-pin-do="nothing">
                                    <i class="fa fa-pinterest-p"></i>


                                </a>
                            </div>

                        </div>

                    </div>


                    <div class="image-credit embed-image-credit">
                        <span class="image-photo-credit">Danielle Tullo</span></div>


                </div>
                <p class="body-text">Ask for a Vanilla Bean Frappuccino with three scoops of blackberry inclusions (for
                    a grande). Then, ask for a drizzle made with eight pumps of white mocha, three pumps of toasted
                    coconut, and three scoops of matcha powder.<br></p><h4 class="body-h4">2. Purple Drink </h4>
                <div class="embed embed-image embed-image-center embed-image-medium">


                    <div class="embed-inner crop-original">
                        <div class="embed-image-wrap aspect-ratio-original">


                            <picture class="zoomable lazyload-in-view">
                                <source data-srcset="https://hips.hearstapps.com/hmg-prod.s3.amazonaws.com/images/screen-shot-2017-05-02-at-3-57-15-pm-1493756361.png?crop=1xw:1xh;center,top&amp;resize=768:*"
                                        media="(min-width: 75rem)"></source>
                                <source data-srcset="https://hips.hearstapps.com/hmg-prod.s3.amazonaws.com/images/screen-shot-2017-05-02-at-3-57-15-pm-1493756361.png?crop=1xw:1xh;center,top&amp;resize=768:*"
                                        media="(min-width: 61.25rem)"></source>
                                <source data-srcset="https://hips.hearstapps.com/hmg-prod.s3.amazonaws.com/images/screen-shot-2017-05-02-at-3-57-15-pm-1493756361.png?crop=1xw:1xh;center,top&amp;resize=980:*"
                                        media="(min-width: 48rem)"></source>
                                <source data-srcset="https://hips.hearstapps.com/hmg-prod.s3.amazonaws.com/images/screen-shot-2017-05-02-at-3-57-15-pm-1493756361.png?crop=1xw:1xh;center,top&amp;resize=640:*"
                                        media="(min-width: 40.625rem)"></source>
                                <source data-srcset="https://hips.hearstapps.com/hmg-prod.s3.amazonaws.com/images/screen-shot-2017-05-02-at-3-57-15-pm-1493756361.png?crop=1xw:1xh;center,top&amp;resize=640:*"
                                        media="(min-width: 30rem)"></source>

                                <img data-srcset="https://hips.hearstapps.com/hmg-prod.s3.amazonaws.com/images/screen-shot-2017-05-02-at-3-57-15-pm-1493756361.png?crop=1xw:1xh;center,top&amp;resize=480:*"
                                     alt=""
                                     title=""
                                     src="https://hips.hearstapps.com/hmg-prod.s3.amazonaws.com/images/screen-shot-2017-05-02-at-3-57-15-pm-1493756361.png?crop=1xw:1xh;center,top&resize=480:*"
                                     data-src="https://hips.hearstapps.com/hmg-prod.s3.amazonaws.com/images/screen-shot-2017-05-02-at-3-57-15-pm-1493756361.png?crop=1xw:1xh;center,top&amp;resize=480:*"
                                />
                            </picture>


                            <div class="zoom-icon">
                                <i class="fa fa-arrows-alt"></i>
                            </div>

                        </div>

                        <div class="social-button-group embed-image-social-button-group"
                             data-share-location="social-btns-image">
                            <div class="social-button social-button-pinterest embed-image-social-button social-share-button"
                                 data-tracking-id="share-button-pinterest" title="Share on Pinterest"
                            >

                                <a class="social-button-link"
                                   href="//pinterest.com/pin/create/button/?url=http%3A%2F%2Fwww.cosmopolitan.com%2Ffood-cocktails%2Fnews%2Fa38276%2F20-things-you-didnt-know-you-could-order-at-starbucks%2F&amp;description=26%20Starbucks%20Drinks%20You%20Had%20No%20Idea%20Actually%20Existed%20-%20Cosmopolitan.com&amp;media=https%3A%2F%2Fhips.hearstapps.com%2Fhmg-prod.s3.amazonaws.com%2Fimages%2Fpin-starbucksexisted-1493760756.jpg%3Fcrop%3D1.00xw%3A0.167xh%3B0%2C0.126xh%26resize%3D1600%3A%2A"
                                   target="_blank" data-pin-do="nothing">
                                    <i class="fa fa-pinterest-p"></i>
                                </a>
                            </div>

                        </div>

                    </div>


                    <div class="image-credit embed-image-credit">
                        <span class="image-photo-credit">Instagram</span></div>


                </div>
                <div class="breaker-ad article-breaker-ad standard-article-breaker-ad mobile-breaker-ad">
                    <div class="breaker-ad-text">Advertisement - Continue Reading Below</div>
                    <div id="ad-article-breaker-mobile-0" class="ad-container"></div>
                </div>
                <p class="body-text">Order passion iced tea, soy milk, vanilla syrup, and blackberries. </p><h4
                    class="body-h4">3. Purple Pink Drink </h4>
                <div class="embed embed-image embed-image-center embed-image-medium">


                    <div class="embed-inner crop-original">
                        <div class="embed-image-wrap aspect-ratio-original">


                            <picture class="zoomable lazyload-in-view">
                                <source data-srcset="https://hips.hearstapps.com/hmg-prod.s3.amazonaws.com/images/screen-shot-2017-05-02-at-4-20-30-pm-1493756442.png?crop=1xw:1xh;center,top&amp;resize=768:*"
                                        media="(min-width: 75rem)"></source>
                                <source data-srcset="https://hips.hearstapps.com/hmg-prod.s3.amazonaws.com/images/screen-shot-2017-05-02-at-4-20-30-pm-1493756442.png?crop=1xw:1xh;center,top&amp;resize=768:*"
                                        media="(min-width: 61.25rem)"></source>
                                <source data-srcset="https://hips.hearstapps.com/hmg-prod.s3.amazonaws.com/images/screen-shot-2017-05-02-at-4-20-30-pm-1493756442.png?crop=1xw:1xh;center,top&amp;resize=980:*"
                                        media="(min-width: 48rem)"></source>
                                <source data-srcset="https://hips.hearstapps.com/hmg-prod.s3.amazonaws.com/images/screen-shot-2017-05-02-at-4-20-30-pm-1493756442.png?crop=1xw:1xh;center,top&amp;resize=640:*"
                                        media="(min-width: 40.625rem)"></source>
                                <source data-srcset="https://hips.hearstapps.com/hmg-prod.s3.amazonaws.com/images/screen-shot-2017-05-02-at-4-20-30-pm-1493756442.png?crop=1xw:1xh;center,top&amp;resize=640:*"
                                        media="(min-width: 30rem)"></source>

                                <img data-srcset="https://hips.hearstapps.com/hmg-prod.s3.amazonaws.com/images/screen-shot-2017-05-02-at-4-20-30-pm-1493756442.png?crop=1xw:1xh;center,top&amp;resize=480:*"
                                     alt=""
                                     title=""
                                     src="https://hips.hearstapps.com/hmg-prod.s3.amazonaws.com/images/screen-shot-2017-05-02-at-4-20-30-pm-1493756442.png?crop=1xw:1xh;center,top&resize=480:*"
                                     data-src="https://hips.hearstapps.com/hmg-prod.s3.amazonaws.com/images/screen-shot-2017-05-02-at-4-20-30-pm-1493756442.png?crop=1xw:1xh;center,top&amp;resize=480:*"
                                />
                            </picture>


                            <div class="zoom-icon">
                                <i class="fa fa-arrows-alt"></i>
                            </div>

                        </div>

                        <div class="social-button-group embed-image-social-button-group"
                             data-share-location="social-btns-image">
                            <div class="social-button social-button-pinterest embed-image-social-button social-share-button"
                                 data-tracking-id="share-button-pinterest" title="Share on Pinterest"
                            >

                                <a class="social-button-link"
                                   href="//pinterest.com/pin/create/button/?url=http%3A%2F%2Fwww.cosmopolitan.com%2Ffood-cocktails%2Fnews%2Fa38276%2F20-things-you-didnt-know-you-could-order-at-starbucks%2F&amp;description=26%20Starbucks%20Drinks%20You%20Had%20No%20Idea%20Actually%20Existed%20-%20Cosmopolitan.com&amp;media=https%3A%2F%2Fhips.hearstapps.com%2Fhmg-prod.s3.amazonaws.com%2Fimages%2Fpin-starbucksexisted-1493760756.jpg%3Fcrop%3D1.00xw%3A0.167xh%3B0%2C0.126xh%26resize%3D1600%3A%2A"
                                   target="_blank" data-pin-do="nothing">
                                    <i class="fa fa-pinterest-p"></i>


                                </a>
                            </div>

                        </div>

                    </div>


                    <div class="image-credit embed-image-credit">
                        <span class="image-photo-credit">Instagram</span>
                    </div>

                </div>


                <div class="social-menu">
                    <div class="social-menu-inner">
                        <div class="social-button-group social-menu-button-group"
                             data-share-location="social-btns-fixed">
                            <div class="social-button social-button-facebook social-menu-button social-share-button"
                                 data-tracking-id="share-button-facebook" title="Share on Facebook"
                            >
                                <a class="social-button-link"
                                   href="//facebook.com/v2.3/dialog/feed?display=popup&amp;link=http%3A%2F%2Fwww.cosmopolitan.com%2Ffood-cocktails%2Fnews%2Fa38276%2F20-things-you-didnt-know-you-could-order-at-starbucks%2F&amp;redirect_uri=http%3A%2F%2Fwww.cosmopolitan.com%2Ffood-cocktails%2Fnews%2Fa38276%2F20-things-you-didnt-know-you-could-order-at-starbucks%2F&amp;name=26%20Starbucks%20Drinks%20You%20Had%20No%20Idea%20Actually%20Existed&amp;description=Its%20%22secret%22%20drink%20menu%20is%20more%20limitless%20and%20mind-blowing%20than%20you%20every%20imagined.&amp;picture=https%3A%2F%2Fhips.hearstapps.com%2Fhmg-prod.s3.amazonaws.com%2Fimages%2Fpin-starbucksexisted-1493760756.jpg%3Fcrop%3D1.00xw%3A0.167xh%3B0%2C0.126xh%26resize%3D1600%3A%2A&amp;app_id=162305873819997"
                                   target="_blank" data-social-key="facebook">
                                    <i class="fa fa-facebook"></i>

                                    <span class="social-button-label">Share</span>

                                </a>
                            </div>
                            <div class="social-button social-button-twitter social-menu-button social-share-button"
                                 data-tracking-id="share-button-twitter" title="Share on Twitter"
                            >
                                <a class="social-button-link"
                                   href="//www.twitter.com/share?url=http%3A%2F%2Fwww.cosmopolitan.com%2Ffood-cocktails%2Fnews%2Fa38276%2F20-things-you-didnt-know-you-could-order-at-starbucks%2F&amp;text=26%20Starbucks%20Drinks%20You%20Had%20No%20Idea%20Actually%20Existed&amp;via=Cosmopolitan"
                                   target="_blank" data-social-key="twitter">
                                    <i class="fa fa-twitter"></i>

                                    <span class="social-button-label">Tweet</span>

                                </a>
                            </div>
                            <div class="social-button social-button-email social-menu-button social-share-button"
                                 data-tracking-id="share-button-email" title="Email"
                            >
                                <a class="social-button-link"
                                   href="mailto:?body=http%3A%2F%2Fwww.cosmopolitan.com%2Ffood-cocktails%2Fnews%2Fa38276%2F20-things-you-didnt-know-you-could-order-at-starbucks%2F&amp;subject=26%20Starbucks%20Drinks%20You%20Had%20No%20Idea%20Actually%20Existed"
                                   target="_self" data-social-key="email">
                                    <span class="fa fa-envelope-o"></span>

                                    <span class="social-button-label">Email</span>

                                </a>
                            </div>

                        </div>

                    </div>
                </div>


                <div class="transporter">
                    <div class="transporter-header">
                        <div class="transporter-header-inner">
                            <span class="transporter-label">More From</span>
                            <a class="transporter-hed" href="/food-cocktails/">Food &amp; Cocktails</a>
                        </div>
                    </div>


                    <div class="feed feed-transporter"
                         data-params="&quot;{}&quot;"
                         data-pagesize=""
                         data-tracking-id="recirc-transporter"
                         data-tracking-label="More From Food &amp; Cocktails"
                    >




                        <div class="simple-item transporter-simple-item grid-simple-item-last-mobile ">


                            <a class="simple-item-image item-image"
                               href="/food-cocktails/a9599074/usda-suspends-school-lunch-standards/">
                                <img class="lazyload-in-view"
                                     src="https://hips.hearstapps.com/hmg-prod.s3.amazonaws.com/images/lunch-1493828852.jpg?crop=1.00xw:1.00xh;0,0&amp;resize=480:*"
                                     title=""
                                     alt=""
                                />
                            </a>


                            <a class="simple-item-title item-title"
                               href="/food-cocktails/a9599074/usda-suspends-school-lunch-standards/">
                                Trump Suspends School Nutrition Standards
                            </a>


                        </div>


                        <div class="simple-item transporter-simple-item grid-simple-item-last-mobile ">


                            <a class="simple-item-image item-image"
                               href="/food-cocktails/a9599074/usda-suspends-school-lunch-standards/">


                                <img class="lazyload-in-view"
                                     src="https://hips.hearstapps.com/hmg-prod.s3.amazonaws.com/images/img-6440-jpg-1493921771.jpg?crop=1.00xw:0.752xh;0,0.188xh&resize=480:*"
                                     title=""
                                     alt=""
                                />


                            </a>


                            <a class="simple-item-title item-title"
                               href="/food-cocktails/a9599074/usda-suspends-school-lunch-standards/">
                                Trump Suspends School Nutrition Standards
                            </a>


                        </div>



                        <div class="simple-item transporter-simple-item grid-simple-item-last-mobile ">


                            <a class="simple-item-image item-image"
                               href="/food-cocktails/a9599074/usda-suspends-school-lunch-standards/">


                                <img class="lazyload-in-view"
                                     src="https://hips.hearstapps.com/hmg-prod.s3.amazonaws.com/images/narwol-drink-1493915737.jpg?crop=1xw:0.9992774566473989xh;center,top&resize=480:*"
                                     title=""
                                     alt=""
                                />


                            </a>


                            <a class="simple-item-title item-title"
                               href="/food-cocktails/a9599074/usda-suspends-school-lunch-standards/">
                                Trump Suspends School Nutrition Standards
                            </a>


                        </div>


                        <hr class="horizontal-rule-mobile">


                        <div class="simple-item transporter-simple-item grid-simple-item-last-tablet ">


                            <a class="simple-item-image item-image"
                               href="/food-cocktails/a9598251/pizza-girl-on-train/">


                                <img class="lazyload-in-view"
                                     src="https://hips.hearstapps.com/del.h-cdn.co/assets/17/18/768x384/landscape-1493753857-c-j7muzxyaa4u46.jpg?resize=480:*"

                                     data-src="https://hips.hearstapps.com/del.h-cdn.co/assets/17/18/768x384/landscape-1493753857-c-j7muzxyaa4u46.jpg?resize=480:*"


                                     data-srcset="https://hips.hearstapps.com/del.h-cdn.co/assets/17/18/768x384/landscape-1493753857-c-j7muzxyaa4u46.jpg?resize=640:* 480w,https://hips.hearstapps.com/del.h-cdn.co/assets/17/18/768x384/landscape-1493753857-c-j7muzxyaa4u46.jpg?resize=768:* 650w,https://hips.hearstapps.com/del.h-cdn.co/assets/17/18/768x384/landscape-1493753857-c-j7muzxyaa4u46.jpg?resize=980:* 768w,https://hips.hearstapps.com/del.h-cdn.co/assets/17/18/768x384/landscape-1493753857-c-j7muzxyaa4u46.jpg?resize=768:* 980w"

                                     title="pizza&#x20;girl"
                                     alt=""
                                />


                            </a>


                            <a class="simple-item-title item-title"
                               href="/food-cocktails/a9598251/pizza-girl-on-train/">
                                This Viral "Pizza Girl" Photo Is a Work of Art
                            </a>


                        </div>


                        <hr class="horizontal-rule-tablet">


                        <div class="simple-item transporter-simple-item grid-simple-item-last-mobile ">


                            <a class="simple-item-image item-image"
                               href="/food-cocktails/a9592611/paternal-age-social-skills/">


                                <img class="lazyload-in-view"
                                     src="https://hips.hearstapps.com/hmg-prod.s3.amazonaws.com/images/thumbnail-dad-age-social-life-02-1493747879.jpg?crop=1.00xw:1.00xh;0,0&amp;resize=480:*"
                                     title=""
                                     alt=""
                                />


                            </a>


                            <a class="simple-item-title item-title"
                               href="/food-cocktails/a9592611/paternal-age-social-skills/">
                                How Your Dad's Age Could Explain Your Social Life
                            </a>


                        </div>


                        <hr class="horizontal-rule-mobile">

                    </div>




                </div>


                <div class="seo-tags-container" data-tracking-id="recirc-SEO-tags">
                    <ul class="seo-tag-list">
                        <li class="seo-tag">
                            <a class="seo-link" href="/food-cocktails/">Food &amp; Cocktails</a>
                        </li>

                        <li class="seo-tag">
                            <a class="seo-link"
                               href="//www.cosmopolitan.com/food-cocktails/g5937/the-best-secret-menu-starbucks-drink-for-your-sign/"
                               title="The Best Starbucks Secret-Menu Drink for Your Sign">The Best Starbucks Secret-Menu
                                Drink for Your Sign</a>
                        </li>
                        <li class="seo-tag">
                            <a class="seo-link"
                               href="//www.cosmopolitan.com/food-cocktails/news/a60626/starbucks-orange-drink/"
                               title="The Newest Starbucks Rainbow Drink Is Here and You&#039;re About to Be Obsessed">The
                                Newest Starbucks Rainbow Drink Is Here and You&#039;re About to Be Obsessed</a>
                        </li>
                        <li class="seo-tag">
                            <a class="seo-link"
                               href="//www.cosmopolitan.com/food-cocktails/a60693/hold-on-to-your-taste-buds-starbucks-secret-blue-drink-is-the-next-rainbow-drink-to-try/"
                               title="Hold On to Your Taste Buds, Starbucks&#039; Secret &quot;Blue Drink&quot; Is the Next Rainbow Drink to Try">Hold
                                On to Your Taste Buds, Starbucks&#039; Secret &quot;Blue Drink&quot; Is the Next Rainbow
                                Drink to Try</a>
                        </li>
                        <li class="seo-tag">
                            <a class="seo-link"
                               href="//www.cosmopolitan.com/food-cocktails/a9530545/starbucks-secret-unicorn-drink-hacks/"
                               title="5 Secret Starbucks Unicorn Drinks ">5 Secret Starbucks Unicorn Drinks </a>
                        </li>
                        <li class="seo-tag">
                            <a class="seo-link"
                               href="//www.cosmopolitan.com/food-cocktails/a9192509/medicine-ball-starbucks-secret-menu/"
                               title="This Starbucks Secret Menu Drink Is A Cold Blaster">This Starbucks Secret Menu
                                Drink Is A Cold Blaster</a>
                        </li>
                        <li class="seo-tag">
                            <a class="seo-link"
                               href="//www.cosmopolitan.com/food-cocktails/a9260555/starbucks-pink-drink-official-menu/"
                               title="The Pink Drink Is Now on Starbucks&#039; Official Menu">The Pink Drink Is Now on
                                Starbucks&#039; Official Menu</a>
                        </li>

                    </ul>
                </div>
                <div id="zoom-overlay">
                    <div id="zoom-close">
                        <i class="icon icon-close01"></i>
                    </div>
                    <span class="vertical-helper"></span><img id="zoom-overlay-image"/>
                    <i class="zoom-loader"></i>
                </div>
                <!-- footers/main -->


                <footer class="footer">
                    <div class="footer-inner">
                        <div class="footer-logo">
                            <a href="/">


                                <svg version="1.1" class="logo-svg" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 800 143" enable-background="new 0 0 800 143" xml:space="preserve">
	<defs></defs>
	<g transform="translate(1.000000, 1.000000)" fill="#EC008C">
		<path d="M533.769,-0.096 L507.923,-0.096 L507.923,48.519 C504.231,12.211 490.692,-0.096 471,-0.096 C456.231,-0.096 445.154,7.288 438.385,26.365 C433.461,7.288 419.308,-0.096 395.923,-0.096 L370.077,-0.096 L370.077,48.519 L369.461,48.519 C365.769,12.211 352.231,-0.096 332.539,-0.096 C313.462,-0.096 299.923,12.211 295.615,48.519 L295,48.519 L295,-0.096 L261.769,-0.096 L249.462,72.519 L248.846,72.519 L238.385,-0.096 L203.923,-0.096 L203.923,27.596 C200.846,10.98 191,-0.096 172.538,-0.096 C152.231,-0.096 141.154,14.057 139.308,31.904 C133.769,7.904 121.462,-0.096 105.462,-0.096 C87.615,-0.096 74.692,10.365 69.769,40.519 C68.539,18.98 62.385,-0.096 36.539,-0.096 C16.231,-0.096 -0.385,18.365 -0.385,70.673 C-0.385,115.596 8.846,141.442 36.539,141.442 C61.154,141.442 67.923,121.75 69.769,102.057 C74.692,131.596 87.615,141.442 105.462,141.442 C122.692,141.442 135,131.596 140.538,103.904 C141.769,121.75 148.538,141.442 173.769,141.442 C187.923,141.442 198.385,135.288 203.923,124.826 L203.923,140.827 L223,140.827 L223,37.442 L223.615,37.442 L240.846,140.827 L255,140.827 L272.231,37.442 L272.846,37.442 L272.846,140.827 L295.615,140.827 L295.615,92.211 L296.231,92.211 C299.923,128.519 313.461,140.827 333.154,140.827 C352.231,140.827 365.769,128.519 370.077,92.211 L370.692,92.211 L370.692,140.827 L396.538,140.827 L396.538,84.211 L407,84.211 C419.923,84.211 428.538,79.288 434.077,71.288 C434.077,124.211 448.846,140.827 471.615,140.827 C490.692,140.827 504.231,128.519 508.538,92.211 L508.538,140.827 L567,140.827 L567,119.288 L534.385,119.288 L534.385,-0.096 L533.769,-0.096 L533.769,-0.096 Z M48.846,87.288 C48.231,106.98 46.385,119.288 37.769,119.288 C29.769,119.288 27.308,114.365 27.308,69.442 C27.308,23.904 32.846,20.827 38.385,20.827 C44.539,20.827 47.615,29.442 47.615,51.596 L69.154,50.98 C68.539,57.134 68.539,63.288 68.539,70.673 C68.539,77.442 68.539,83.596 69.154,89.134 L48.846,87.288 L48.846,87.288 Z M115.308,84.827 C115.308,114.365 111.615,119.903 106.077,119.903 C99.923,119.903 96.846,113.75 96.846,84.827 L96.846,55.904 C96.846,26.365 100.538,20.827 106.077,20.827 C112.231,20.827 115.308,26.98 115.308,55.904 L115.308,84.827 L115.308,84.827 Z M175,119.904 C163.923,119.904 163.923,106.365 163.923,98.98 L141.769,98.98 C143,90.98 143.615,81.134 143.615,70.057 C143.615,64.519 143.615,58.98 143,54.057 C154.077,79.288 186.077,86.673 186.077,106.98 C186.077,111.904 183.615,119.904 175,119.904 L175,119.904 Z M162.692,33.134 C162.692,25.75 166.385,20.827 172.538,20.827 C183,20.827 183,33.75 183,41.134 L204.539,41.134 L204.539,82.365 C192.231,60.211 162.692,51.596 162.692,33.134 L162.692,33.134 Z M342.385,84.827 C342.385,114.365 338.692,120.519 333.154,120.519 C327,120.519 323.923,114.365 323.923,84.827 L323.923,55.904 C323.923,26.365 327.615,20.211 333.154,20.211 C339.308,20.211 342.385,26.365 342.385,55.904 L342.385,84.827 L342.385,84.827 Z M398.385,63.904 L395.923,63.904 L395.923,21.442 L397.769,21.442 C406.385,21.442 414.385,22.057 414.385,42.365 C414.385,59.596 408.846,63.904 398.385,63.904 L398.385,63.904 Z M480.231,84.827 C480.231,114.365 476.539,120.519 471,120.519 C464.846,120.519 461.769,114.365 461.769,84.827 L461.769,55.904 C461.769,26.365 465.461,20.211 471,20.211 C477.154,20.211 480.231,26.365 480.231,55.904 L480.231,84.827 L480.231,84.827 Z" id="Fill-1"></path>
		<path d="M570.692,-0.096 L596.538,-0.096 L596.538,140.827 L570.692,140.827 L570.692,-0.096 Z"></path>
		<path d="M670.385,-0.096 L600.231,-0.096 L600.231,21.442 L622.385,21.442 L622.385,140.827 L648.231,140.827 L648.231,21.442 L670.385,21.442 L670.385,-0.096"></path>
		<path d="M776.846,-0.096 L776.846,74.365 L776.231,74.365 L752.846,-0.096 L727.615,-0.096 L727.615,122.98 L712.231,-0.096 L674.692,-0.096 L655,140.827 L676.539,140.827 L680.231,109.442 L701.154,109.442 L704.846,140.827 L749.769,140.827 L749.769,55.288 L750.385,55.288 L778.077,140.827 L798.385,140.827 L798.385,-0.096 L776.846,-0.096 L776.846,-0.096 Z M683.308,89.134 L691.308,21.442 L691.923,21.442 L699.308,89.134 L683.308,89.134 L683.308,89.134 Z"></path>
	</g>
</svg>


                            </a>
                        </div>

                        <div class="social-button-group footer-social-menu" data-share-location="social-btns-follow">
                            <div class="social-button social-button-facebook footer-social-menu-item"
                                 data-tracking-id="share-button-facebook" title="Share on Facebook"
                            >
                                <a class="social-button-link" href="https://facebook.com/Cosmopolitan" target="_blank"
                                   data-social-key="facebook">
                                    <i class="fa fa-facebook"></i>


                                </a>
                            </div>
                            <div class="social-button social-button-twitter footer-social-menu-item"
                                 data-tracking-id="share-button-twitter" title="Share on Twitter"
                            >
                                <a class="social-button-link" href="https://twitter.com/Cosmopolitan" target="_blank"
                                   data-social-key="twitter">
                                    <i class="fa fa-twitter"></i>


                                </a>
                            </div>
                            <div class="social-button social-button-pinterest footer-social-menu-item"
                                 data-tracking-id="share-button-pinterest" title="Share on Pinterest"
                            >

                                <a class="social-button-link" href="https://www.pinterest.com/Cosmopolitan/"
                                   target="_blank" data-pin-do="nothing">
                                    <i class="fa fa-pinterest-p"></i>


                                </a>
                            </div>

                        </div>


                        <ul class="footer-menu">
                            <li class="footer-menu-item nav-item" data-id="1"><a
                                    href="http://newsletters.cosmopolitan.com">Newsletter</a></li>
                            <li class="footer-menu-item nav-item" data-id="2"><a
                                    href="https://subscribe.hearstmags.com/subscribe/splits/cosmopolitan/cos_digital_foot_link">Digital
                                Editions</a></li>
                            <li class="footer-menu-item nav-item" data-id="3"><a href="/about/">About Us</a></li>
                            <li class="footer-menu-item nav-item" data-id="4"><a
                                    href="http://www.hearst.com/press-room/">Press Room</a></li>
                            <li class="footer-menu-item nav-item" data-id="5"><a href="/about/a1734/contact-us/">Contact
                                Us</a></li>
                            <li class="footer-menu-item nav-item" data-id="6"><a
                                    href="/lifestyle/a28544/community-guidelines/">Community Guidelines</a></li>
                            <li class="footer-menu-item nav-item" data-id="7"><a
                                    href="/career/a28541/advertise-online/">Advertise Online</a></li>
                            <li class="footer-menu-item nav-item" data-id="8"><a href="/career/a28543/about-our-ads/">About
                                Our Ads</a></li>
                            <li class="footer-menu-item nav-item" data-id="9"><a href="/lifestyle/g1701/cosmo-books/">Cosmo
                                Books</a></li>
                            <li class="footer-menu-item nav-item" data-id="10"><a href="/career/a3376/work-for-cosmo/">Work
                                For Cosmo</a></li>
                            <li class="footer-menu-item nav-item" data-id="11"><a href="/about/a3221/internships/">Become
                                A Cosmo Intern</a></li>
                            <li class="footer-menu-item nav-item" data-id="12"><a
                                    href="http://service.cosmopolitan.com">Customer Service</a></li>
                            <li class="footer-menu-item nav-item" data-id="13"><a
                                    href="https://subscribe.hearstmags.com/subscribe/splits/cosmopolitan/cos_sub_nav_link_footer">Subscribe</a>
                            </li>
                            <li class="footer-menu-item nav-item" data-id="14"><a
                                    href="http://subscribe.hearstmags.com/circulation/shared/index.html">Other Hearst
                                Subscriptions</a></li>
                            <li class="footer-menu-item nav-item" data-id="15"><a
                                    href="https://subscribe.hearstmags.com/subscribe/splits/cosmopolitan/cos_gift_nav_link_footer">Give
                                a Gift</a></li>
                            <li class="footer-menu-item nav-item" data-id="16"><a
                                    href="/sweepstakes/a28542/promotions/">Events &amp; Promotions</a></li>
                            <li class="footer-menu-item nav-item" data-id="17"><a
                                    href="https://subscribe.hearstmags.com/subscribe/splits/cosmopolitan/cos_giveaways_footer">Giveaways</a>
                            </li>
                            <li class="footer-menu-item nav-item" data-id="18"><a
                                    href="http://www.hearst.com/beinggreen/">Being Green</a></li>
                            <li class="footer-menu-item nav-item" data-id="19"><a href="/lifestyle/a3402/oba-policy/">Why
                                Did I Get This Ad?</a></li>
                            <li class="footer-menu-item nav-item" data-id="20"><a
                                    href="http://www.bestproducts.com/style/">BestProducts</a></li>
                        </ul>

                        <img data-src="/sites/cosmopolitan/assets/images/logos/network-logo.png"
                             class="lazyload lazyload-in-view footer-network-logo"
                             alt="Hearst Young Women&#039;s Network - A Part of Hearst Digital Media"
                        />

                        <span class="footer-network-tagline">A Part of Hearst Digital Media</span>

                        <span class="footer-affiliate-disclosure">
				Cosmopolitan participates in various affiliate marketing programs, which means Cosmopolitan gets paid commissions on purchases made through our links to retailer sites.
			</span>

                        <div class="footer-legal">
                            <small class="footer-copyright">&copy;2017 Hearst Communications, Inc. All Rights
                                Reserved.
                            </small>

                            <ul class="footer-legal-menu">
                                <li class="footer-legal-menu-item nav-item" data-id="1"><a
                                        href="/about/a1778/privacy-policy/">Privacy Policy</a></li>
                                <li class="footer-legal-menu-item nav-item" data-id="2"><a
                                        href="/about/a1778/privacy-policy/#california">Your California Privacy
                                    Policy</a></li>
                                <li class="footer-legal-menu-item nav-item" data-id="3"><a
                                        href="/about/a28685/terms-of-use/">Terms of Use</a></li>
                                <li class="footer-legal-menu-item nav-item" data-id="4"><a href="/sitemap/">Site Map</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </footer>
                <!-- / footers/main -->
                <script id="recirc-module-template" type="text/template">
                    <div class="recirculation-module" data-tracking-id="recirc-<%= data.feed.feed_type %>"
                         data-tracking-label="More From <%= data.feed.title %>">
                        <div class="recirculation-module-header">
                            More From

                            <a class="recirculation-module-feed-link" href="<%= data.feed.url %>"><%= data.feed.title
                                %></a>
                        </div>

                        <div class="recirculation-module-inner">
                            <% _.each( data.content, function( item ) { %>
                            <div class="simple-item recirculation-module-item">
                                <div class="recirculation-module-image aspect-ratio-2x1">
                                    <% if ( item.image ) { %>
                                    <a class="full-item-image item-image recirculation-image" href="<%= item.url %>">

                                        <img class="lazyload lazyload-in-view " data-src="<%= item.image.src %>"
                                        <% if ( typeof item.image.srcset !== "undefined" && item.image.srcset.length ) {
                                        %>
                                        data-srcset="<%= item.image.srcset.join(",") %>"
                                        <% } %>
                                        />


                                        <%
                                        var displayTypeTitle = item.displaytype._attributes.title;
                                        var contentTypeTitle = item.contenttype._attributes.title;

                                        var contentTypeIcon = {
                                        "Quizzes": "quiz",
                                        "Video": "play"
                                        }[ contentTypeTitle ];

                                        var displayTypeIcon = {
                                        "Gallery": "gallery"
                                        }[ displayTypeTitle ];

                                        var acceptedContentTypes = contentTypeTitle === "Quizzes" || contentTypeTitle
                                        === "Video";
                                        var acceptedDisplayTypes = displayTypeTitle === "Gallery";

                                        var showIcons = acceptedContentTypes || acceptedDisplayTypes;
                                        %>

                                        <% if ( showIcons ) { %>
                                        <div class="content-type-icon">
                                            <i class="icon icon-<% if ( contentTypeIcon ) { %><%= contentTypeIcon %><% } else { %><%= displayTypeIcon %><% } %>"></i>
                                        </div>
                                        <% } %>

                                    </a>
                                    <% } else { %>
                                    <a class="recirculation-content-indicator" href="<%= item.url %>">
                                        <% if ( item && item.hasOwnProperty( "displayType" ) ) { %>
                                        <%
                                        var iconClass = {
                                        "Gallery": "gallery",
                                        "Listicle": "list",
                                        "Long Form Article": "feature"
                                        }[ item.displayType ] || "article";
                                        %>
                                        <span class="content-indicator  icon icon-<%= iconClass %>"></span>
                                        <% } %>

                                    </a>
                                    <% } %>
                                </div>

                                <a class="item-title recirculation-module-item-title" href="<%= item.url %>"><%=
                                    item.title %></a>

                                <% if ( item.sponsored ) { %>

                                <%
                                var sponsorClass = {
                                "1": "no-logo",
                                "2": "sponsored-by",
                                "3": "brand-logo",
                                "4": "provided-by",
                                "5": "created-for",
                                "6": "custom-label"
                                }[ item.sponsorbrand.type ],
                                siteName = item.sitename,
                                customLabelLong = "item.sponsorbrand.custom_label_long",
                                customLabelShort = "item.sponsorbrand.custom_label_short";
                                %>

                                <% if ( sponsorClass != "no-logo" ) { %>
                                <div class="sponsor sponsor-inline simple-item-sponsor recirculation-sponsor <%= sponsorClass %>">
                                    <div class="sponsor-label">
                                        <% if ( sponsorClass === "brand-logo" ) { %>
                                        <span class="site-name"><%= siteName %></span>
                                        <span class="sponsor-logo-separator">+</span>
                                        <% } else if ( sponsorClass === "created-for" ) { %>
                                        <span class="created-for--short">
					Created For
				</span>

                                        <span class="created-for--long">
					Created By <%= siteName %> For
				</span>
                                        <% } else if ( sponsorClass === "custom-label" ) { %>
                                        <span class="custom-label--short">
					<%= customLabelShort %>
				</span>

                                        <span class="custom-label--long">
					<%= customLabelLong %>
				</span>
                                        <% } else { %>
                                        <% if ( sponsorClass === "sponsored-by" ) { %>
                                        Presented By
                                        <% } %>

                                        <% if ( sponsorClass === "provided-by" ) { %>
                                        Created By
                                        <% } %>
                                        <% } %>
                                    </div>
                                    <div class="sponsor-image">
                                        <%= item.sponsored._attributes.brand %>
                                    </div>
                                </div>
                                <% } %>

                                <% } %>
                            </div>
                            <% } ); %>
                        </div>
                    </div>
                </script>
                <script id="related-module-template" type="text/template">
                    <a class="related-content-link" href="<%= data.url %>">
                        <div class="embed-related-content" data-related-id="<%= data.id %>"
                             data-tracking-id="recirc-editorial" data-tracking-label="<%= data.title %>">
                            <div class="image-container aspect-ratio-2x1">
                                <% if ( data.image ) { %>

                                <img class="lazyload lazyload-in-view " data-src="<%= data.image.src %>"
                                <% if ( typeof data.image.srcset !== "undefined" && data.image.srcset.length ) { %>
                                data-srcset="<%= data.image.srcset.join(",") %>"
                                <% } %>
                                />

                                <% } else { %>
                                <% if ( item && item.hasOwnProperty( "displayType" ) ) { %>
                                <%
                                var iconClass = {
                                "Gallery": "gallery",
                                "Listicle": "list",
                                "Long Form Article": "feature"
                                }[ item.displayType ] || "article";
                                %>
                                <span class="content-indicator  icon icon-<%= iconClass %>"></span>
                                <% } %>

                                <% } %>
                            </div>
                            <div class="info-container">
                                <a class="item-title recirculation-module-item-title" href="<%= data.url %>"><%=
                                    data.title %></a>
                            </div>
                        </div>
                    </a>
                </script>
                <script id="content-testing-template" type="text/template">
                    <div class="ct-unit">
                        <div class="ct-unit-inner">
                            <div class="ct-unit-text-container">
                                <a class="ct-unit-heading" href="<%= body.variant_url %>">Read This Next</a>

                                <a class="ct-unit-title" href="<%= body.variant_url %>"><%= body.headline %></a>
                            </div>

                            <a class="ct-unit-image-container" href="<%= body.variant_url %>">

                                <img class="lazyload lazyload-in-view ct-unit-image"
                                     data-src="<%= body.image.selectedCrop %>"
                                <% if ( typeof srcset !== "undefined" && srcset.length ) { %>
                                data-srcset="<%= srcset.join(",") %>"
                                <% } %>
                                />

                            </a>
                        </div>
                    </div>
                </script>


                <div class="social-menu">
                    <div class="social-menu-inner">
                        <div class="social-button-group social-menu-button-group"
                             data-share-location="social-btns-fixed">
                            <div class="social-button social-button-facebook social-menu-button social-share-button"
                                 data-tracking-id="share-button-facebook" title="Share on Facebook"
                            >
                                <a class="social-button-link"
                                   href="//facebook.com/v2.3/dialog/feed?display=popup&amp;link=http%3A%2F%2Fwww.cosmopolitan.com%2Ffood-cocktails%2Fnews%2Fa38276%2F20-things-you-didnt-know-you-could-order-at-starbucks%2F&amp;redirect_uri=http%3A%2F%2Fwww.cosmopolitan.com%2Ffood-cocktails%2Fnews%2Fa38276%2F20-things-you-didnt-know-you-could-order-at-starbucks%2F&amp;name=26%20Starbucks%20Drinks%20You%20Had%20No%20Idea%20Actually%20Existed&amp;description=Its%20%22secret%22%20drink%20menu%20is%20more%20limitless%20and%20mind-blowing%20than%20you%20every%20imagined.&amp;picture=https%3A%2F%2Fhips.hearstapps.com%2Fhmg-prod.s3.amazonaws.com%2Fimages%2Fpin-starbucksexisted-1493760756.jpg%3Fcrop%3D1.00xw%3A0.167xh%3B0%2C0.126xh%26resize%3D1600%3A%2A&amp;app_id=162305873819997"
                                   target="_blank" data-social-key="facebook">
                                    <i class="fa fa-facebook"></i>

                                    <span class="social-button-label">Share</span>

                                </a>
                            </div>
                            <div class="social-button social-button-twitter social-menu-button social-share-button"
                                 data-tracking-id="share-button-twitter" title="Share on Twitter"
                            >
                                <a class="social-button-link"
                                   href="//www.twitter.com/share?url=http%3A%2F%2Fwww.cosmopolitan.com%2Ffood-cocktails%2Fnews%2Fa38276%2F20-things-you-didnt-know-you-could-order-at-starbucks%2F&amp;text=26%20Starbucks%20Drinks%20You%20Had%20No%20Idea%20Actually%20Existed&amp;via=Cosmopolitan"
                                   target="_blank" data-social-key="twitter">
                                    <i class="fa fa-twitter"></i>

                                    <span class="social-button-label">Tweet</span>

                                </a>
                            </div>
                            <div class="social-button social-button-email social-menu-button social-share-button"
                                 data-tracking-id="share-button-email" title="Email"
                            >
                                <a class="social-button-link"
                                   href="mailto:?body=http%3A%2F%2Fwww.cosmopolitan.com%2Ffood-cocktails%2Fnews%2Fa38276%2F20-things-you-didnt-know-you-could-order-at-starbucks%2F&amp;subject=26%20Starbucks%20Drinks%20You%20Had%20No%20Idea%20Actually%20Existed"
                                   target="_self" data-social-key="email">
                                    <span class="fa fa-envelope-o"></span>

                                    <span class="social-button-label">Email</span>

                                </a>
                            </div>

                        </div>

                    </div>
                </div>
                <script id="eoc-module-template" type="text/template">
                    <div class="end-of-content-module" data-tracking-id="recirc-end-of-content">
                        <div class="end-of-content-header">
                            Read Next
                        </div>
                        <div class="end-of-content-inner">
                            <% _.each( data, function( item ) { %>
                            <div class="simple-item end-of-content-simple-item" data-tracking-id="recirc-eoc">
                                <% if ( item.image ) { %>
                                <a class="simple-item-image item-image endofcontent-image" href="<%= item.url %>">

                                    <img class="" src="<%= item.image.src %>"
                                    <% if ( typeof item.image.srcset !== "undefined" && item.image.srcset.length ) { %>
                                    data-srcset="<%= item.image.srcset.join(",") %>"
                                    <% } %>
                                    />

                                </a>
                                <% } else { %>
                                <a class="recirculation-content-indicator" href="<%= item.url %>">
                                    <% if ( item && item.hasOwnProperty( "displayType" ) ) { %>
                                    <%
                                    var iconClass = {
                                    "Gallery": "gallery",
                                    "Listicle": "list",
                                    "Long Form Article": "feature"
                                    }[ item.displayType ] || "article";
                                    %>
                                    <span class="content-indicator  icon icon-<%= iconClass %>"></span>
                                    <% } %>

                                </a>
                                <% } %>
                                <a class="end-of-content-title item-title" href="<%= item.url %>"><%= item.title %></a>
                                <% if ( item.sponsor ) { %>

                                <%
                                var sponsorClass = {
                                "1": "no-logo",
                                "2": "sponsored-by",
                                "3": "brand-logo",
                                "4": "provided-by",
                                "5": "created-for",
                                "6": "custom-label"
                                }[ item.sponsor.type ],
                                siteName = "Cosmopolitan",
                                customLabelLong = null,
                                customLabelShort = null;
                                %>

                                <% if ( sponsorClass != "no-logo" ) { %>
                                <div class="sponsor sponsor-inline simple-item-sponsor recirculation-sponsor <%= sponsorClass %>">
                                    <div class="sponsor-label">
                                        <% if ( sponsorClass === "brand-logo" ) { %>
                                        <span class="site-name"><%= siteName %></span>
                                        <span class="sponsor-logo-separator">+</span>
                                        <% } else if ( sponsorClass === "created-for" ) { %>
                                        <span class="created-for--short">
					Created For
				</span>

                                        <span class="created-for--long">
					Created By <%= siteName %> For
				</span>
                                        <% } else if ( sponsorClass === "custom-label" ) { %>
                                        <span class="custom-label--short">
					<%= customLabelShort %>
				</span>

                                        <span class="custom-label--long">
					<%= customLabelLong %>
				</span>
                                        <% } else { %>
                                        <% if ( sponsorClass === "sponsored-by" ) { %>
                                        Presented By
                                        <% } %>

                                        <% if ( sponsorClass === "provided-by" ) { %>
                                        Created By
                                        <% } %>
                                        <% } %>
                                    </div>
                                    <div class="sponsor-image">
                                        <%= item.sponsor.title %>
                                    </div>
                                </div>
                                <% } %>

                                <% } %>
                            </div>
                            <% }); %>
                        </div>
                    </div>
                </script>

            </div>
            <script id="deferred-css-script-tag">(function (Modernizr) {
                var d = document,
                    ua = navigator.userAgent,
                    reMobile = /Mobile|iP(hone|od|ad)|Android|BlackBerry|IEMobile|Kindle|NetFront|Silk-Accelerated|(hpw|web)OS|Fennec|Minimo|Opera M(obi|ini)|Blazer|Dolfin|Dolphin|Skyfire|Zune/ig;

                if (Modernizr && Modernizr.addTest) {
                    Modernizr.addTest("mobile", function () {
                        return reMobile.test(ua) && Modernizr.mq("only screen and (min-width: 320px) and (max-width: 639px)");
                    });

                    Modernizr.addTest("tablet", function () {
                        return reMobile.test(ua) && !Modernizr.mobile;
                    });
                }

                d.addEventListener("DOMContentLoaded", function () {
                    var l, h = d.getElementsByTagName("head")[0],
                        f = ["/sites/cosmopolitan/assets/css/standard-article.css?cb=3.3.2"];

                    for (var i = 0, len = f.length; i < len; i++) {
                        l = d.createElement("link");
                        l.rel = "stylesheet";
                        l.href = Modernizr && Modernizr.mobile ? f[i].replace(".css", "-mobile.css") : f[i];

                        h.parentNode.insertBefore(l, h);
                    }
                });
            })(Modernizr);
            </script>
            <script id="require-js-script-tag"
                    src="/sites/cosmopolitan/assets/js/dist/app/viewcontrollers/Article.js?cb=3.3.2" async></script>
            <script type="text/javascript">
            window.SENTRY_DSN = "https://2db1fe908c734593b15029361071c2a4@sentry.io/109939";
            window.BABOU_URL = "http://babou.hdmtools.com/api/v2";
            window.VARIANT_PUB = "cosmopolitan_us";
            window.VIDEOPLAYER_URL = "https://player.hearst.io";
            window.CURRENT_SITE = {
                "id": "81bbdae2-81fb-4d95-b643-a0679795a2a4",
                "created_at": "2016-01-23T03:19:08.972000Z",
                "updated_at": "2017-05-10T13:11:54.564823Z",
                "domain": "cosmopolitan.com",
                "image_sitename": "cosmopolitan",
                "metadata": {
                    "links": {
                        "hostnames": {
                            "edit": {
                                "prod": "patty-cosmopolitan.prod.hearstapps.com",
                                "dev": "patty-cosmopolitan.feature.hearstapps.net",
                                "stage": "patty-cosmopolitan.stage.hearstapps.net"
                            },
                            "fre": {
                                "prod": "www.cosmopolitan.com",
                                "dev": "cosmopolitan.feature.hearstapps.net",
                                "stage": "cosmopolitan.stage.hearstapps.net"
                            }
                        }, "includeLocalePath": false
                    },
                    "burtAnalytics": "AMPA3EOLU38U",
                    "googleAnalyticsSiteAccount": "UA-3000283-1",
                    "copyright": "Hearst Communications, Inc. All Rights Reserved.",
                    "googleAnalyticsNetworkAccount": "UA-42946725-1",
                    "icxSiteId": "10049",
                    "siteAcronym": "COS",
                    "icxDomainId": "6841",
                    "dartZone": "/36117602/hdm-cosmopolitan/",
                    "rsid": "hmagglobal",
                    "comScoreId": "6035258",
                    "networkLogoPath": "@siteAssets/images/logos/network-logo.png",
                    "networkTagLine": "A Part of Hearst Digital Media",
                    "chartbeatId": "39276",
                    "adUnit": {"networkID": "36117602", "site": "hdm-cosmopolitan"},
                    "networkName": "Hearst Young Women's Network",
                    "top_touts": {
                        "7b12643c-61ee-4268-a0d0-a7a4ca7b6f96": {
                            "type": "content",
                            "id": "7b12643c-61ee-4268-a0d0-a7a4ca7b6f96",
                            "order": "1"
                        },
                        "05c44d2d-636d-4e43-a56d-bba43479d1b6": {
                            "type": "content",
                            "id": "05c44d2d-636d-4e43-a56d-bba43479d1b6",
                            "order": "2"
                        },
                        "17cf0839-abab-4c13-b2b2-cf2f8008ba5c": {
                            "type": "content",
                            "id": "17cf0839-abab-4c13-b2b2-cf2f8008ba5c",
                            "order": "0"
                        },
                        "2e6c9073-9246-4e8f-8022-4c5d87a38106": {
                            "type": "content",
                            "id": "2e6c9073-9246-4e8f-8022-4c5d87a38106",
                            "order": "3"
                        },
                        "5ea329c2-c886-4c84-86b8-79d195ea6b29": {
                            "type": "content",
                            "id": "5ea329c2-c886-4c84-86b8-79d195ea6b29",
                            "order": "4"
                        }
                    },
                    "ensightenDevScriptUrl": "//nexus.ensighten.com/hearst/mag-dev/Bootstrap.js",
                    "ensightenScriptUrl": "//nexus.ensighten.com/hearst/mag/Bootstrap.js",
                    "yieldmoId": "1615158659109993358",
                    "defaults": {"editorial_source": "Hearst Editorial", "source_site": "Cosmopolitan"},
                    "social": {
                        "networks": {
                            "instagram": {"socialUrl": "http://instagram.com/cosmopolitan"},
                            "pinterest": {
                                "suffix": " - Cosmopolitan.com",
                                "socialUrl": "https://www.pinterest.com/Cosmopolitan/"
                            },
                            "twitter": {"handle": "@Cosmopolitan", "socialUrl": "https://twitter.com/Cosmopolitan"},
                            "googleplus": {
                                "webmasterTools": "OgzSrVaVV7yFKzGAbRMcXSJRgdDAbANPEE4HCHyKkdM",
                                "socialUrl": "https://plus.google.com/u/0/111347932293989723742/posts"
                            },
                            "youtube": {"socialUrl": "http://www.youtube.com/cosmopolitan"},
                            "tumblr": {"socialUrl": "http://cosmopolitanmagazine.tumblr.com"},
                            "facebook": {
                                "appId": "162305873819997",
                                "socialUrl": "https://facebook.com/Cosmopolitan",
                                "iaAppId": "8358247707"
                            }
                        }
                    }
                },
                "site_prefix": "COS",
                "ad_tag": "https://pubads.g.doubleclick.net/gampad/ads?sz=1x4&iu=/36117602/hdm-gopherplayer/cosmopolitan&impl=s&gdfp_req=1&env=vp&output=vast&unviewed_position_start=1&url=[referrer_url]&description_url=[description_url]&correlator=[timestamp]",
                "ad_type": 1,
                "brand": {
                    "id": "901b88d0-a001-425c-90dd-2ab9a42017ce",
                    "created_at": "2016-01-23T03:19:08.963000Z",
                    "updated_at": "2016-05-31T17:58:28.964061Z",
                    "name": "Cosmopolitan",
                    "metadata": [],
                    "business_unit": "ad046b46-538b-42cb-aa54-c3d158875ed6"
                },
                "locale": {
                    "id": "ce9851fb-c3a3-4b8b-8069-1f3d37f87dd9",
                    "created_at": "2016-01-23T03:19:08.924000Z",
                    "updated_at": "2016-04-21T18:18:44.392818Z",
                    "name": "United States",
                    "language": "en",
                    "country": "US",
                    "url_path": "en"
                },
                "pools": [{
                    "id": "23c44f09-c5f0-4293-94a5-9543b3e45691",
                    "created_at": "2016-05-13T15:37:25.292772Z",
                    "updated_at": "2016-05-13T15:37:25.292792Z",
                    "name": "US Only",
                    "metadata": [],
                    "type": "49719708-6b4b-4580-b5d7-43c647909684",
                    "sites": ["7399c57a-aa06-4b9c-87ff-bb598c3203f1", "3bc17a33-7fcd-4d76-a03f-e63c30c341f6", "9e524293-b460-4bcd-b98e-9ba38b9dcc0e", "0ab1c860-336a-4b0b-bb94-dd080aea7a20", "cd4f2528-d52d-4312-ad85-ac9572b30eda", "1865b1fe-83de-4f1b-a9b0-226d957ae165", "115eff3b-95a0-4668-832c-9d02ea92500d", "aaf0f31b-756b-48fc-99fb-dc5085da9dc7", "887d06c0-fba5-43a4-969f-0ebff091e55f", "358b58f7-cfd6-41bf-9519-e09c8ee811df", "d4dbbc78-a13a-485a-aae7-ef6358d97415", "a4f9566a-1fd0-484c-b731-150b9bda9ffa", "0cb499a3-b6f3-4c40-99ca-5b16ef28bfcd", "5bd80293-fc82-4d28-83eb-c0c4184e42f2", "229d0812-d901-44db-87b0-24674345b9e5", "8342522f-11a7-4c85-8c15-51f36ee1d53f", "8b6b0f67-bcde-4d9d-86c6-dedff1abae12", "e4df0316-2a48-4277-8e20-2e971de5b4a6", "530bacd4-96b2-4cfe-a9a6-1fbd7c749e22", "3c406490-fb47-4a49-adc8-96958258f28d", "f30f2c6f-2363-4b03-b482-ae642b94f911", "81bbdae2-81fb-4d95-b643-a0679795a2a4", "8a208619-6e7d-4fab-9fa9-5cf45178bfcb"]
                }, {
                    "id": "9003b3d2-b17a-4cb6-91dc-ebfd74be33cc",
                    "created_at": "2016-05-13T15:35:34.375214Z",
                    "updated_at": "2016-05-13T15:35:34.375252Z",
                    "name": "OK for Syndication",
                    "metadata": [],
                    "type": "49719708-6b4b-4580-b5d7-43c647909684",
                    "sites": ["7399c57a-aa06-4b9c-87ff-bb598c3203f1", "3bc17a33-7fcd-4d76-a03f-e63c30c341f6", "9e524293-b460-4bcd-b98e-9ba38b9dcc0e", "53fd7fa5-d43c-401b-823b-b21cf6cddcd6", "0ab1c860-336a-4b0b-bb94-dd080aea7a20", "05c91d33-fc37-418e-bf52-cf5b8f74407c", "11450e94-9e7a-4e13-b53d-1c4e5f2ba9c4", "e5d981ad-90f9-48da-9b3e-d0d4cf6fa28a", "8c4412ae-225f-4ccc-8c63-d51d85fcb326", "0fbb7ac1-e4a0-4000-b247-8dcbab14b00f", "0b535744-06fe-433d-ae5e-aac90731f89a", "f64606a7-1720-4799-9bc0-664c4a93e214", "cd57fcde-b36f-429e-859f-4820e630259d", "5ceb5581-5708-43de-ad58-d2dbba312cf1", "d373c840-ece5-4ebc-a094-32ac96ffad6c", "4d3aa4d0-46c8-4eb8-8ca1-c69fc3103513", "5fe6dc72-5307-444b-84ce-fef3f12952f1", "cd4f2528-d52d-4312-ad85-ac9572b30eda", "1865b1fe-83de-4f1b-a9b0-226d957ae165", "115eff3b-95a0-4668-832c-9d02ea92500d", "aaf0f31b-756b-48fc-99fb-dc5085da9dc7", "887d06c0-fba5-43a4-969f-0ebff091e55f", "358b58f7-cfd6-41bf-9519-e09c8ee811df", "a4f9566a-1fd0-484c-b731-150b9bda9ffa", "0cb499a3-b6f3-4c40-99ca-5b16ef28bfcd", "5bd80293-fc82-4d28-83eb-c0c4184e42f2", "229d0812-d901-44db-87b0-24674345b9e5", "8342522f-11a7-4c85-8c15-51f36ee1d53f", "8b6b0f67-bcde-4d9d-86c6-dedff1abae12", "e4df0316-2a48-4277-8e20-2e971de5b4a6", "530bacd4-96b2-4cfe-a9a6-1fbd7c749e22", "3c406490-fb47-4a49-adc8-96958258f28d", "f30f2c6f-2363-4b03-b482-ae642b94f911", "81bbdae2-81fb-4d95-b643-a0679795a2a4", "8a208619-6e7d-4fab-9fa9-5cf45178bfcb"]
                }],
                "links": {
                    "hostnames": {
                        "edit": {
                            "prod": "patty-cosmopolitan.prod.hearstapps.com",
                            "dev": "patty-cosmopolitan.feature.hearstapps.net",
                            "stage": "patty-cosmopolitan.stage.hearstapps.net"
                        },
                        "fre": {
                            "prod": "www.cosmopolitan.com",
                            "dev": "cosmopolitan.feature.hearstapps.net",
                            "stage": "cosmopolitan.stage.hearstapps.net"
                        }
                    }, "includeLocalePath": false
                },
                "hostnames": {
                    "edit": {
                        "prod": "patty-cosmopolitan.prod.hearstapps.com",
                        "dev": "patty-cosmopolitan.feature.hearstapps.net",
                        "stage": "patty-cosmopolitan.stage.hearstapps.net"
                    },
                    "fre": {
                        "prod": "www.cosmopolitan.com",
                        "dev": "cosmopolitan.feature.hearstapps.net",
                        "stage": "cosmopolitan.stage.hearstapps.net"
                    }
                },
                "linkTemplates": [],
                "edit-hostnames": {
                    "prod": "patty-cosmopolitan.prod.hearstapps.com",
                    "dev": "patty-cosmopolitan.feature.hearstapps.net",
                    "stage": "patty-cosmopolitan.stage.hearstapps.net"
                },
                "fre-hostnames": {
                    "prod": "www.cosmopolitan.com",
                    "dev": "cosmopolitan.feature.hearstapps.net",
                    "stage": "cosmopolitan.stage.hearstapps.net"
                }
            };
            window.CURRENT_LOCALE = {
                "id": "ce9851fb-c3a3-4b8b-8069-1f3d37f87dd9",
                "created_at": "2016-01-23T03:19:08.924000Z",
                "updated_at": "2016-04-21T18:18:44.392818Z",
                "name": "United States",
                "language": "en",
                "country": "US",
                "url_path": "en"
            };
            (function (d) {
                var s = document.createElement("script");

                s.async = true;

                s.src = "//nexus.ensighten.com/hearst/mag/Bootstrap.js";

                if (d.cookie.indexOf("nsghtn=dev") > -1) {
                    s.src = "//nexus.ensighten.com/hearst/mag-dev/Bootstrap.js";
                }

                d.getElementsByTagName("head")[0].appendChild(s);
            })(document);
            </script>
            <script type="text/javascript">window.NREUM || (NREUM = {});
            NREUM.info = {
                "beacon": "bam.nr-data.net",
                "licenseKey": "5adcd0261b",
                "applicationID": "22237650",
                "transactionName": "MgRTbBdQXEIFAUNYCgtOck0WRV1cSwFYXxEAD0UXAV5HUwgH",
                "queueTime": 0,
                "applicationTime": 2276,
                "atts": "HkNQGl9KT0w=",
                "errorBeacon": "bam.nr-data.net",
                "agent": ""
            }</script></div></div>
    </div>
    <script>
        window.document.addEventListener('click', function(e) {
            if (e.target.tagName === 'A') {
                e.preventDefault();
            }
        });
    </script>
    <script>
        document.getElementById('video1').play();
        document.getElementById('video2').play();
        document.getElementById('video3').play();
    </script>
</body>
</html>
`;

export default multivHTML;
